
const mockDataUsers = [
  {
    firstName: "Aadolf",
    lastName: "Arvelo",
    email: "tenant001@sopia.io",
    companyLogo: "logo101.png",
    companyName: "Startup Aino",
    contactPerson: "Elma",
    contactPersonLastName: "Osmonsalo",
    phoneNumber: "0536559796",
    language: "Finnish, English",
    turnover: 2.0,
    employeeCount: 3,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1743465600000),
    size: 20,
    sizeMax: 30,
    rent: 975,
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["SHARED"],
    kitchen: ["NO"],
    lobbyService: "Lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Aapeli",
    lastName: "Ahtisaari",
    email: "tenant002@sopia.io",
    companyLogo: "logo102.png",
    companyName: "Startup Bambi",
    contactPerson: "Elmi",
    contactPersonLastName: "Reenpää",
    phoneNumber: "0554692361",
    language: "Finnish, English",
    turnover: 1.5,
    employeeCount: 3,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1746057600000),
    size: 39,
    sizeMax: 49,
    rent: 975,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 2.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["SHARED"],
    kitchen: ["NO"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Aapo",
    lastName: "Ahtovuo",
    email: "tenant003@sopia.io",
    companyLogo: "logo103.png",
    companyName: "Startup Celsius",
    contactPerson: "Elna",
    contactPersonLastName: "Reenkola",
    phoneNumber: "0596475461",
    language: "Finnish, English",
    turnover: 0.7,
    employeeCount: 3,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1746057600000),
    size: 29,
    sizeMax: 39,
    rent: 725,
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["SHARED"],
    kitchen: ["NO"],
    lobbyService: "Lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Aappo",
    lastName: "Äimä",
    email: "tenant004@sopia.io",
    companyLogo: "logo104.png",
    companyName: "Startup Domino",
    contactPerson: "Elsa",
    contactPersonLastName: "Sotavalta",
    phoneNumber: "0491395649",
    language: "Finnish, English",
    turnover: 1.7,
    employeeCount: 3,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1746057600000),
    size: 30,
    sizeMax: 40,
    rent: 1500,
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["SHARED"],
    kitchen: ["NO"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Aarne",
    lastName: "Artola",
    email: "tenant005@sopia.io",
    companyLogo: "logo105.png",
    companyName: "Startup Eino",
    contactPerson: "Else",
    contactPersonLastName: "Hallsten",
    phoneNumber: "0496831535",
    language: "Finnish, English, Swedish",
    turnover: 1.8,
    employeeCount: 3,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1746057600000),
    size: 45,
    sizeMax: 55,
    rent: 1500,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 3.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["SHARED"],
    kitchen: ["NO"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Aarni",
    lastName: "Alaja",
    email: "tenant006@sopia.io",
    companyLogo: "logo106.png",
    companyName: "Startup Faarao",
    contactPerson: "Elsi",
    contactPersonLastName: "Harberg",
    phoneNumber: "0573288515",
    language: "Finnish, English",
    turnover: 1.9,
    employeeCount: 3,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1746057600000),
    size: 20,
    sizeMax: 30,
    rent: 1500,
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["SHARED"],
    kitchen: ["NO"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Aarno",
    lastName: "Arohonka",
    email: "tenant007@sopia.io",
    companyLogo: "logo107.png",
    companyName: "Startup Gabriel",
    contactPerson: "Elvi",
    contactPersonLastName: "Heerman",
    phoneNumber: "0532563649",
    language: "Finnish, English",
    turnover: 2.0,
    employeeCount: 3,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1746057600000),
    size: 25,
    sizeMax: 35,
    rent: 1500,
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["SHARED"],
    kitchen: ["NO"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Aaro",
    lastName: "Arajärvi",
    email: "tenant008@sopia.io",
    companyLogo: "logo108.png",
    companyName: "Startup Heino",
    contactPerson: "Elviira",
    contactPersonLastName: "Heikel",
    phoneNumber: "0480189560",
    language: "Finnish, English",
    turnover: 2.1,
    employeeCount: 3,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1746057600000),
    size: 41,
    sizeMax: 51,
    rent: 1500,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 3.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["NO"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Aaron",
    lastName: "Almi",
    email: "tenant009@sopia.io",
    companyLogo: "logo109.png",
    companyName: "Startup Into",
    contactPerson: "Emilia",
    contactPersonLastName: "Helander",
    phoneNumber: "0426566108",
    language: "Finnish, English, Swedish",
    turnover: 2.2,
    employeeCount: 3,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1746057600000),
    size: 24,
    sizeMax: 34,
    rent: 1500,
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["NO"],
    lobbyService: "Lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Aarre",
    lastName: "Tuomas-Kettunen",
    email: "tenant010@sopia.io",
    companyLogo: "logo110.png",
    companyName: "Startup Jano",
    contactPerson: "Emma",
    contactPersonLastName: "Helander",
    phoneNumber: "0470006216",
    language: "Finnish, English",
    turnover: 2.3,
    employeeCount: 3,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1746057600000),
    size: 20,
    sizeMax: 30,
    rent: 1500,
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["NO"],
    lobbyService: "Lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Good",
    view: "No view",
    deposit: 0,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Aarto",
    lastName: "Ahjopalo",
    email: "tenant011@sopia.io",
    companyLogo: "logo111.png",
    companyName: "Startup K",
    contactPerson: "Emmi",
    contactPersonLastName: "Helenius",
    phoneNumber: "0463863164",
    language: "Finnish, English, Swedish",
    turnover: 2.4,
    employeeCount: 3,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1746057600000),
    size: 24,
    sizeMax: 34,
    rent: 1500,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 2.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["NO"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Aatami",
    lastName: "Ypyä",
    email: "tenant012@sopia.io",
    companyLogo: "logo112.png",
    companyName: "Growt company A",
    contactPerson: "Enna",
    contactPersonLastName: "Helenius",
    phoneNumber: "0559755036",
    language: "Finnish, English",
    turnover: 2.5,
    employeeCount: 3,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1746057600000),
    size: 53,
    sizeMax: 63,
    rent: 1325,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 3.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["NO"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Aatos",
    lastName: "Asanti",
    email: "tenant013@sopia.io",
    companyLogo: "logo113.png",
    companyName: "Growt company B",
    contactPerson: "Enni",
    contactPersonLastName: "Helenius",
    phoneNumber: "0520042882",
    language: "Finnish, English",
    turnover: 150.0,
    employeeCount: 6,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1746057600000),
    size: 85,
    sizeMax: 95,
    rent: 4000,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 3.0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Aatto",
    lastName: "Ahmavaara",
    email: "tenant014@sopia.io",
    companyLogo: "logo114.png",
    companyName: "Artist",
    contactPerson: "Erja",
    contactPersonLastName: "Helenius",
    phoneNumber: "0480606161",
    language: "Finnish, English, Swedish",
    turnover: 2.7,
    employeeCount: 2,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1746057600000),
    size: 18,
    sizeMax: 28,
    rent: 1075,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 2.0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Aatu",
    lastName: "Ailio",
    email: "tenant015@sopia.io",
    companyLogo: "logo115.png",
    companyName: "Medro Oy",
    contactPerson: "Essi",
    contactPersonLastName: "Helenius",
    phoneNumber: "0447091951",
    language: "Finnish, English",
    turnover: 2.8,
    employeeCount: 4,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1746057600000),
    size: 51,
    sizeMax: 61,
    rent: 1275,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 3.0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Ahti",
    lastName: "Visapää",
    email: "tenant016@sopia.io",
    companyLogo: "logo116.png",
    companyName: "Paavali Oy",
    contactPerson: "Ester",
    contactPersonLastName: "Helenius",
    phoneNumber: "0469594846",
    language: "Finnish, English",
    turnover: 2.9,
    employeeCount: 1,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1746057600000),
    size: 17,
    sizeMax: 27,
    rent: 650,
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 0,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Ahto",
    lastName: "Wuorenheimo",
    email: "tenant017@sopia.io",
    companyLogo: "logo117.png",
    companyName: "Sepät Oy",
    contactPerson: "Esteri",
    contactPersonLastName: "Helin",
    phoneNumber: "0548296630",
    language: "Finnish, Swedish",
    turnover: 80.0,
    employeeCount: 5,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [4],
    whenAvailable: new Date(1746057600000),
    size: 81,
    sizeMax: 91,
    rent: 2025,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 3.0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Ahvo",
    lastName: "Wuorenrinne",
    email: "tenant018@sopia.io",
    companyLogo: "logo118.png",
    companyName: "Pinja Oy",
    contactPerson: "Eveliina",
    contactPersonLastName: "Hellberg",
    phoneNumber: "0489825781",
    language: "Finnish, English",
    turnover: 3.1,
    employeeCount: 4,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1746057600000),
    size: 36,
    sizeMax: 46,
    rent: 900,
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Aimo",
    lastName: "Kalliala",
    email: "tenant019@sopia.io",
    companyLogo: "logo119.png",
    companyName: "Kettumaa Oy",
    contactPerson: "Hanna",
    contactPersonLastName: "Hellman",
    phoneNumber: "0484267267",
    language: "Finnish, English",
    turnover: 3.2,
    employeeCount: 4,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1746057600000),
    size: 29,
    sizeMax: 39,
    rent: 725,
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: false,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Aki",
    lastName: "Vuorenjuuri",
    email: "tenant020@sopia.io",
    companyLogo: "logo120.png",
    companyName: "Kuvataide Oy",
    contactPerson: "Hanne",
    contactPersonLastName: "Hellsten",
    phoneNumber: "0541670035",
    language: "Finnish, Swedish",
    turnover: 3.3,
    employeeCount: 4,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1746057600000),
    size: 15,
    sizeMax: 25,
    rent: 750,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 4.0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: false,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Akseli",
    lastName: "Vanni",
    email: "tenant021@sopia.io",
    companyLogo: "logo121.png",
    companyName: "Paletti Oy",
    contactPerson: "Hannele",
    contactPersonLastName: "Herckman",
    phoneNumber: "0584733493",
    language: "Finnish, English",
    turnover: 77.0,
    employeeCount: 4,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1748736000000),
    size: 66,
    sizeMax: 76,
    rent: 1650,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 3.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Aku",
    lastName: "Visanti",
    email: "tenant022@sopia.io",
    companyLogo: "logo122.png",
    companyName: "Kalevin Tmi",
    contactPerson: "Heidi",
    contactPersonLastName: "Hidén",
    phoneNumber: "0562625014",
    language: "Finnish, English",
    turnover: 3.5,
    employeeCount: 4,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1748736000000),
    size: 30,
    sizeMax: 40,
    rent: 750,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 4.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Albert",
    lastName: "Rantasalo",
    email: "tenant023@sopia.io",
    companyLogo: "logo123.png",
    companyName: "Kasvuyhtiö Group",
    contactPerson: "Heini",
    contactPersonLastName: "Hildén",
    phoneNumber: "0433697611",
    language: "Finnish, Swedish",
    turnover: 3.6,
    employeeCount: 6,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1748736000000),
    size: 84,
    sizeMax: 94,
    rent: 2100,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 3.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Ale",
    lastName: "Wuorimaa\/Vuorimaa",
    email: "tenant024@sopia.io",
    companyLogo: "logo124.png",
    companyName: "Pensseli Tmi",
    contactPerson: "Helena",
    contactPersonLastName: "Hildén",
    phoneNumber: "0425261860",
    language: "Finnish, Swedish",
    turnover: 3.7,
    employeeCount: 4,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1748736000000),
    size: 45,
    sizeMax: 55,
    rent: 1125,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 4.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Aleksanteri",
    lastName: "Kilpi",
    email: "tenant025@sopia.io",
    companyLogo: "logo125.png",
    companyName: "Rock Tmi",
    contactPerson: "Helga",
    contactPersonLastName: "Hildén",
    phoneNumber: "0537494342",
    language: "Finnish, English",
    turnover: 3.8,
    employeeCount: 4,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1748736000000),
    size: 20,
    sizeMax: 30,
    rent: 600,
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 0,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Aleksi",
    lastName: "Jalas",
    email: "tenant026@sopia.io",
    companyLogo: "logo126.png",
    companyName: "Filmi Tmi",
    contactPerson: "Heli",
    contactPersonLastName: "Hoffrén",
    phoneNumber: "0552190202",
    language: "Finnish, English",
    turnover: 3.9,
    employeeCount: 4,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1748736000000),
    size: 33,
    sizeMax: 43,
    rent: 825,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 3.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Aleksis",
    lastName: "Kaira",
    email: "tenant027@sopia.io",
    companyLogo: "logo127.png",
    companyName: "Mitta Tmi",
    contactPerson: "Helinä",
    contactPersonLastName: "Hoffrén",
    phoneNumber: "0424616491",
    language: "Finnish, English, Swedish",
    turnover: 4.0,
    employeeCount: 4,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1748736000000),
    size: 44,
    sizeMax: 54,
    rent: 1100,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 3.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: false,
  },
  {
    firstName: "Alfred",
    lastName: "Poijärvi",
    email: "tenant028@sopia.io",
    companyLogo: "logo128.png",
    companyName: "Putket Oy",
    contactPerson: "Heljä",
    contactPersonLastName: "Hohenthal",
    phoneNumber: "0503994629",
    language: "Finnish, Swedish",
    turnover: 4.1,
    employeeCount: 5,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1748736000000),
    size: 49,
    sizeMax: 60,
    rent: 1225,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 3.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Ali",
    lastName: "Linnala",
    email: "tenant029@sopia.io",
    companyLogo: "logo129.png",
    companyName: "Sähköä Oy",
    contactPerson: "Helka",
    contactPersonLastName: "Holmberg",
    phoneNumber: "0572164882",
    language: "Finnish, English",
    turnover: 4.2,
    employeeCount: 4,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1748736000000),
    size: 27,
    sizeMax: 35,
    rent: 675,
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: false,
  },
  {
    firstName: "Allan",
    lastName: "Paloheimo",
    email: "tenant030@sopia.io",
    companyLogo: "logo130.png",
    companyName: "Leffa Oy",
    contactPerson: "Helle",
    contactPersonLastName: "Holmström",
    phoneNumber: "0529425770",
    language: "Finnish, English",
    turnover: 4.3,
    employeeCount: 4,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1748736000000),
    size: 29,
    sizeMax: 45,
    rent: 725,
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: false,
  },
  {
    firstName: "Alpi",
    lastName: "Palosuo",
    email: "tenant031@sopia.io",
    companyLogo: "logo131.png",
    companyName: "Plug Finland Oy",
    contactPerson: "Hellevi",
    contactPersonLastName: "Hultman",
    phoneNumber: "0494803337",
    language: "Finnish, English",
    turnover: 50.0,
    employeeCount: 10,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [4],
    whenAvailable: new Date(1748736000000),
    size: 110,
    sizeMax: 150,
    rent: 2750,
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Alpo",
    lastName: "Tulikoura",
    email: "tenant032@sopia.io",
    companyLogo: "logo132.png",
    companyName: "Sadut Oy",
    contactPerson: "Helli",
    contactPersonLastName: "Hällberg\/Hälleberg",
    phoneNumber: "0491660413",
    language: "Finnish, English",
    turnover: 4.5,
    employeeCount: 4,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1748736000000),
    size: 33,
    sizeMax: 43,
    rent: 825,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 3.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: false,
  },
  {
    firstName: "Altti",
    lastName: "Honka",
    email: "tenant033@sopia.io",
    companyLogo: "logo133.png",
    companyName: "Kirjamaa Oy",
    contactPerson: "Hellin",
    contactPersonLastName: "Hällström",
    phoneNumber: "0541769543",
    language: "Finnish, English",
    turnover: 4.6,
    employeeCount: 4,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1748736000000),
    size: 31,
    sizeMax: 41,
    rent: 775,
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0.0,
    furnished: "Furnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: false,
  },
  {
    firstName: "Alvar",
    lastName: "Aho",
    email: "tenant034@sopia.io",
    companyLogo: "logo134.png",
    companyName: "IIDOO",
    contactPerson: "Hellä",
    contactPersonLastName: "Hällström, af Hällström",
    phoneNumber: "0501517695",
    language: "Finnish, English",
    turnover: 68.0,
    employeeCount: 13,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [5],
    whenAvailable: new Date(1748736000000),
    size: 163,
    sizeMax: 173,
    rent: 4075,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 13.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Alvi",
    lastName: "Palo",
    email: "tenant035@sopia.io",
    companyLogo: "logo135.png",
    companyName: "Konttori Oy",
    contactPerson: "Helmi",
    contactPersonLastName: "Hällström\/Hellström",
    phoneNumber: "0569433947",
    language: "Finnish, English, Swedish",
    turnover: 4.8,
    employeeCount: 4,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1748736000000),
    size: 27,
    sizeMax: 37,
    rent: 675,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 3.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: false,
  },
  {
    firstName: "Ano",
    lastName: "Välikangas\/Wälikangas",
    email: "tenant036@sopia.io",
    companyLogo: "logo136.png",
    companyName: "Konttorirotat Oy",
    contactPerson: "Helvi",
    contactPersonLastName: "Hästesko",
    phoneNumber: "0475663329",
    language: "Finnish, English",
    turnover: 38.0,
    employeeCount: 5,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1748736000000),
    size: 78,
    sizeMax: 88,
    rent: 1950,
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Anselmi",
    lastName: "Alhava",
    email: "tenant037@sopia.io",
    companyLogo: "logo137.png",
    companyName: "Automaa Oy",
    contactPerson: "Hely",
    contactPersonLastName: "Högman",
    phoneNumber: "0421872034",
    language: "Finnish, English",
    turnover: 5.0,
    employeeCount: 5,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1748736000000),
    size: 56,
    sizeMax: 66,
    rent: 1400,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 2.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Anssi",
    lastName: "Puro",
    email: "tenant038@sopia.io",
    companyLogo: "logo138.png",
    companyName: "Auton varaosa Oy",
    contactPerson: "Henna",
    contactPersonLastName: "Ingman",
    phoneNumber: "0529029297",
    language: "Finnish, Swedish",
    turnover: 5.1,
    employeeCount: 4,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1748736000000),
    size: 27,
    sizeMax: 37,
    rent: 675,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 3.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Excellent",
    view: "View",
    deposit: 0,
    nearGreenArea: "Yes",
    nearLunch: "No",
    isLandlord: false,
  },
  {
    firstName: "Antero",
    lastName: "Puroma",
    email: "tenant039@sopia.io",
    companyLogo: "logo139.png",
    companyName: "Muotia Oy",
    contactPerson: "Henni",
    contactPersonLastName: "Jakobsson",
    phoneNumber: "0585284909",
    language: "Finnish, English",
    turnover: 5.2,
    employeeCount: 2,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1748736000000),
    size: 26,
    sizeMax: 36,
    rent: 700,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 2.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: false,
  },
  {
    firstName: "Anton",
    lastName: "Kalela",
    email: "tenant040@sopia.io",
    companyLogo: "logo140.png",
    companyName: "Lenny Tmi",
    contactPerson: "Henriikka",
    contactPersonLastName: "Jankeloff",
    phoneNumber: "0563012822",
    language: "Finnish, English",
    turnover: 5.3,
    employeeCount: 2,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1748736000000),
    size: 43,
    sizeMax: 53,
    rent: 1075,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 2.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "No",
    isLandlord: false,
  },
  {
    firstName: "Antti",
    lastName: "Kannisto",
    email: "tenant041@sopia.io",
    companyLogo: "logo141.png",
    companyName: "Taito Oy",
    contactPerson: "Hertta",
    contactPersonLastName: "Jansson",
    phoneNumber: "0576665667",
    language: "Finnish, English",
    turnover: 5.4,
    employeeCount: 2,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1748736000000),
    size: 46,
    sizeMax: 56,
    rent: 1150,
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Antto",
    lastName: "Kannila",
    email: "tenant042@sopia.io",
    companyLogo: "logo142.png",
    companyName: "Taitto Oy",
    contactPerson: "Heta",
    contactPersonLastName: "Jernberg",
    phoneNumber: "0439133714",
    language: "Finnish, English",
    turnover: 40.0,
    employeeCount: 6,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1748736000000),
    size: 78,
    sizeMax: 88,
    rent: 1950,
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Anttoni",
    lastName: "Linkola",
    email: "tenant043@sopia.io",
    companyLogo: "logo143.png",
    companyName: "Runo Oy",
    contactPerson: "Hilda",
    contactPersonLastName: "Jernberg",
    phoneNumber: "0584678186",
    language: "Finnish, English",
    turnover: 5.6,
    employeeCount: 2,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1748736000000),
    size: 44,
    sizeMax: 54,
    rent: 1100,
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Arhippa",
    lastName: "Ylänne",
    email: "tenant044@sopia.io",
    companyLogo: "logo144.png",
    companyName: "Runoelma Oy",
    contactPerson: "Hilja",
    contactPersonLastName: "Jernström",
    phoneNumber: "0568684096",
    language: "Finnish, English",
    turnover: 6.0,
    employeeCount: 2,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1751328000000),
    size: 30,
    sizeMax: 40,
    rent: 775,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 2.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Aili",
    lastName: "Kuusisto",
    email: "tenant045@sopia.io",
    companyLogo: "logo145.png",
    companyName: "Sävelmä Oy",
    contactPerson: "Hilkka",
    contactPersonLastName: "Järnström",
    phoneNumber: "0588654221",
    language: "Finnish, English",
    turnover: 7.0,
    employeeCount: 3,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1751328000000),
    size: 51,
    sizeMax: 61,
    rent: 1275,
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Aina",
    lastName: "Rantakari",
    email: "tenant046@sopia.io",
    companyLogo: "logo146.png",
    companyName: "Arkisto Oy",
    contactPerson: "Hilla",
    contactPersonLastName: "Johansson",
    phoneNumber: "0496529943",
    language: "Finnish, English",
    turnover: 8.0,
    employeeCount: 2,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1751328000000),
    size: 24,
    sizeMax: 34,
    rent: 600,
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: false,
    propertyCondition: "Excellent",
    view: "View",
    deposit: 0,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Aini",
    lastName: "Pinomaa",
    email: "tenant047@sopia.io",
    companyLogo: "logo147.png",
    companyName: "Lupaavat Arkkitehdit Oy",
    contactPerson: "Hille",
    contactPersonLastName: "Johansson",
    phoneNumber: "0458273472",
    language: "Finnish, English",
    turnover: 9.0,
    employeeCount: 5,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1751328000000),
    size: 37,
    sizeMax: 47,
    rent: 925,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 2.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Excellent",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Ainikki",
    lastName: "Paasilinna",
    email: "tenant048@sopia.io",
    companyLogo: "logo148.png",
    companyName: "Uneliaat taiteilijat Oy",
    contactPerson: "Hillevi",
    contactPersonLastName: "Johansson",
    phoneNumber: "0515324012",
    language: "Finnish, English",
    turnover: 10.0,
    employeeCount: 4,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1751328000000),
    size: 21,
    sizeMax: 31,
    rent: 525,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 2.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: false,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Aino",
    lastName: "Pihkala",
    email: "tenant049@sopia.io",
    companyLogo: "logo149.png",
    companyName: "Kallen Kaupat Oy",
    contactPerson: "Hilma",
    contactPersonLastName: "Johansson",
    phoneNumber: "0435446378",
    language: "Finnish, Swedish",
    turnover: 11.0,
    employeeCount: 12,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1751328000000),
    size: 95,
    sizeMax: 105,
    rent: 2375,
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Aira",
    lastName: "Halsti",
    email: "tenant050@sopia.io",
    companyLogo: "logo150.png",
    companyName: "Kynttilätalo Oy",
    contactPerson: "Hilppa",
    contactPersonLastName: "Johnsson",
    phoneNumber: "0460573176",
    language: "Finnish, English",
    turnover: 200.0,
    employeeCount: 10,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [5],
    whenAvailable: new Date(1751328000000),
    size: 150,
    sizeMax: 160,
    rent: 3925,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 10.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Airi",
    lastName: "Kallia",
    email: "tenant051@sopia.io",
    companyLogo: "logo151.png",
    companyName: "Ohjelmoijat Oy",
    contactPerson: "Iida",
    contactPersonLastName: "Kulomäki",
    phoneNumber: "0509715531",
    language: "Finnish, English, Swedish",
    turnover: 13.0,
    employeeCount: 3,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1751328000000),
    size: 40,
    sizeMax: 50,
    rent: 1000,
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Aleksandra",
    lastName: "Haarla",
    email: "tenant052@sopia.io",
    companyLogo: "logo152.png",
    companyName: "Softaa Oy",
    contactPerson: "Iina",
    contactPersonLastName: "Kataja",
    phoneNumber: "0461394512",
    language: "Finnish, English",
    turnover: 14.0,
    employeeCount: 3,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1751328000000),
    size: 25,
    sizeMax: 35,
    rent: 600,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 2.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Aliisa",
    lastName: "Harva",
    email: "tenant053@sopia.io",
    companyLogo: "logo153.png",
    companyName: "Koodia Oy",
    contactPerson: "Iines",
    contactPersonLastName: "Kurki-Suonio",
    phoneNumber: "0410024433",
    language: "Finnish, English",
    turnover: 15.0,
    employeeCount: 4,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1751328000000),
    size: 20,
    sizeMax: 30,
    rent: 500,
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 0,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Alina",
    lastName: "Heikinheimo",
    email: "tenant054@sopia.io",
    companyLogo: "logo154.png",
    companyName: "Sirken Salonki",
    contactPerson: "Iiris",
    contactPersonLastName: "Kalha",
    phoneNumber: "0402524659",
    language: "Finnish, English",
    turnover: 16.0,
    employeeCount: 1,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1751328000000),
    size: 26,
    sizeMax: 36,
    rent: 650,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 1.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Alisa",
    lastName: "Päivänsalo",
    email: "tenant055@sopia.io",
    companyLogo: "logo155.png",
    companyName: "Code Oy",
    contactPerson: "Jaakkima",
    contactPersonLastName: "Kulo",
    phoneNumber: "0560273255",
    language: "Finnish, English",
    turnover: 120.0,
    employeeCount: 6,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1751328000000),
    size: 82,
    sizeMax: 102,
    rent: 2050,
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Alli",
    lastName: "Helanen",
    email: "tenant056@sopia.io",
    companyLogo: "logo156.png",
    companyName: "Software 4U",
    contactPerson: "Jaakko",
    contactPersonLastName: "Lehto",
    phoneNumber: "0511976246",
    language: "Finnish, English",
    turnover: 18.0,
    employeeCount: 5,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1751328000000),
    size: 45,
    sizeMax: 65,
    rent: 1125,
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 0,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Alma",
    lastName: "Hattara",
    email: "tenant057@sopia.io",
    companyLogo: "logo157.png",
    companyName: "Hoiva Oy",
    contactPerson: "Jaakob",
    contactPersonLastName: "Lahdensuo",
    phoneNumber: "0406326785",
    language: "Finnish, English",
    turnover: 19.0,
    employeeCount: 1,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1751328000000),
    size: 25,
    sizeMax: 45,
    rent: 625,
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Amalia",
    lastName: "Helismaa",
    email: "tenant058@sopia.io",
    companyLogo: "logo158.png",
    companyName: "Annan Tili",
    contactPerson: "Jaakoppi",
    contactPersonLastName: "Hirvensalo",
    phoneNumber: "0548673192",
    language: "Finnish, English",
    turnover: 20.0,
    employeeCount: 1,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1751328000000),
    size: 20,
    sizeMax: 40,
    rent: 550,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 1.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Amanda",
    lastName: "Heljas",
    email: "tenant059@sopia.io",
    companyLogo: "logo159.png",
    companyName: "Konsultit Oy",
    contactPerson: "Jalmari",
    contactPersonLastName: "Kalima",
    phoneNumber: "0425296591",
    language: "Finnish, English",
    turnover: 21.0,
    employeeCount: 1,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1751328000000),
    size: 40,
    sizeMax: 60,
    rent: 1000,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 1.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Anelma",
    lastName: "Helo",
    email: "tenant060@sopia.io",
    companyLogo: "logo160.png",
    companyName: "Unelma-asunto Oy",
    contactPerson: "Jalo",
    contactPersonLastName: "Leikola",
    phoneNumber: "0550743489",
    language: "Finnish, English",
    turnover: 22.0,
    employeeCount: 1,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1751328000000),
    size: 32,
    sizeMax: 52,
    rent: 800,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 1.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Anette",
    lastName: "Rahola",
    email: "tenant061@sopia.io",
    companyLogo: "logo161.png",
    companyName: "Hesan Paras Koti Oy",
    contactPerson: "Jami",
    contactPersonLastName: "Listo",
    phoneNumber: "0582091006",
    language: "Finnish, English",
    turnover: 23.0,
    employeeCount: 1,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1751328000000),
    size: 43,
    sizeMax: 63,
    rent: 1075,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 1.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Anita",
    lastName: "Waltari",
    email: "tenant062@sopia.io",
    companyLogo: "logo162.png",
    companyName: "Laatuvalmennus Oy",
    contactPerson: "Jani",
    contactPersonLastName: "Niini",
    phoneNumber: "0449848584",
    language: "Finnish, English",
    turnover: 24.0,
    employeeCount: 2,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1751328000000),
    size: 26,
    sizeMax: 46,
    rent: 650,
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Anitta",
    lastName: "Heliövaara",
    email: "tenant063@sopia.io",
    companyLogo: "logo163.png",
    companyName: "Ykköskodit Oy",
    contactPerson: "Janne",
    contactPersonLastName: "Hiekka",
    phoneNumber: "0578442048",
    language: "Finnish, English",
    turnover: 25.0,
    employeeCount: 2,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1752537600000),
    size: 23,
    sizeMax: 43,
    rent: 575,
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: false,
  },
  {
    firstName: "Anja",
    lastName: "Harvila",
    email: "tenant064@sopia.io",
    companyLogo: "logo164.png",
    companyName: "Ykköspalvelu Oy",
    contactPerson: "Jari",
    contactPersonLastName: "Leppälä",
    phoneNumber: "0571463517",
    language: "Finnish, English",
    turnover: 26.0,
    employeeCount: 4,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1752537600000),
    size: 51,
    sizeMax: 71,
    rent: 1275,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 1.0,
    furnished: "Furnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Anna",
    lastName: "Holma",
    email: "tenant065@sopia.io",
    companyLogo: "logo165.png",
    companyName: "Hattaramaa Oy",
    contactPerson: "Jarkko",
    contactPersonLastName: "Koskelo",
    phoneNumber: "0517251196",
    language: "Finnish, English, Swedish",
    turnover: 27.0,
    employeeCount: 3,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1752537600000),
    size: 38,
    sizeMax: 58,
    rent: 950,
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: false,
  },
  {
    firstName: "Anne",
    lastName: "Paasikivi",
    email: "tenant066@sopia.io",
    companyLogo: "logo166.png",
    companyName: "Metsämaa Oy",
    contactPerson: "Jarmo",
    contactPersonLastName: "Apajalahti",
    phoneNumber: "0412692570",
    language: "Finnish, Swedish",
    turnover: 28.0,
    employeeCount: 4,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1752537600000),
    size: 36,
    sizeMax: 56,
    rent: 900,
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Anneli",
    lastName: "Saarenpää",
    email: "tenant067@sopia.io",
    companyLogo: "logo167.png",
    companyName: "Peltomaa Oy",
    contactPerson: "Jarno",
    contactPersonLastName: "Linko",
    phoneNumber: "0443978293",
    language: "Finnish, Swedish",
    turnover: 29.0,
    employeeCount: 5,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1752537600000),
    size: 42,
    sizeMax: 70,
    rent: 1050,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 3.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Anni",
    lastName: "Hiitonen",
    email: "tenant068@sopia.io",
    companyLogo: "logo168.png",
    companyName: "Koivunen & co",
    contactPerson: "Jasper",
    contactPersonLastName: "Liro",
    phoneNumber: "0487881634",
    language: "Finnish, English",
    turnover: 30.0,
    employeeCount: 4,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1759276800000),
    size: 25,
    sizeMax: 45,
    rent: 625,
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Anniina",
    lastName: "Kaira",
    email: "tenant069@sopia.io",
    companyLogo: "logo169.png",
    companyName: "Lahtela & Lahtela",
    contactPerson: "Jere",
    contactPersonLastName: "Loimaranta",
    phoneNumber: "0562372521",
    language: "Finnish, English",
    turnover: 31.0,
    employeeCount: 3,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1759276800000),
    size: 28,
    sizeMax: 40,
    rent: 700,
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0.0,
    furnished: "Furnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Annika",
    lastName: "Osara",
    email: "tenant070@sopia.io",
    companyLogo: "logo170.png",
    companyName: "Peace Man Oy",
    contactPerson: "Jeremias",
    contactPersonLastName: "Merikoski",
    phoneNumber: "0572796600",
    language: "Finnish, English",
    turnover: 32.0,
    employeeCount: 6,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1759276800000),
    size: 58,
    sizeMax: 78,
    rent: 1450,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 2.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Annikki",
    lastName: "Palojärvi",
    email: "tenant071@sopia.io",
    companyLogo: "logo171.png",
    companyName: "Pilvi & Linnu",
    contactPerson: "Jesper",
    contactPersonLastName: "Niinistö",
    phoneNumber: "0529450772",
    language: "Finnish, English",
    turnover: 70.0,
    employeeCount: 6,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1759276800000),
    size: 79,
    sizeMax: 99,
    rent: 1975,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 2.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Annu",
    lastName: "Hiekkala",
    email: "tenant072@sopia.io",
    companyLogo: "logo172.png",
    companyName: "Kukka & Multa",
    contactPerson: "Jesse",
    contactPersonLastName: "Sarva",
    phoneNumber: "0597453685",
    language: "Finnish, Swedish",
    turnover: 100.0,
    employeeCount: 3,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1759276800000),
    size: 75,
    sizeMax: 95,
    rent: 1850,
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Annukka",
    lastName: "Soini",
    email: "tenant073@sopia.io",
    companyLogo: "logo173.png",
    companyName: "Helsingin parkki",
    contactPerson: "Jimi",
    contactPersonLastName: "Louhivuori",
    phoneNumber: "0503091118",
    language: "Finnish, English",
    turnover: 35.0,
    employeeCount: 3,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1759276800000),
    size: 30,
    sizeMax: 50,
    rent: 750,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 3.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 0,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Ansa",
    lastName: "Harima",
    email: "tenant074@sopia.io",
    companyLogo: "logo174.png",
    companyName: "Lataus Oy",
    contactPerson: "Jiri",
    contactPersonLastName: "Saarnio",
    phoneNumber: "0563879662",
    language: "Finnish, English",
    turnover: 36.0,
    employeeCount: 3,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1759276800000),
    size: 40,
    sizeMax: 60,
    rent: 1000,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 2.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Anu",
    lastName: "Harva",
    email: "tenant075@sopia.io",
    companyLogo: "logo175.png",
    companyName: "Kasvu Oy",
    contactPerson: "Joakim",
    contactPersonLastName: "Maasalo",
    phoneNumber: "0408870705",
    language: "Finnish, Swedish",
    turnover: 37.0,
    employeeCount: 3,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1759276800000),
    size: 27,
    sizeMax: 47,
    rent: 675,
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 0,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Arja",
    lastName: "Karikoski",
    email: "tenant076@sopia.io",
    companyLogo: "logo176.png",
    companyName: "Liito Oy",
    contactPerson: "Joel",
    contactPersonLastName: "Malmivaara",
    phoneNumber: "0575912588",
    language: "Finnish, Swedish",
    turnover: 38.0,
    employeeCount: 3,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1754006400000),
    size: 28,
    sizeMax: 48,
    rent: 700,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 3.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Armi",
    lastName: "Harki",
    email: "tenant077@sopia.io",
    companyLogo: "logo177.png",
    companyName: "Rahapankki",
    contactPerson: "Johannes",
    contactPersonLastName: "Mela",
    phoneNumber: "0421294065",
    language: "Finnish, English",
    turnover: 39.0,
    employeeCount: 6,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [5],
    whenAvailable: new Date(1754006400000),
    size: 93,
    sizeMax: 113,
    rent: 2325,
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Asta",
    lastName: "Paasivuori",
    email: "tenant078@sopia.io",
    companyLogo: "logo178.png",
    companyName: "Korkoa korolle Oy",
    contactPerson: "Joni",
    contactPersonLastName: "Merikanto",
    phoneNumber: "0463113047",
    language: "Finnish, English, Swedish",
    turnover: 40.0,
    employeeCount: 5,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1754006400000),
    size: 83,
    sizeMax: 103,
    rent: 2075,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Auli",
    lastName: "Helasvuo",
    email: "tenant079@sopia.io",
    companyLogo: "logo179.png",
    companyName: "Talletusneidit",
    contactPerson: "Jonne",
    contactPersonLastName: "Mannermaa",
    phoneNumber: "0573786045",
    language: "Finnish, English",
    turnover: 41.0,
    employeeCount: 5,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1754006400000),
    size: 80,
    sizeMax: 100,
    rent: 2000,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Aulikki",
    lastName: "Paasivirta",
    email: "tenant080@sopia.io",
    companyLogo: "logo180.png",
    companyName: "Hessun Kone",
    contactPerson: "Jonni",
    contactPersonLastName: "Miesmaa",
    phoneNumber: "0514804207",
    language: "Finnish, Swedish",
    turnover: 200.0,
    employeeCount: 5,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [4],
    whenAvailable: new Date(1754006400000),
    size: 110,
    sizeMax: 130,
    rent: 2750,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Aune",
    lastName: "Paasio",
    email: "tenant081@sopia.io",
    companyLogo: "logo181.png",
    companyName: "Punainen Ratikka",
    contactPerson: "Jooa",
    contactPersonLastName: "Kivalo",
    phoneNumber: "0584791379",
    language: "Finnish, English",
    turnover: 43.0,
    employeeCount: 5,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1754006400000),
    size: 50,
    sizeMax: 70,
    rent: 1250,
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["NO"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 0,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Auni",
    lastName: "Heporauta",
    email: "tenant082@sopia.io",
    companyLogo: "logo182.png",
    companyName: "Sininen Linna",
    contactPerson: "Joona",
    contactPersonLastName: "Muroma",
    phoneNumber: "0506136858",
    language: "Finnish, English",
    turnover: 44.0,
    employeeCount: 4,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1754006400000),
    size: 43,
    sizeMax: 63,
    rent: 1075,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 3.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Aura",
    lastName: "Rihtniemi",
    email: "tenant083@sopia.io",
    companyLogo: "logo183.png",
    companyName: "Vihreä Kuljetus Oy",
    contactPerson: "Joonas",
    contactPersonLastName: "Nevanlinna",
    phoneNumber: "0590007683",
    language: "Finnish, English",
    turnover: 45.0,
    employeeCount: 2,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1754006400000),
    size: 44,
    sizeMax: 64,
    rent: 1100,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 2.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Auri",
    lastName: "Ivalo",
    email: "tenant084@sopia.io",
    companyLogo: "logo184.png",
    companyName: "Green Path Oy",
    contactPerson: "Joonatan",
    contactPersonLastName: "Nuorpuu",
    phoneNumber: "0530412961",
    language: "Finnish, Swedish",
    turnover: 46.0,
    employeeCount: 5,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1754006400000),
    size: 26,
    sizeMax: 46,
    rent: 650,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 5.0,
    furnished: "Furnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Aurora",
    lastName: "Koskenjaakko",
    email: "tenant085@sopia.io",
    companyLogo: "logo185.png",
    companyName: "Greener Steps",
    contactPerson: "Joose",
    contactPersonLastName: "Pohjanpää",
    phoneNumber: "0463937731",
    language: "Finnish, English",
    turnover: 47.0,
    employeeCount: 6,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1754006400000),
    size: 63,
    sizeMax: 83,
    rent: 1575,
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Eerika",
    lastName: "Jaari",
    email: "tenant086@sopia.io",
    companyLogo: "logo186.png",
    companyName: "Hissi Oy",
    contactPerson: "Joosef",
    contactPersonLastName: "Nuorivaara",
    phoneNumber: "0406567494",
    language: "Finnish, English",
    turnover: 100.0,
    employeeCount: 5,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [4],
    whenAvailable: new Date(1754006400000),
    size: 101,
    sizeMax: 121,
    rent: 2525,
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 0,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Eeva",
    lastName: "Wihuri",
    email: "tenant087@sopia.io",
    companyLogo: "logo187.png",
    companyName: "Keltainen Aurinko",
    contactPerson: "Jooseppi",
    contactPersonLastName: "Nuorteva",
    phoneNumber: "0547332841",
    language: "Finnish, English",
    turnover: 49.0,
    employeeCount: 2,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1754006400000),
    size: 27,
    sizeMax: 47,
    rent: 675,
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: false,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Eevi",
    lastName: "Rautavaara\/Rautawaara",
    email: "tenant088@sopia.io",
    companyLogo: "logo188.png",
    companyName: "Oranssi Tiikeri Oy",
    contactPerson: "Jori",
    contactPersonLastName: "Laitakari",
    phoneNumber: "0523596430",
    language: "Finnish, English",
    turnover: 50.0,
    employeeCount: 2,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1754006400000),
    size: 44,
    sizeMax: 64,
    rent: 1100,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 3.0,
    furnished: "Furnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Eija",
    lastName: "Rautavuori",
    email: "tenant089@sopia.io",
    companyLogo: "logo189.png",
    companyName: "Metsäkasvu",
    contactPerson: "Jorma",
    contactPersonLastName: "Airila",
    phoneNumber: "0509784364",
    language: "Finnish, English",
    turnover: 51.0,
    employeeCount: 3,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1754006400000),
    size: 80,
    sizeMax: 100,
    rent: 2200,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 2.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Eila",
    lastName: "Järviluoma",
    email: "tenant090@sopia.io",
    companyLogo: "logo190.png",
    companyName: "Voitto & Ansa",
    contactPerson: "Jouko",
    contactPersonLastName: "Nuorvala",
    phoneNumber: "0404872910",
    language: "Finnish, English",
    turnover: 52.0,
    employeeCount: 3,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1754006400000),
    size: 38,
    sizeMax: 58,
    rent: 950,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 3.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Eine",
    lastName: "Rautavirta",
    email: "tenant091@sopia.io",
    companyLogo: "logo191.png",
    companyName: "Liisan Laku Oy",
    contactPerson: "Jouni",
    contactPersonLastName: "Ilves",
    phoneNumber: "0519337235",
    language: "Finnish, English",
    turnover: 53.0,
    employeeCount: 3,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1754006400000),
    size: 35,
    sizeMax: 55,
    rent: 875,
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Eini",
    lastName: "Airo",
    email: "tenant092@sopia.io",
    companyLogo: "logo192.png",
    companyName: "DKVB OY",
    contactPerson: "Jousia",
    contactPersonLastName: "Niitemaa",
    phoneNumber: "0575823950",
    language: "Finnish, English",
    turnover: 54.0,
    employeeCount: 2,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1754006400000),
    size: 33,
    sizeMax: 50,
    rent: 825,
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Eira",
    lastName: "Kaila",
    email: "tenant093@sopia.io",
    companyLogo: "logo193.png",
    companyName: "ZXZX Oy",
    contactPerson: "Juha",
    contactPersonLastName: "Näre",
    phoneNumber: "0575199303",
    language: "Finnish, English",
    turnover: 55.0,
    employeeCount: 2,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1754956800000),
    size: 26,
    sizeMax: 46,
    rent: 650,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 2.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Elena",
    lastName: "Somerjoki",
    email: "tenant094@sopia.io",
    companyLogo: "logo194.png",
    companyName: "Toimittajat Huomenna Oy",
    contactPerson: "Juhana",
    contactPersonLastName: "Järventaus",
    phoneNumber: "0508233501",
    language: "Finnish, English, Swedish",
    turnover: 56.0,
    employeeCount: 2,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1755043200000),
    size: 33,
    sizeMax: 50,
    rent: 825,
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Eleonoora",
    lastName: "Vannas",
    email: "tenant095@sopia.io",
    companyLogo: "logo195.png",
    companyName: "Lännen Urheilijat Oy",
    contactPerson: "Juhani",
    contactPersonLastName: "Suviranta",
    phoneNumber: "0424696838",
    language: "Finnish, Swedish",
    turnover: 57.0,
    employeeCount: 2,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1755129600000),
    size: 38,
    sizeMax: 58,
    rent: 950,
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Eliisa",
    lastName: "Soininen",
    email: "tenant096@sopia.io",
    companyLogo: "logo196.png",
    companyName: "Eläintuote Oy",
    contactPerson: "Juho",
    contactPersonLastName: "Suolahti",
    phoneNumber: "0582328370",
    language: "Finnish, English",
    turnover: 58.0,
    employeeCount: 2,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1755216000000),
    size: 30,
    sizeMax: 40,
    rent: 775,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 2.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Elina",
    lastName: "Soisalon-Soininen",
    email: "tenant097@sopia.io",
    companyLogo: "logo197.png",
    companyName: "Tietoa Oy",
    contactPerson: "Jukka",
    contactPersonLastName: "Salmenoja",
    phoneNumber: "0411003769",
    language: "Finnish, English",
    turnover: 59.0,
    employeeCount: 2,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1756684800000),
    size: 20,
    sizeMax: 40,
    rent: 650,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 2.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 0,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Elisa",
    lastName: "Jousi",
    email: "tenant098@sopia.io",
    companyLogo: "logo198.png",
    companyName: "Tietäjät Oy",
    contactPerson: "Julius",
    contactPersonLastName: "Paalu",
    phoneNumber: "0421502168",
    language: "Finnish, English",
    turnover: 60.0,
    employeeCount: 2,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1756684800000),
    size: 25,
    sizeMax: 40,
    rent: 525,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 2.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Elisabet",
    lastName: "Juva",
    email: "tenant099@sopia.io",
    companyLogo: "logo199.png",
    companyName: "Pellen Kehitys Oy",
    contactPerson: "Jussi",
    contactPersonLastName: "Paatela",
    phoneNumber: "0489979975",
    language: "Finnish, English",
    turnover: 61.0,
    employeeCount: 2,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1756684800000),
    size: 35,
    sizeMax: 40,
    rent: 850,
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: false,
  },
  {
    firstName: "Elise",
    lastName: "Jalanti",
    email: "tenant100@sopia.io",
    companyLogo: "logo200.png",
    companyName: "Tiian Taigaa",
    contactPerson: "Justus",
    contactPersonLastName: "Salonen",
    phoneNumber: "0513540744",
    language: "Finnish, Swedish",
    turnover: 62.0,
    employeeCount: 1,
    city: "Helsinki",
    area: null,
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1756684800000),
    size: 30,
    sizeMax: 40,
    rent: 800,
    publicTransport: null,
    parking: ["OUTDOORS"],
    parkingPlaceAmount: 2.0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: false,
  }
]
const mockDataAnnouncements = [
  {
    company: "Real Estate Finland",
    email: "landlord001@sopia.io",
    contactPersonFirstName: "Juho",
    contactPersonLastName: "Johansson",
    phoneNumber: "0404872910",
    language: "Finnish, English, Swedish",
    description: "We offer a collaborative and innovative workspace designed to foster creativity and growth",
    address: "Fabianinkatu 7",
    postalCode: "00130",
    location: { x: 60.16865, y: 24.953422 },
    n: 60.16865,
    e: 24.953422,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1738368000000),
    size: 75,
    rent: 900,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Finland",
    email: "landlord001@sopia.io",
    contactPersonFirstName: "Jooa",
    contactPersonLastName: "Hultman",
    phoneNumber: "0536559796",
    language: "Finnish, English, Swedish",
    description: "A versatile two-room office perfect for both work and meetings",
    address: "Fabianinkatu 9",
    postalCode: "00130",
    location: { x: 60.169, y: 24.953422 },
    n: 60.169,
    e: 24.953422,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 46,
    rent: 552,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 5,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Finland",
    email: "landlord002@sopia.io",
    contactPersonFirstName: "Emma",
    contactPersonLastName: "Kalima",
    phoneNumber: "0554692361",
    language: "Finnish, English",
    description: "Modern Office Space\nA stylish and private office room, perfect for focused work or one-on-one meetings, equipped with all the essentials for productivity",
    address: "Fabianinkatu 20",
    postalCode: "00100",
    location: { x: 60.17477, y: 24.952912 },
    n: 60.17477,
    e: 24.952912,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 29,
    rent: 348,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Finland",
    email: "landlord002@sopia.io",
    contactPersonFirstName: "Joose",
    contactPersonLastName: "Hällström\/Hellström",
    phoneNumber: "0596475461",
    language: "Finnish, English",
    description: "A spacious four-room office offering a perfect blend of privacy and collaboration, designed to enhance productivity and creativity in a professional setting",
    address: "Fabianinkatu 21",
    postalCode: "00130",
    location: { x: 60.17105, y: 24.953428 },
    n: 60.17105,
    e: 24.953428,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [4],
    whenAvailable: new Date(1738368000000),
    size: 86,
    rent: 1032,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 5,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Finland",
    email: "landlord003@sopia.io",
    contactPersonFirstName: "Elsa",
    contactPersonLastName: "Kurki-Suonio",
    phoneNumber: "0491395649",
    language: "Finnish, English",
    description: "Bright and Spacious Room\nA well-lit office with large windows, providing a comfortable space for work or creative thinking, designed for maximum comfort",
    address: "Fabianinkatu 23",
    postalCode: "00130",
    location: { x: 60.17135, y: 24.953338 },
    n: 60.17135,
    e: 24.953338,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 37,
    rent: 444,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 5,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Finland",
    email: "landlord003@sopia.io",
    contactPersonFirstName: "Jari",
    contactPersonLastName: "Helenius",
    phoneNumber: "0496831535",
    language: "Finnish, English, Swedish",
    description: "A cozy, well-lit two-room office offering privacy and productivity",
    address: "Fabianinkatu 24",
    postalCode: "00100",
    location: { x: 60.17583, y: 24.9529 },
    n: 60.17583,
    e: 24.9529,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 59,
    rent: 708,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 5,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Finland",
    email: "landlord004@sopia.io",
    contactPersonFirstName: "Juhani",
    contactPersonLastName: "Järnström",
    phoneNumber: "0573288515",
    language: "Finnish, English",
    description: "Professional and Quiet\nA quiet, private office ideal for uninterrupted work, with sleek furniture and a minimalist design for a clear mind",
    address: "Fabianinkatu 26",
    postalCode: "00100",
    location: { x: 60.17611, y: 24.952786 },
    n: 60.17611,
    e: 24.952786,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 29,
    rent: 348,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Furnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Finland",
    email: "landlord004@sopia.io",
    contactPersonFirstName: "Jalmari",
    contactPersonLastName: "Helander",
    phoneNumber: "0532563649",
    language: "Finnish, English",
    description: "Looking for a modern office environment? Our flexible spaces are perfect for both individual work and team collaboration.\nNeed a productive workspace? We provide comfortable, fully-equipped offices to help you achieve your best work",
    address: "Fabianinkatu 28",
    postalCode: "00100",
    location: { x: 60.17642, y: 24.952888 },
    n: 60.17642,
    e: 24.952888,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1738368000000),
    size: 82,
    rent: 984,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Finland",
    email: "landlord005@sopia.io",
    contactPersonFirstName: "Heljä",
    contactPersonLastName: "Mela",
    phoneNumber: "0480189560",
    language: "Finnish, English",
    description: "Cozy Office Corner\nA compact yet functional office room, offering a cozy environment to concentrate and meet with clients in a professional setting",
    address: "Fabianinkatu 30",
    postalCode: "00100",
    location: { x: 60.17664, y: 24.952708 },
    n: 60.17664,
    e: 24.952708,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 43,
    rent: 516,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Finland",
    email: "landlord005@sopia.io",
    contactPersonFirstName: "Joakim",
    contactPersonLastName: "Hildén",
    phoneNumber: "0426566108",
    language: "Finnish, English, Swedish",
    description: "Elegant Workspace\nA tastefully decorated office room with contemporary furnishings, providing an ideal setting for individual work or client consultations\nEfficient & Practical\nA well-organized office room, offering a productive environment with a desk, comfortable seating, and plenty of storage space",
    address: "Gyldénintie 1",
    postalCode: "00200",
    location: { x: 60.16243, y: 24.929404 },
    n: 60.16243,
    e: 24.929404,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 43,
    rent: 516,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Finland",
    email: "landlord006@sopia.io",
    contactPersonFirstName: "Jukka",
    contactPersonLastName: "Johansson",
    phoneNumber: "0470006216",
    language: "Finnish, English",
    description: "Your next office awaits! Enjoy a sleek, comfortable environment where ideas come to life and businesses grow.",
    address: "Hietaniemenkatu 2",
    postalCode: "00100",
    location: { x: 60.19758, y: 24.958825 },
    n: 60.19758,
    e: 24.958582,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1738368000000),
    size: 77,
    rent: 924,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 5,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Finland",
    email: "landlord006@sopia.io",
    contactPersonFirstName: "Helmi",
    contactPersonLastName: "Nuorpuu",
    phoneNumber: "0463863164",
    language: "Finnish, English, Swedish",
    description: "A roomy four-room office combining privacy and collaborative spaces, designed to boost productivity and creativity in a professional environment",
    address: "Hietaniemenkatu 27",
    postalCode: "00100",
    location: { x: 60.23157, y: 24.952045 },
    n: 60.23157,
    e: 24.952504,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [4],
    whenAvailable: new Date(1738368000000),
    size: 117,
    rent: 1404,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Finland",
    email: "landlord007@sopia.io",
    contactPersonFirstName: "Jimi",
    contactPersonLastName: "Hildén",
    phoneNumber: "0559755036",
    language: "Finnish, English",
    description: "A modern two-room office with a balance of personal space and collaboration",
    address: "Abrahaminkatu 6",
    postalCode: "00180",
    location: { x: 60.24051, y: 24.960175 },
    n: 60.24051,
    e: 24.960517,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 51,
    rent: 612,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 5,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Finland",
    email: "landlord007@sopia.io",
    contactPersonFirstName: "Enni",
    contactPersonLastName: "Niini",
    phoneNumber: "0520042882",
    language: "Finnish, English",
    description: "A spacious two-room office designed for comfort and efficient work",
    address: "Abrahaminkatu 8",
    postalCode: "00180",
    location: { x: 60.24451, y: 24.959875 },
    n: 60.24451,
    e: 24.959587,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 43,
    rent: 516,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Finland",
    email: "landlord008@sopia.io",
    contactPersonFirstName: "Jooa",
    contactPersonLastName: "Hultman",
    phoneNumber: "0480606161",
    language: "Finnish, English, Swedish",
    description: "Private and Peaceful\nA serene office room with soundproofing and modern decor, ensuring a distraction-free environment for focused work or private meetings\n",
    address: "Ainonkatu 2",
    postalCode: "00100",
    location: { x: 60.22053, y: 24.962515 },
    n: 60.22053,
    e: 24.962551,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 34,
    rent: 408,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Furnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Finland",
    email: "landlord008@sopia.io",
    contactPersonFirstName: "Justus",
    contactPersonLastName: "Johnsson",
    phoneNumber: "0447091951",
    language: "Finnish, English",
    description: "Contemporary Office Room\nThis modern office space features clean lines, a comfortable work desk, and ample natural light, creating a bright and inviting atmosphere",
    address: "Ainonkatu 4",
    postalCode: "00100",
    location: { x: 60.21955, y: 24.962245 },
    n: 60.21955,
    e: 24.962524,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 25,
    rent: 500,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Finland",
    email: "landlord009@sopia.io",
    contactPersonFirstName: "Helena",
    contactPersonLastName: "Louhivuori",
    phoneNumber: "0469594846",
    language: "Finnish, English",
    description: "A two-room office with stylish decor, ideal for professionals and teams",
    address: "Albertinkatu 1",
    postalCode: "00150",
    location: { x: 60.18850, y: 24.967075 },
    n: 60.18850,
    e: 24.967507,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 50,
    rent: 1000,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 5,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Finland",
    email: "landlord009@sopia.io",
    contactPersonFirstName: "Jori",
    contactPersonLastName: "Ingman",
    phoneNumber: "0548296630",
    language: "Finnish, Swedish",
    description: "Creative Work Environment\nA flexible office room that fosters creativity, with stylish furniture and a layout designed for both individual and collaborative tasks",
    address: "Albertinkatu 12",
    postalCode: "00150",
    location: { x: 60.19951, y: 24.965375 },
    n: 60.19951,
    e: 24.965537,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 23,
    rent: 460,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Helsinki",
    email: "landlord010@sopia.io",
    contactPersonFirstName: "Hilja",
    contactPersonLastName: "Näre",
    phoneNumber: "0489825781",
    language: "Finnish, English",
    description: "A functional two-room office that supports both individual work and group collaboration",
    address: "Albertinkatu 14",
    postalCode: "00120",
    location: { x: 60.20356, y: 24.965125 },
    n: 60.20356,
    e: 24.965512,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 57,
    rent: 1140,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 10,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Helsinki",
    email: "landlord010@sopia.io",
    contactPersonFirstName: "Jani",
    contactPersonLastName: "Helenius",
    phoneNumber: "0484267267",
    language: "Finnish, English",
    description: "Sleek and Functional\nA well-equipped office space with a desk, ergonomic chair, and essential technology, designed to support both productivity and comfort",
    address: "Bulevardi 31",
    postalCode: "00180",
    location: { x: 60.22456, y: 24.961975 },
    n: 60.22456,
    e: 24.961597,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 29,
    rent: 580,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 10,
    furnished: "Furnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Helsinki",
    email: "landlord011@sopia.io",
    contactPersonFirstName: "Jouni",
    contactPersonLastName: "Jansson",
    phoneNumber: "0541670035",
    language: "Finnish, Swedish",
    description: "A sleek and contemporary two-room office with ample natural light",
    address: "Bulevardi 34a",
    postalCode: "00120",
    location: { x: 60.22353, y: 24.963475 },
    n: 60.22353,
    e: 24.963547,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 43,
    rent: 516,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Helsinki",
    email: "landlord011@sopia.io",
    contactPersonFirstName: "Hanne",
    contactPersonLastName: "Loimaranta",
    phoneNumber: "0584733493",
    language: "Finnish, English",
    description: "Elevate your work life! Discover a professional setting with top-notch facilities and a thriving community",
    address: "Bulevardi 40",
    postalCode: "00120",
    location: { x: 60.21851, y: 24.962525 },
    n: 60.21851,
    e: 24.962552,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1738368000000),
    size: 87,
    rent: 1044,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 10,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Helsinki",
    email: "landlord012@sopia.io",
    contactPersonFirstName: "Jukka",
    contactPersonLastName: "Johansson",
    phoneNumber: "0562625014",
    language: "Finnish, English",
    description: "Efficient & Practical\nA well-organized office room, offering a productive environment with a desk, comfortable seating, and plenty of storage space",
    address: "Bulevardi 4",
    postalCode: "00120",
    location: { x: 60.25755, y: 24.968375 },
    n: 60.25755,
    e: 24.968537,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 23,
    rent: 690,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 10,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Helsinki",
    email: "landlord012@sopia.io",
    contactPersonFirstName: "Jeremias",
    contactPersonLastName: "Hellsten",
    phoneNumber: "0433697611",
    language: "Finnish, Swedish",
    description: "Modern Office Space\nA stylish and private office room, perfect for focused work or one-on-one meetings, equipped with all the essentials for productivity",
    address: "Caloniuksenkatu 1",
    postalCode: "00100",
    location: { x: 60.24059, y: 24.955515 },
    n: 60.24059,
    e: 24.955551,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 42,
    rent: 1260,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 10,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Helsinki",
    email: "landlord013@sopia.io",
    contactPersonFirstName: "Juhana",
    contactPersonLastName: "Jernström",
    phoneNumber: "0425261860",
    language: "Finnish, Swedish",
    description: "Bright and Spacious Room\nA well-lit office with large windows, providing a comfortable space for work or creative thinking, designed for maximum comfort",
    address: "Caloniuksenkatu 3",
    postalCode: "00100",
    location: { x: 60.24357, y: 24.955685 },
    n: 60.24357,
    e: 24.955568,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 44,
    rent: 528,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Helsinki",
    email: "landlord013@sopia.io",
    contactPersonFirstName: "Heljä",
    contactPersonLastName: "Mela",
    phoneNumber: "0537494342",
    language: "Finnish, English",
    description: "A private two-room office that promotes focus and creativity",
    address: "Caloniuksenkatu 5",
    postalCode: "00100",
    location: { x: 60.24654, y: 24.955935 },
    n: 60.24654,
    e: 24.955593,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 43,
    rent: 516,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 10,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Helsinki",
    email: "landlord014@sopia.io",
    contactPersonFirstName: "Enna",
    contactPersonLastName: "Listo",
    phoneNumber: "0552190202",
    language: "Finnish, English",
    description: "A stylish two-room office with modern amenities to suit your business needs",
    address: "Caloniuksenkatu 7",
    postalCode: "00100",
    location: { x: 60.24955, y: 24.956135 },
    n: 60.24955,
    e: 24.956513,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 55,
    rent: 660,
    rentPeriodMin: "3 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 10,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Helsinki",
    email: "landlord014@sopia.io",
    contactPersonFirstName: "Juho",
    contactPersonLastName: "Johansson",
    phoneNumber: "0424616491",
    language: "Finnish, English, Swedish",
    description: "Professional and Quiet\nA quiet, private office ideal for uninterrupted work, with sleek furniture and a minimalist design for a clear mind",
    address: "Caloniuksenkatu 9",
    postalCode: "00100",
    location: { x: 60.25255, y: 24.956515 },
    n: 60.25255,
    e: 24.956551,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 23,
    rent: 276,
    rentPeriodMin: "3 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Helsinki",
    email: "landlord015@sopia.io",
    contactPersonFirstName: "Enna",
    contactPersonLastName: "Listo",
    phoneNumber: "0503994629",
    language: "Finnish, Swedish",
    description: "A professional two-room office with an open layout and quiet workspace",
    address: "Dunckerinkatu 2",
    postalCode: "00260",
    location: { x: 60.19451, y: 24.960395 },
    n: 60.19451,
    e: 24.960539,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 57,
    rent: 684,
    rentPeriodMin: "3 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Helsinki",
    email: "landlord015@sopia.io",
    contactPersonFirstName: "Hanne",
    contactPersonLastName: "Loimaranta",
    phoneNumber: "0572164882",
    language: "Finnish, English",
    description: "Bright and Spacious Room\nA well-lit office with large windows, providing a comfortable space for work or creative thinking, designed for maximum comfort",
    address: "Döbelninkatu 1",
    postalCode: "00260",
    location: { x: 60.19355, y: 24.958105 },
    n: 60.19355,
    e: 24.958510,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 25,
    rent: 500,
    rentPeriodMin: "3 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 10,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Helsinki",
    email: "landlord016@sopia.io",
    contactPersonFirstName: "Jalmari",
    contactPersonLastName: "Helander",
    phoneNumber: "0529425770",
    language: "Finnish, English",
    description: "A well-equipped two-room office designed for productivity and comfort",
    address: "Döbelninkatu 3a",
    postalCode: "00260",
    location: { x: 60.19259, y: 24.957865 },
    n: 60.19259,
    e: 24.957586,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 53,
    rent: 1060,
    rentPeriodMin: "3 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Helsinki",
    email: "landlord016@sopia.io",
    contactPersonFirstName: "Jaakoppi",
    contactPersonLastName: "Heikel",
    phoneNumber: "0494803337",
    language: "Finnish, English",
    description: "Modern Office Space\nA stylish and private office room, perfect for focused work or one-on-one meetings, equipped with all the essentials for productivity",
    address: "Eino Leinon katu 3",
    postalCode: "00250",
    location: { x: 60.25754, y: 24.955825 },
    n: 60.25754,
    e: 24.955582,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 45,
    rent: 900,
    rentPeriodMin: "3 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Helsinki",
    email: "landlord017@sopia.io",
    contactPersonFirstName: "Hellevi",
    contactPersonLastName: "Miesmaa",
    phoneNumber: "0491660413",
    language: "Finnish, English",
    description: "Professional and Quiet\nA quiet, private office ideal for uninterrupted work, with sleek furniture and a minimalist design for a clear mind",
    address: "Eino Leinon katu 7",
    postalCode: "00250",
    location: { x: 60.25756, y: 24.955095 },
    n: 60.25756,
    e: 24.955509,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 42,
    rent: 840,
    rentPeriodMin: "3 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Helsinki",
    email: "landlord017@sopia.io",
    contactPersonFirstName: "Jonni",
    contactPersonLastName: "Holmström",
    phoneNumber: "0541769543",
    language: "Finnish, English",
    description: "A clean and simple two-room office, perfect for small teams or individuals",
    address: "Eiranranta 3",
    postalCode: "00150",
    location: { x: 60.23752, y: 24.963065 },
    n: 60.23752,
    e: 24.963506,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 59,
    rent: 1180,
    rentPeriodMin: "3 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Helsinki",
    email: "landlord018@sopia.io",
    contactPersonFirstName: "Hilla",
    contactPersonLastName: "Suviranta",
    phoneNumber: "0501517695",
    language: "Finnish, English",
    description: "Need a productive workspace?\nWe provide comfortable, fully-equipped offices to help you achieve your best work",
    address: "Eiranranta 7",
    postalCode: "00150",
    location: { x: 60.23056, y: 24.962035 },
    n: 60.23056,
    e: 24.962503,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1738368000000),
    size: 73,
    rent: 876,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 10,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Helsinki",
    email: "landlord018@sopia.io",
    contactPersonFirstName: "Jesper",
    contactPersonLastName: "Herckman",
    phoneNumber: "0569433947",
    language: "Finnish, English, Swedish",
    description: "Creative Work Environment\nA flexible office room that fosters creativity, with stylish furniture and a layout designed for both individual and collaborative tasks.",
    address: "Elisabeth Koch vägen - Ruskeasuon siirtolapuutarha 61",
    postalCode: "00280",
    location: { x: 60.16886, y: 24.946055 },
    n: 60.16886,
    e: 24.946505,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 22,
    rent: 264,
    rentPeriodMin: "3 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Helsinki",
    email: "landlord019@sopia.io",
    contactPersonFirstName: "Jimi",
    contactPersonLastName: "Hildén",
    phoneNumber: "0475663329",
    language: "Finnish, English",
    description: "Spacious 3-Room Office\nA modern, efficient space with three private rooms, ideal for meetings, workstations, and collaborative sessions.",
    address: "Elisabeth Koch vägen - Ruskeasuon siirtolapuutarha 63",
    postalCode: "00280",
    location: { x: 60.16920, y: 24.946395 },
    n: 60.16920,
    e: 24.946539,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1738368000000),
    size: 95,
    rent: 1140,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Helsinki",
    email: "landlord019@sopia.io",
    contactPersonFirstName: "Jori",
    contactPersonLastName: "Ingman",
    phoneNumber: "0421872034",
    language: "Finnish, English",
    description: "A bright two-room office offering privacy and a collaborative environment",
    address: "Fabianinkatu 7",
    postalCode: "00130",
    location: { x: 60.23655, y: 24.972375 },
    n: 60.23655,
    e: 24.972537,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 45,
    rent: 900,
    rentPeriodMin: "3 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Helsinki",
    email: "landlord020@sopia.io",
    contactPersonFirstName: "Joose",
    contactPersonLastName: "Hällström\/Hellström",
    phoneNumber: "0529029297",
    language: "Finnish, Swedish",
    description: "Cozy Office Corner\nA compact yet functional office room, offering a cozy environment to concentrate and meet with clients in a professional setting.",
    address: "Fabianinkatu 9",
    postalCode: "00130",
    location: { x: 60.24050, y: 24.972375 },
    n: 60.24050,
    e: 24.972537,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 33,
    rent: 660,
    rentPeriodMin: "3 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 10,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Helsinki",
    email: "landlord020@sopia.io",
    contactPersonFirstName: "Jarmo",
    contactPersonLastName: "Helenius",
    phoneNumber: "0585284909",
    language: "Finnish, English",
    description: "A flexible two-room office with plenty of room for meetings and personal work",
    address: "Fabianinkatu 20",
    postalCode: "00100",
    location: { x: 60.19757, y: 24.971525 },
    n: 60.19757,
    e: 24.971552,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 57,
    rent: 684,
    rentPeriodMin: "3 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Helsinki",
    email: "landlord021@sopia.io",
    contactPersonFirstName: "Jiri",
    contactPersonLastName: "Hildén",
    phoneNumber: "0563012822",
    language: "Finnish, English",
    description: "A flexible two-room office with plenty of room for meetings and personal work",
    address: "Fabianinkatu 21",
    postalCode: "00130",
    location: { x: 60.16055, y: 24.972385 },
    n: 60.16055,
    e: 24.972538,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 41,
    rent: 492,
    rentPeriodMin: "3 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Helsinki",
    email: "landlord021@sopia.io",
    contactPersonFirstName: "Joonas",
    contactPersonLastName: "Hällström",
    phoneNumber: "0576665667",
    language: "Finnish, English",
    description: "Bright and Spacious Room\nA well-lit office with large windows, providing a comfortable space for work or creative thinking, designed for maximum comfort.",
    address: "Fabianinkatu 23",
    postalCode: "00130",
    location: { x: 60.16355, y: 24.972235 },
    n: 60.16355,
    e: 24.972523,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 35,
    rent: 420,
    rentPeriodMin: "3 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Helsinki",
    email: "landlord022@sopia.io",
    contactPersonFirstName: "Jimi",
    contactPersonLastName: "Hildén",
    phoneNumber: "0439133714",
    language: "Finnish, English",
    description: "A flexible two-room office with plenty of room for meetings and personal work",
    address: "Fabianinkatu 24",
    postalCode: "00100",
    location: { x: 60.20853, y: 24.971505 },
    n: 60.20853,
    e: 24.971550,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 46,
    rent: 552,
    rentPeriodMin: "3 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Helsinki",
    email: "landlord022@sopia.io",
    contactPersonFirstName: "Justus",
    contactPersonLastName: "Johnsson",
    phoneNumber: "0584678186",
    language: "Finnish, English",
    description: "Creative Work Environment\nA flexible office room that fosters creativity, with stylish furniture and a layout designed for both individual and collaborative tasks.",
    address: "Fabianinkatu 26",
    postalCode: "00100",
    location: { x: 60.21151, y: 24.971315 },
    n: 60.21151,
    e: 24.971531,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 35,
    rent: 420,
    rentPeriodMin: "3 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Helsinki",
    email: "landlord023@sopia.io",
    contactPersonFirstName: "Helena",
    contactPersonLastName: "Louhivuori",
    phoneNumber: "0568684096",
    language: "Finnish, English",
    description: "This expansive four-room office offers a seamless balance of privacy and teamwork, ideal for fostering both focus and innovation.",
    address: "Fabianinkatu 28",
    postalCode: "00100",
    location: { x: 60.21452, y: 24.971485 },
    n: 60.21452,
    e: 24.971548,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [4],
    whenAvailable: new Date(1740787200000),
    size: 117,
    rent: 1404,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Helsinki",
    email: "landlord023@sopia.io",
    contactPersonFirstName: "Elsa",
    contactPersonLastName: "Kurki-Suonio",
    phoneNumber: "0588654221",
    language: "Finnish, English",
    description: "Modern Office Space\nA stylish and private office room, perfect for focused work or one-on-one meetings, equipped with all the essentials for productivity.",
    address: "Fabianinkatu 30",
    postalCode: "00100",
    location: { x: 60.21654, y: 24.971185 },
    n: 60.21654,
    e: 24.971518,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 36,
    rent: 432,
    rentPeriodMin: "3 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Helsinki",
    email: "landlord024@sopia.io",
    contactPersonFirstName: "Jonne",
    contactPersonLastName: "Holmberg",
    phoneNumber: "0496529943",
    language: "Finnish, English",
    description: "A flexible two-room office with plenty of room for meetings and personal work",
    address: "Gyldénintie 1",
    postalCode: "00200",
    location: { x: 60.17453, y: 24.932345 },
    n: 60.17453,
    e: 24.932534,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 41,
    rent: 820,
    rentPeriodMin: "3 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Helsinki",
    email: "landlord024@sopia.io",
    contactPersonFirstName: "Iiris",
    contactPersonLastName: "Sotavalta",
    phoneNumber: "0458273472",
    language: "Finnish, English",
    description: "A flexible two-room office with plenty of room for meetings and personal work",
    address: "Gyldénintie 13",
    postalCode: "00200",
    location: { x: 60.20455, y: 24.932535 },
    n: 60.20455,
    e: 24.932553,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 58,
    rent: 1160,
    rentPeriodMin: "3 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Helsinki",
    email: "landlord025@sopia.io",
    contactPersonFirstName: "Hellevi",
    contactPersonLastName: "Miesmaa",
    phoneNumber: "0515324012",
    language: "Finnish, English",
    description: "A versatile two-room office perfect for both work and meetings",
    address: "Gyldénintie 15",
    postalCode: "00200",
    location: { x: 60.21155, y: 24.932595 },
    n: 60.21155,
    e: 24.932559,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 43,
    rent: 516,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Helsinki",
    email: "landlord025@sopia.io",
    contactPersonFirstName: "Jouko",
    contactPersonLastName: "Jankeloff",
    phoneNumber: "0435446378",
    language: "Finnish, Swedish",
    description: "A modern two-room office with a balance of personal space and collaboration",
    address: "Gyldénintie 2a",
    postalCode: "00200",
    location: { x: 60.17851, y: 24.931585 },
    n: 60.17851,
    e: 24.931558,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 50,
    rent: 600,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Furnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Helsinki",
    email: "landlord026@sopia.io",
    contactPersonFirstName: "Hille",
    contactPersonLastName: "Suolahti",
    phoneNumber: "0460573176",
    language: "Finnish, English",
    description: "A two-room office with stylish decor, ideal for professionals and teams",
    address: "Gyldénintie 4",
    postalCode: "00200",
    location: { x: 60.18651, y: 24.931615 },
    n: 60.18651,
    e: 24.931561,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 42,
    rent: 504,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Helsinki",
    email: "landlord026@sopia.io",
    contactPersonFirstName: "Jasper",
    contactPersonLastName: "Hellberg",
    phoneNumber: "0509715531",
    language: "Finnish, English, Swedish",
    description: "Cozy Office Corner\nA compact yet functional office room, offering a cozy environment to concentrate and meet with clients in a professional setting.",
    address: "Gyldénintie 6",
    postalCode: "00200",
    location: { x: 60.19357, y: 24.931755 },
    n: 60.19357,
    e: 24.931575,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 28,
    rent: 336,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Helsinki",
    email: "landlord027@sopia.io",
    contactPersonFirstName: "Eveliina",
    contactPersonLastName: "Linko",
    phoneNumber: "0461394512",
    language: "Finnish, English",
    description: "Professional and Quiet\nA quiet, private office ideal for uninterrupted work, with sleek furniture and a minimalist design for a clear mind.",
    address: "Erottajankatu 1-3",
    postalCode: "00130",
    location: { x: 60.23858, y: 24.969115 },
    n: 60.23858,
    e: 24.969511,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 40,
    rent: 480,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Helsinki",
    email: "landlord027@sopia.io",
    contactPersonFirstName: "Jaakko",
    contactPersonLastName: "Harberg",
    phoneNumber: "0410024433",
    language: "Finnish, English",
    description: "Vibrant & Creative Workspace\nBold color accents and unique design elements in every room inspire creativity, while maintaining a professional and polished look.",
    address: "Haahkakuja 3",
    postalCode: "00200",
    location: { x: 60.25251, y: 24.930975 },
    n: 60.25251,
    e: 24.930597,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1740787200000),
    size: 83,
    rent: 996,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Helsinki",
    email: "landlord028@sopia.io",
    contactPersonFirstName: "Johannes",
    contactPersonLastName: "Hoffrén",
    phoneNumber: "0402524659",
    language: "Finnish, English",
    description: "Creative Work Environment\nA flexible office room that fosters creativity, with stylish furniture and a layout designed for both individual and collaborative tasks.",
    address: "Haahkakuja 7",
    postalCode: "00200",
    location: { x: 60.16455, y: 24.931155 },
    n: 60.16455,
    e: 24.931515,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 39,
    rent: 468,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Real Estate Helsinki",
    email: "landlord028@sopia.io",
    contactPersonFirstName: "Helvi",
    contactPersonLastName: "Pohjanpää",
    phoneNumber: "0560273255",
    language: "Finnish, English",
    description: "A functional two-room office that supports both individual work and group collaboration",
    address: "Haahkapolku 1",
    postalCode: "00200",
    location: { x: 60.24955, y: 24.932415 },
    n: 60.24955,
    e: 24.932541,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 49,
    rent: 588,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Hki Real Estates",
    email: "landlord029@sopia.io",
    contactPersonFirstName: "Hilkka",
    contactPersonLastName: "Järventaus",
    phoneNumber: "0511976246",
    language: "Finnish, English",
    description: "A flexible two-room office with plenty of room for meetings and personal work",
    address: "Haahkapolku 3",
    postalCode: "00200",
    location: { x: 60.24352, y: 24.932145 },
    n: 60.24352,
    e: 24.932514,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 59,
    rent: 708,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Furnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Hki Real Estates",
    email: "landlord029@sopia.io",
    contactPersonFirstName: "Hilkka",
    contactPersonLastName: "Järventaus",
    phoneNumber: "0406326785",
    language: "Finnish, English",
    description: "Cozy Office Corner\nA compact yet functional office room, offering a cozy environment to concentrate and meet with clients in a professional setting.",
    address: "Haahkatie 1",
    postalCode: "00200",
    location: { x: 60.25954, y: 24.933945 },
    n: 60.25954,
    e: 24.933594,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 40,
    rent: 480,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Hki Real Estates",
    email: "landlord030@sopia.io",
    contactPersonFirstName: "Juhani",
    contactPersonLastName: "Järnström",
    phoneNumber: "0548673192",
    language: "Finnish, English",
    description: "Bright and Spacious Room\nA well-lit office with large windows, providing a comfortable space for work or creative thinking, designed for maximum comfort.",
    address: "Haahkatie 12",
    postalCode: "00200",
    location: { x: 60.24955, y: 24.932415 },
    n: 60.24955,
    e: 24.932541,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 34,
    rent: 408,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Hki Real Estates",
    email: "landlord030@sopia.io",
    contactPersonFirstName: "Jarkko",
    contactPersonLastName: "Helenius",
    phoneNumber: "0425296591",
    language: "Finnish, English",
    description: "A well-designed four-room office that blends private workspaces with areas for collaboration, optimizing productivity and creativity.",
    address: "Haahkatie 14",
    postalCode: "00200",
    location: { x: 60.24859, y: 24.931945 },
    n: 60.24859,
    e: 24.931594,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [4],
    whenAvailable: new Date(1740787200000),
    size: 117,
    rent: 1404,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Hki Real Estates",
    email: "landlord031@sopia.io",
    contactPersonFirstName: "Jarkko",
    contactPersonLastName: "Helenius",
    phoneNumber: "0550743489",
    language: "Finnish, English",
    description: "Creative Work Environment\nA flexible office room that fosters creativity, with stylish furniture and a layout designed for both individual and collaborative tasks.",
    address: "Helsinginkatu 56",
    postalCode: "00260",
    location: { x: 60.24157, y: 24.961895 },
    n: 60.24157,
    e: 24.961589,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 32,
    rent: 640,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Furnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Hki Real Estates",
    email: "landlord031@sopia.io",
    contactPersonFirstName: "Henni",
    contactPersonLastName: "Laitakari",
    phoneNumber: "0582091006",
    language: "Finnish, English",
    description: "Modern Office Space\nA stylish and private office room, perfect for focused work or one-on-one meetings, equipped with all the essentials for productivity.",
    address: "Heikinniementie 11",
    postalCode: "00250",
    location: { x: 60.24053, y: 24.937695 },
    n: 60.24053,
    e: 24.937569,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 31,
    rent: 620,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Hki Real Estates",
    email: "landlord032@sopia.io",
    contactPersonFirstName: "Jarno",
    contactPersonLastName: "Helin",
    phoneNumber: "0449848584",
    language: "Finnish, English",
    description: "Private & Productive\nEnjoy three well-designed rooms in a quiet office setting, perfect for focused work, team discussions, and client interactions.",
    address: "Heikinniementie 3",
    postalCode: "00250",
    location: { x: 60.22358, y: 24.939075 },
    n: 60.22358,
    e: 24.939507,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1740787200000),
    size: 97,
    rent: 1164,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Hki Real Estates",
    email: "landlord032@sopia.io",
    contactPersonFirstName: "Jiri",
    contactPersonLastName: "Hildén",
    phoneNumber: "0578442048",
    language: "Finnish, English",
    description: "Bright and Spacious Room\nA well-lit office with large windows, providing a comfortable space for work or creative thinking, designed for maximum comfort.",
    address: "Heikinniementie 4a",
    postalCode: "00250",
    location: { x: 60.22258, y: 24.938265 },
    n: 60.22258,
    e: 24.938526,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 37,
    rent: 740,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 5,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Hki Real Estates",
    email: "landlord033@sopia.io",
    contactPersonFirstName: "Enni",
    contactPersonLastName: "Niini",
    phoneNumber: "0571463517",
    language: "Finnish, English",
    description: "Creative Work Environment\nA flexible office room that fosters creativity, with stylish furniture and a layout designed for both individual and collaborative tasks.",
    address: "Heikinniementie 6",
    postalCode: "00250",
    location: { x: 60.23452, y: 24.937115 },
    n: 60.23452,
    e: 24.937511,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 37,
    rent: 740,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 5,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Hki Real Estates",
    email: "landlord033@sopia.io",
    contactPersonFirstName: "Heidi",
    contactPersonLastName: "Niinistö",
    phoneNumber: "0517251196",
    language: "Finnish, English, Swedish",
    description: "Modern Office Space\nA stylish and private office room, perfect for focused work or one-on-one meetings, equipped with all the essentials for productivity.",
    address: "Heikinniementie 9",
    postalCode: "00250",
    location: { x: 60.23554, y: 24.938185 },
    n: 60.23554,
    e: 24.938518,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 20,
    rent: 400,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 5,
    furnished: "Furnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimitilat Oy",
    email: "landlord034@sopia.io",
    contactPersonFirstName: "Jalmari",
    contactPersonLastName: "Helander",
    phoneNumber: "0412692570",
    language: "Finnish, Swedish",
    description: "A versatile two-room office perfect for both work and meetings",
    address: "Heikkilänaukio 2",
    postalCode: "00210",
    location: { x: 60.21857, y: 24.933845 },
    n: 60.21857,
    e: 24.933584,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 56,
    rent: 2240,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimitilat Oy",
    email: "landlord034@sopia.io",
    contactPersonFirstName: "Jooseppi",
    contactPersonLastName: "Högman",
    phoneNumber: "0443978293",
    language: "Finnish, Swedish",
    description: "Versatile Office Space\nA 3-room office offering flexibility to accommodate both individual work and group collaboration, all within a professional environment.",
    address: "Heikkilänpolku 1",
    postalCode: "00210",
    location: { x: 60.23358, y: 24.933305 },
    n: 60.23358,
    e: 24.933530,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1740787200000),
    size: 68,
    rent: 2720,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimitilat Oy",
    email: "landlord035@sopia.io",
    contactPersonFirstName: "Hilma",
    contactPersonLastName: "Paalu",
    phoneNumber: "0487881634",
    language: "Finnish, English",
    description: "A modern two-room office with a balance of personal space and collaboration",
    address: "Heikkilänpolku 4",
    postalCode: "00210",
    location: { x: 60.23256, y: 24.932725 },
    n: 60.23256,
    e: 24.932572,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 56,
    rent: 672,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 5,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimitilat Oy",
    email: "landlord035@sopia.io",
    contactPersonFirstName: "Joni",
    contactPersonLastName: "Hohenthal",
    phoneNumber: "0562372521",
    language: "Finnish, English",
    description: "Bright and Spacious Room\nA well-lit office with large windows, providing a comfortable space for work or creative thinking, designed for maximum comfort.",
    address: "Heikkiläntie 1",
    postalCode: "00210",
    location: { x: 60.23252, y: 24.934225 },
    n: 60.23252,
    e: 24.934522,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 26,
    rent: 312,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 5,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimitilat Oy",
    email: "landlord036@sopia.io",
    contactPersonFirstName: "Jalo",
    contactPersonLastName: "Helander",
    phoneNumber: "0572796600",
    language: "Finnish, English",
    description: "Cozy Office Corner\nA compact yet functional office room, offering a cozy environment to concentrate and meet with clients in a professional setting.",
    address: "Heikkiläntie 2",
    postalCode: "00210",
    location: { x: 60.22856, y: 24.933025 },
    n: 60.22856,
    e: 24.933502,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 20,
    rent: 600,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimitilat Oy",
    email: "landlord036@sopia.io",
    contactPersonFirstName: "Hanne",
    contactPersonLastName: "Loimaranta",
    phoneNumber: "0529450772",
    language: "Finnish, English",
    description: "Comfortable & Functional\nThree spacious rooms designed for comfort and productivity, with dedicated areas for focused work, team meetings, and client visits.",
    address: "Heikkiläntie 4",
    postalCode: "00210",
    location: { x: 60.23358, y: 24.933305 },
    n: 60.23358,
    e: 24.933530,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1740787200000),
    size: 63,
    rent: 1890,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 5,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimitilat Oy",
    email: "landlord037@sopia.io",
    contactPersonFirstName: "Jaakob",
    contactPersonLastName: "Heerman",
    phoneNumber: "0597453685",
    language: "Finnish, Swedish",
    description: "A two-room office with stylish decor, ideal for professionals and teams",
    address: "Heikkiläntie 7",
    postalCode: "00210",
    location: { x: 60.24755, y: 24.935975 },
    n: 60.24755,
    e: 24.935597,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 52,
    rent: 2080,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimitilat Oy",
    email: "landlord037@sopia.io",
    contactPersonFirstName: "Else",
    contactPersonLastName: "Kalha",
    phoneNumber: "0503091118",
    language: "Finnish, English",
    description: "Professional and Quiet\nA quiet, private office ideal for uninterrupted work, with sleek furniture and a minimalist design for a clear mind.",
    address: "Heino Kasken katu 2",
    postalCode: "00180",
    location: { x: 60.17157, y: 24.949785 },
    n: 60.17157,
    e: 24.949578,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 28,
    rent: 560,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 5,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimitilat Oy",
    email: "landlord038@sopia.io",
    contactPersonFirstName: "Jooa",
    contactPersonLastName: "Hultman",
    phoneNumber: "0563879662",
    language: "Finnish, English",
    description: "A versatile two-room office perfect for both work and meetings",
    address: "Heino Kasken katu 5",
    postalCode: "00180",
    location: { x: 60.16658, y: 24.949045 },
    n: 60.16658,
    e: 24.949504,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 46,
    rent: 920,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 5,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimitilat Oy",
    email: "landlord038@sopia.io",
    contactPersonFirstName: "Jalo",
    contactPersonLastName: "Helander",
    phoneNumber: "0408870705",
    language: "Finnish, Swedish",
    description: "Elegant Workspace\nA tastefully decorated office room with contemporary furnishings, providing an ideal setting for individual work or client consultations.\nEfficient & Practical\nA well-organized office room, offering a productive environment with a desk, comfortable seating, and plenty of storage space.",
    address: "Helenankatu 1",
    postalCode: "00170",
    location: { x: 60.18157, y: 24.975325 },
    n: 60.18157,
    e: 24.975532,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 29,
    rent: 870,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 5,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimitilat Oy",
    email: "landlord039@sopia.io",
    contactPersonFirstName: "Helinä",
    contactPersonLastName: "Malmivaara",
    phoneNumber: "0575912588",
    language: "Finnish, Swedish",
    description: "Modern 3-Room Office Suite\nA sleek office with three distinct rooms, including a private office, meeting space, and a collaborative work area.",
    address: "Hietalahdenkatu 10",
    postalCode: "00180",
    location: { x: 60.22751, y: 24.959575 },
    n: 60.22751,
    e: 24.959557,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1740787200000),
    size: 93,
    rent: 3720,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimitilat Oy",
    email: "landlord039@sopia.io",
    contactPersonFirstName: "Heini",
    contactPersonLastName: "Sarva",
    phoneNumber: "0421294065",
    language: "Finnish, English",
    description: "A flexible two-room office with plenty of room for meetings and personal work",
    address: "Hietalahdenkatu 12",
    postalCode: "00180",
    location: { x: 60.23056, y: 24.959325 },
    n: 60.23056,
    e: 24.959532,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 42,
    rent: 1680,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 7,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimitilat Oy",
    email: "landlord040@sopia.io",
    contactPersonFirstName: "Heljä",
    contactPersonLastName: "Mela",
    phoneNumber: "0463113047",
    language: "Finnish, English, Swedish",
    description: "Efficient Office Setup\nThis 3-room office offers a balance of privacy and open space, ideal for teams to work and meet with clients comfortably.",
    address: "Hietaniemenkatu 20",
    postalCode: "00100",
    location: { x: 60.23358, y: 24.949565 },
    n: 60.23358,
    e: 24.949556,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1740787200000),
    size: 86,
    rent: 3440,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 7,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimitilat Oy",
    email: "landlord040@sopia.io",
    contactPersonFirstName: "Justus",
    contactPersonLastName: "Johnsson",
    phoneNumber: "0573786045",
    language: "Finnish, English",
    description: "Cozy Office Corner\nA compact yet functional office room, offering a cozy environment to concentrate and meet with clients in a professional setting.",
    address: "Hietaniemenkatu 2",
    postalCode: "00100",
    location: { x: 60.19758, y: 24.958825 },
    n: 60.19758,
    e: 24.958582,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 40,
    rent: 480,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Furnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimitilat Oy",
    email: "landlord041@sopia.io",
    contactPersonFirstName: "Juha",
    contactPersonLastName: "Jernberg",
    phoneNumber: "0514804207",
    language: "Finnish, Swedish",
    description: "A modern two-room office with a balance of personal space and collaboration",
    address: "Hietaniemenkatu 27",
    postalCode: "00100",
    location: { x: 60.23157, y: 24.952045 },
    n: 60.23157,
    e: 24.952504,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 44,
    rent: 528,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 7,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimitilat Oy",
    email: "landlord041@sopia.io",
    contactPersonFirstName: "Joakim",
    contactPersonLastName: "Hildén",
    phoneNumber: "0584791379",
    language: "Finnish, English",
    description: "Modern Office Space\nA stylish and private office room, perfect for focused work or one-on-one meetings, equipped with all the essentials for productivity.",
    address: "Hietaniemenkatu 4",
    postalCode: "00100",
    location: { x: 60.19651, y: 24.958585 },
    n: 60.19651,
    e: 24.958558,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 33,
    rent: 396,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 7,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimitilat Oy",
    email: "landlord042@sopia.io",
    contactPersonFirstName: "Essi",
    contactPersonLastName: "Leppälä",
    phoneNumber: "0506136858",
    language: "Finnish, English",
    description: "Well-Equipped Office\nThree fully-equipped rooms with modern amenities, creating an ideal setting for work, meetings, and brainstorming sessions.",
    address: "Hietaniemenkatu 5b",
    postalCode: "00100",
    location: { x: 60.20450, y: 24.957795 },
    n: 60.20450,
    e: 24.957579,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1740787200000),
    size: 76,
    rent: 3040,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 7,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimitilat Oy",
    email: "landlord042@sopia.io",
    contactPersonFirstName: "Elsi",
    contactPersonLastName: "Kulo",
    phoneNumber: "0590007683",
    language: "Finnish, English",
    description: "Tailored for Productivity\nA 3-room office designed with productivity in mind, featuring a quiet workspace, meeting room, and a collaborative area.",
    address: "Hietaniemenkatu 8",
    postalCode: "00100",
    location: { x: 60.19854, y: 24.957965 },
    n: 60.19854,
    e: 24.957596,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1740787200000),
    size: 90,
    rent: 3600,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 7,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimitilat Oy",
    email: "landlord043@sopia.io",
    contactPersonFirstName: "Erja",
    contactPersonLastName: "Hiekka",
    phoneNumber: "0530412961",
    language: "Finnish, Swedish",
    description: "Cozy Office Corner\nA compact yet functional office room, offering a cozy environment to concentrate and meet with clients in a professional setting.",
    address: "Hiekkarannantie 13",
    postalCode: "00100",
    location: { x: 60.23458, y: 24.947615 },
    n: 60.23458,
    e: 24.947561,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 28,
    rent: 1120,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 7,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimitilat Oy",
    email: "landlord043@sopia.io",
    contactPersonFirstName: "Jimi",
    contactPersonLastName: "Hildén",
    phoneNumber: "0463937731",
    language: "Finnish, English",
    description: "A spacious four-room office offering a perfect blend of privacy and collaboration, designed to enhance productivity and creativity in a professional setting.\n\n\n",
    address: "Hiekkarannantie 5",
    postalCode: "00100",
    location: { x: 60.16258, y: 24.949685 },
    n: 60.16258,
    e: 24.949568,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [4],
    whenAvailable: new Date(1740787200000),
    size: 81,
    rent: 3240,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimitilat Oy",
    email: "landlord044@sopia.io",
    contactPersonFirstName: "Hilppa",
    contactPersonLastName: "Paatela",
    phoneNumber: "0406567494",
    language: "Finnish, English",
    description: "A cozy, well-lit two-room office offering privacy and productivity",
    address: "Hertanmäenkatu 4",
    postalCode: "00240",
    location: { x: 60.16577, y: 24.956905 },
    n: 60.16577,
    e: 24.956590,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 57,
    rent: 2280,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimitilat Oy",
    email: "landlord044@sopia.io",
    contactPersonFirstName: "Elna",
    contactPersonLastName: "Kataja",
    phoneNumber: "0547332841",
    language: "Finnish, English",
    description: "Compact & Professional\nA compact office with three rooms, perfect for small teams needing a private, yet collaborative space to work and meet.",
    address: "Kellosaarenkatu 7",
    postalCode: "00180",
    location: { x: 60.21850, y: 24.950305 },
    n: 60.21850,
    e: 24.950530,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1740787200000),
    size: 90,
    rent: 1800,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 7,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimitilat Oy",
    email: "landlord045@sopia.io",
    contactPersonFirstName: "Helmi",
    contactPersonLastName: "Nuorpuu",
    phoneNumber: "0523596430",
    language: "Finnish, English",
    description: "Creative Work Environment\nA flexible office room that fosters creativity, with stylish furniture and a layout designed for both individual and collaborative tasks.",
    address: "Kellosaarenkatu 9",
    postalCode: "00180",
    location: { x: 60.22053, y: 24.949815 },
    n: 60.22053,
    e: 24.949581,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 30,
    rent: 600,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimitilat Oy",
    email: "landlord045@sopia.io",
    contactPersonFirstName: "Helvi",
    contactPersonLastName: "Pohjanpää",
    phoneNumber: "0509784364",
    language: "Finnish, English",
    description: "Bright and Spacious Room\nA well-lit office with large windows, providing a comfortable space for work or creative thinking, designed for maximum comfort.",
    address: "Kellosaarenranta 2",
    postalCode: "00180",
    location: { x: 60.20953, y: 24.951425 },
    n: 60.20953,
    e: 24.951542,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 31,
    rent: 620,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimitilat Oy",
    email: "landlord046@sopia.io",
    contactPersonFirstName: "Jimi",
    contactPersonLastName: "Hildén",
    phoneNumber: "0404872910",
    language: "Finnish, English",
    description: "A spacious two-room office designed for comfort and efficient work",
    address: "Kellosaarenranta 5",
    postalCode: "00180",
    location: { x: 60.21156, y: 24.949705 },
    n: 60.21156,
    e: 24.949570,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 53,
    rent: 1060,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimitilat Oy",
    email: "landlord046@sopia.io",
    contactPersonFirstName: "Joonas",
    contactPersonLastName: "Hällström",
    phoneNumber: "0519337235",
    language: "Finnish, English",
    description: "A two-room office with stylish decor, ideal for professionals and teams",
    address: "Kellosaarenranta 7",
    postalCode: "00180",
    location: { x: 60.21059, y: 24.949085 },
    n: 60.21059,
    e: 24.949508,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 40,
    rent: 1000,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimistotilat Helsinki Oy",
    email: "landlord047@sopia.io",
    contactPersonFirstName: "Joona",
    contactPersonLastName: "Hällberg\/Hälleberg",
    phoneNumber: "0575823950",
    language: "Finnish, English",
    description: "A modern two-room office with a balance of personal space and collaboration",
    address: "Kalevankatu 54",
    postalCode: "00180",
    location: { x: 60.22251, y: 24.959025 },
    n: 60.22251,
    e: 24.959502,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 40,
    rent: 1000,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimistotilat Helsinki Oy",
    email: "landlord047@sopia.io",
    contactPersonFirstName: "Helga",
    contactPersonLastName: "Saarnio",
    phoneNumber: "0575199303",
    language: "Finnish, English",
    description: "Elegant Workspace\nA tastefully decorated office room with contemporary furnishings, providing an ideal setting for individual work or client consultations.\nEfficient & Practical\nA well-organized office room, offering a productive environment with a desk, comfortable seating, and plenty of storage space.",
    address: "Kalevankatu 56a",
    postalCode: "00180",
    location: { x: 60.21856, y: 24.958475 },
    n: 60.21856,
    e: 24.958547,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 30,
    rent: 750,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimistotilat Helsinki Oy",
    email: "landlord048@sopia.io",
    contactPersonFirstName: "Hilda",
    contactPersonLastName: "Niitemaa",
    phoneNumber: "0508233501",
    language: "Finnish, English, Swedish",
    description: "A flexible two-room office with plenty of room for meetings and personal work",
    address: "Kalevankatu 57",
    postalCode: "00180",
    location: { x: 60.22851, y: 24.958975 },
    n: 60.22851,
    e: 24.958597,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 54,
    rent: 1350,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimistotilat Helsinki Oy",
    email: "landlord048@sopia.io",
    contactPersonFirstName: "Hanna",
    contactPersonLastName: "Liro",
    phoneNumber: "0424696838",
    language: "Finnish, Swedish",
    description: "A roomy four-room office combining privacy and collaborative spaces, designed to boost productivity and creativity in a professional environment.",
    address: "Lahnalahdentie 1",
    postalCode: "00200",
    location: { x: 60.22357, y: 24.927615 },
    n: 60.22357,
    e: 24.927561,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [4],
    whenAvailable: new Date(1740787200000),
    size: 72,
    rent: 1800,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimistotilat Helsinki Oy",
    email: "landlord049@sopia.io",
    contactPersonFirstName: "Hilkka",
    contactPersonLastName: "Järventaus",
    phoneNumber: "0582328370",
    language: "Finnish, English",
    description: "A cozy, well-lit two-room office offering privacy and productivity",
    address: "Lahnalahdentie 4",
    postalCode: "00200",
    location: { x: 60.23450, y: 24.925855 },
    n: 60.23450,
    e: 24.925585,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 50,
    rent: 1500,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimistotilat Helsinki Oy",
    email: "landlord049@sopia.io",
    contactPersonFirstName: "Jaakob",
    contactPersonLastName: "Heerman",
    phoneNumber: "0411003769",
    language: "Finnish, English",
    description: "A spacious two-room office designed for comfort and efficient work",
    address: "Lahnaruohontie 1",
    postalCode: "00200",
    location: { x: 60.18058, y: 24.929515 },
    n: 60.18058,
    e: 24.929551,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 46,
    rent: 1380,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Furnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimistotilat Helsinki Oy",
    email: "landlord050@sopia.io",
    contactPersonFirstName: "Hellin",
    contactPersonLastName: "Muroma",
    phoneNumber: "0421502168",
    language: "Finnish, English",
    description: "A versatile two-room office perfect for both work and meetings",
    address: "Lahnaruohontie 2",
    postalCode: "00200",
    location: { x: 60.18559, y: 24.928955 },
    n: 60.18559,
    e: 24.928595,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 43,
    rent: 860,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimistotilat Helsinki Oy",
    email: "landlord050@sopia.io",
    contactPersonFirstName: "Iida",
    contactPersonLastName: "Osmonsalo",
    phoneNumber: "0489979975",
    language: "Finnish, English",
    description: "A modern two-room office with a balance of personal space and collaboration",
    address: "Lahnaruohontie 4",
    postalCode: "00200",
    location: { x: 60.18957, y: 24.928975 },
    n: 60.18957,
    e: 24.928597,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 55,
    rent: 1375,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimistotilat Helsinki Oy",
    email: "landlord051@sopia.io",
    contactPersonFirstName: "Janne",
    contactPersonLastName: "Helenius",
    phoneNumber: "0513540744",
    language: "Finnish, Swedish",
    description: "Sleek & Modern Design\nWith clean lines and minimalist decor, this 3-room office offers a stylish yet functional environment for all your business needs.",
    address: "Lahnaruohontie 6",
    postalCode: "00200",
    location: { x: 60.19454, y: 24.929075 },
    n: 60.19454,
    e: 24.929507,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1740787200000),
    size: 96,
    rent: 2400,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimistotilat Helsinki Oy",
    email: "landlord051@sopia.io",
    contactPersonFirstName: "Elna",
    contactPersonLastName: "Kataja",
    phoneNumber: "0536559796",
    language: "Finnish, Swedish",
    description: "Bright & Inviting Space\nNatural light floods through large windows, illuminating the contemporary furnishings in each of the three rooms, creating an open, airy feel.",
    address: "Lahnaruohontie 8",
    postalCode: "00200",
    location: { x: 60.20053, y: 24.929165 },
    n: 60.20053,
    e: 24.929516,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1740787200000),
    size: 78,
    rent: 1560,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimistotilat Helsinki Oy",
    email: "landlord052@sopia.io",
    contactPersonFirstName: "Helga",
    contactPersonLastName: "Saarnio",
    phoneNumber: "0554692361",
    language: "Finnish, English",
    description: "A cozy, well-lit two-room office offering privacy and productivity",
    address: "Lastenkodin kuja 3",
    postalCode: "00180",
    location: { x: 60.16456, y: 24.958935 },
    n: 60.16456,
    e: 24.958593,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 48,
    rent: 960,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimistotilat Helsinki Oy",
    email: "landlord052@sopia.io",
    contactPersonFirstName: "Juha",
    contactPersonLastName: "Jernberg",
    phoneNumber: "0596475461",
    language: "Finnish, English",
    description: "This expansive four-room office offers a seamless balance of privacy and teamwork, ideal for fostering both focus and innovation.",
    address: "Lastenkodinkatu 11",
    postalCode: "00180",
    location: { x: 60.16157, y: 24.957735 },
    n: 60.16157,
    e: 24.957573,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [4],
    whenAvailable: new Date(1740787200000),
    size: 105,
    rent: 4200,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimistotilat Helsinki Oy",
    email: "landlord053@sopia.io",
    contactPersonFirstName: "Hille",
    contactPersonLastName: "Suolahti",
    phoneNumber: "0491395649",
    language: "Finnish, English",
    description: "A flexible two-room office with plenty of room for meetings and personal work",
    address: "Maamonlahdentie 3",
    postalCode: "00200",
    location: { x: 60.25551, y: 24.933095 },
    n: 60.25551,
    e: 24.933509,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 50,
    rent: 2000,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimistotilat Helsinki Oy",
    email: "landlord053@sopia.io",
    contactPersonFirstName: "Elviira",
    contactPersonLastName: "Lahdensuo",
    phoneNumber: "0496831535",
    language: "Finnish, Swedish",
    description: "A well-designed four-room office that blends private workspaces with areas for collaboration, optimizing productivity and creativity.",
    address: "Mannerheimintie 19a",
    postalCode: "00250",
    location: { x: 60.16053, y: 24.957875 },
    n: 60.16053,
    e: 24.957587,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [4],
    whenAvailable: new Date(1740787200000),
    size: 107,
    rent: 2140,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 5,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimistotilat Helsinki Oy",
    email: "landlord054@sopia.io",
    contactPersonFirstName: "Henni",
    contactPersonLastName: "Laitakari",
    phoneNumber: "0573288515",
    language: "Finnish, English",
    description: "Modern Office Space\nA stylish and private office room, perfect for focused work or one-on-one meetings, equipped with all the essentials for productivity.",
    address: "Mannerheimintie 20",
    postalCode: "00100",
    location: { x: 60.19256, y: 24.965735 },
    n: 60.19256,
    e: 24.965573,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 45,
    rent: 540,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimistotilat Helsinki Oy",
    email: "landlord054@sopia.io",
    contactPersonFirstName: "Iines",
    contactPersonLastName: "Reenkola",
    phoneNumber: "0532563649",
    language: "Finnish, English",
    description: "Chic & Professional Atmosphere\nThe modern design features neutral tones, elegant wood finishes, and modern lighting, providing a sophisticated setting across three rooms.",
    address: "Nousiaistentie 2",
    postalCode: "00280",
    location: { x: 60.16284, y: 24.947465 },
    n: 60.16284,
    e: 24.947546,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1740787200000),
    size: 73,
    rent: 876,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 5,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimistotilat Helsinki Oy",
    email: "landlord055@sopia.io",
    contactPersonFirstName: "Jalmari",
    contactPersonLastName: "Helander",
    phoneNumber: "0480189560",
    language: "Finnish, English",
    description: "A spacious two-room office designed for comfort and efficient work",
    address: "Nousiaistentie 4",
    postalCode: "00280",
    location: { x: 60.16285, y: 24.947905 },
    n: 60.16285,
    e: 24.947590,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 60,
    rent: 720,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 5,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimistotilat Helsinki Oy",
    email: "landlord055@sopia.io",
    contactPersonFirstName: "Hellä",
    contactPersonLastName: "Nevanlinna",
    phoneNumber: "0426566108",
    language: "Finnish, English",
    description: "Professional and Quiet\nA quiet, private office ideal for uninterrupted work, with sleek furniture and a minimalist design for a clear mind.",
    address: "Nousiaistentie 6",
    postalCode: "00280",
    location: { x: 60.16285, y: 24.948335 },
    n: 60.16285,
    e: 24.948533,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 32,
    rent: 384,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimistotilat Helsinki Oy",
    email: "landlord056@sopia.io",
    contactPersonFirstName: "Helga",
    contactPersonLastName: "Saarnio",
    phoneNumber: "0470006216",
    language: "Finnish, English",
    description: "A versatile two-room office perfect for both work and meetings",
    address: "Nousiaistentie 8",
    postalCode: "00280",
    location: { x: 60.16285, y: 24.948805 },
    n: 60.16285,
    e: 24.948580,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 52,
    rent: 624,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 5,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimistotilat Helsinki Oy",
    email: "landlord056@sopia.io",
    contactPersonFirstName: "Hillevi",
    contactPersonLastName: "Salmenoja",
    phoneNumber: "0463863164",
    language: "Finnish, English",
    description: "Creative Work Environment\nA flexible office room that fosters creativity, with stylish furniture and a layout designed for both individual and collaborative tasks.",
    address: "Oikokatu 3",
    postalCode: "00170",
    location: { x: 60.25055, y: 24.974675 },
    n: 60.25055,
    e: 24.974567,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 23,
    rent: 276,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 5,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimistotilat Helsinki Oy",
    email: "landlord057@sopia.io",
    contactPersonFirstName: "Jesse",
    contactPersonLastName: "Hidén",
    phoneNumber: "0559755036",
    language: "Finnish, English",
    description: "Cozy Office Corner\nA compact yet functional office room, offering a cozy environment to concentrate and meet with clients in a professional setting.",
    address: "Oikokatu 5",
    postalCode: "00170",
    location: { x: 60.25058, y: 24.975115 },
    n: 60.25058,
    e: 24.975511,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 40,
    rent: 480,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 5,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimistotilat Helsinki Oy",
    email: "landlord057@sopia.io",
    contactPersonFirstName: "Joel",
    contactPersonLastName: "Hoffrén",
    phoneNumber: "0520042882",
    language: "Finnish, English",
    description: "Contemporary Office Elegance\nA harmonious blend of sleek furniture and soft lighting, creating a welcoming yet professional atmosphere across the three rooms.",
    address: "Oikokatu 6-8",
    postalCode: "00170",
    location: { x: 60.25650, y: 24.974845 },
    n: 60.25650,
    e: 24.974584,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1740787200000),
    size: 85,
    rent: 1020,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Furnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimistotilat Helsinki Oy",
    email: "landlord058@sopia.io",
    contactPersonFirstName: "Joose",
    contactPersonLastName: "Hällström\/Hellström",
    phoneNumber: "0480606161",
    language: "Finnish, English",
    description: "A spacious four-room office, perfectly balancing private areas and collaborative spaces, crafted to elevate productivity and creativity.",
    address: "Oksasenkatu 7",
    postalCode: "00100",
    location: { x: 60.16452, y: 24.957695 },
    n: 60.16452,
    e: 24.957569,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [4],
    whenAvailable: new Date(1740787200000),
    size: 110,
    rent: 1320,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimistotilat Helsinki Oy",
    email: "landlord058@sopia.io",
    contactPersonFirstName: "Joakim",
    contactPersonLastName: "Hildén",
    phoneNumber: "0447091951",
    language: "Finnish, English, Swedish",
    description: "A roomy four-room office combining privacy and collaborative spaces, designed to boost productivity and creativity in a professional environment.",
    address: "Oksasenkatu 9",
    postalCode: "00100",
    location: { x: 60.16753, y: 24.957585 },
    n: 60.16753,
    e: 24.957558,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [4],
    whenAvailable: new Date(1740787200000),
    size: 87,
    rent: 1044,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 5,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimistotilat Helsinki Oy",
    email: "landlord059@sopia.io",
    contactPersonFirstName: "Jere",
    contactPersonLastName: "Hellman",
    phoneNumber: "0469594846",
    language: "Finnish, Swedish",
    description: "Bright and Spacious Room\nA well-lit office with large windows, providing a comfortable space for work or creative thinking, designed for maximum comfort.",
    address: "Olavinkatu 2",
    postalCode: "00100",
    location: { x: 60.20651, y: 24.962735 },
    n: 60.20651,
    e: 24.962573,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 25,
    rent: 300,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimistotilat Helsinki Oy",
    email: "landlord059@sopia.io",
    contactPersonFirstName: "Emmi",
    contactPersonLastName: "Leikola",
    phoneNumber: "0548296630",
    language: "Finnish, English",
    description: "A two-room office with stylish decor, ideal for professionals and teams",
    address: "Oksakoskenpolku 6",
    postalCode: "00250",
    location: { x: 60.20855, y: 24.944195 },
    n: 60.20855,
    e: 24.944519,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 40,
    rent: 480,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Toimistotilat Helsinki Oy",
    email: "landlord060@sopia.io",
    contactPersonFirstName: "Helvi",
    contactPersonLastName: "Pohjanpää",
    phoneNumber: "0489825781",
    language: "Finnish, English",
    description: "Elegant Workspace\nA tastefully decorated office room with contemporary furnishings, providing an ideal setting for individual work or client consultations.\nEfficient & Practical\nA well-organized office room, offering a productive environment with a desk, comfortable seating, and plenty of storage space.",
    address: "Oksasenkatu 2a",
    postalCode: "00100",
    location: { x: 60.24259, y: 24.957765 },
    n: 60.24259,
    e: 24.957576,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 30,
    rent: 600,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistöt Oy",
    email: "landlord060@sopia.io",
    contactPersonFirstName: "Elmi",
    contactPersonLastName: "Kulomäki",
    phoneNumber: "0484267267",
    language: "Finnish, English",
    description: "A cozy, well-lit two-room office offering privacy and productivity",
    address: "Oksasenkatu 2b",
    postalCode: "00100",
    location: { x: 60.24557, y: 24.957645 },
    n: 60.24557,
    e: 24.957564,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 46,
    rent: 920,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistöt Oy",
    email: "landlord061@sopia.io",
    contactPersonFirstName: "Jouni",
    contactPersonLastName: "Jansson",
    phoneNumber: "0541670035",
    language: "Finnish, English",
    description: "A two-room office with stylish decor, ideal for professionals and teams",
    address: "Oksasenkatu 4a",
    postalCode: "00100",
    location: { x: 60.25056, y: 24.957595 },
    n: 60.25056,
    e: 24.957559,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 44,
    rent: 880,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistöt Oy",
    email: "landlord061@sopia.io",
    contactPersonFirstName: "Henriikka",
    contactPersonLastName: "Airila",
    phoneNumber: "0584733493",
    language: "Finnish, Swedish",
    description: "Vibrant & Creative Workspace\nBold color accents and unique design elements in every room inspire creativity, while maintaining a professional and polished look.",
    address: "Oksasenkatu 5",
    postalCode: "00100",
    location: { x: 60.16156, y: 24.957785 },
    n: 60.16156,
    e: 24.957578,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1740787200000),
    size: 93,
    rent: 1860,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistöt Oy",
    email: "landlord062@sopia.io",
    contactPersonFirstName: "Helena",
    contactPersonLastName: "Louhivuori",
    phoneNumber: "0562625014",
    language: "Finnish, Swedish",
    description: "Modern Office Space\nA stylish and private office room, perfect for focused work or one-on-one meetings, equipped with all the essentials for productivity.",
    address: "Paciuksenkaari 3",
    postalCode: "00270",
    location: { x: 60.16010, y: 24.943735 },
    n: 60.16010,
    e: 24.943573,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 29,
    rent: 580,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistöt Oy",
    email: "landlord062@sopia.io",
    contactPersonFirstName: "Elsi",
    contactPersonLastName: "Kulo",
    phoneNumber: "0433697611",
    language: "Finnish, English",
    description: "Efficient & Practical\nA well-organized office room, offering a productive environment with a desk, comfortable seating, and plenty of storage space.",
    address: "Paciuksenkaari 4",
    postalCode: "00270",
    location: { x: 60.19459, y: 24.943485 },
    n: 60.19459,
    e: 24.943548,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 29,
    rent: 580,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistöt Oy",
    email: "landlord063@sopia.io",
    contactPersonFirstName: "Jonne",
    contactPersonLastName: "Holmberg",
    phoneNumber: "0425261860",
    language: "Finnish, English",
    description: "We offer a collaborative and innovative workspace designed to foster creativity and growth.",
    address: "Paciuksenkaari 6",
    postalCode: "00270",
    location: { x: 60.19153, y: 24.942955 },
    n: 60.19153,
    e: 24.942595,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1740787200000),
    size: 67,
    rent: 1340,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistöt Oy",
    email: "landlord063@sopia.io",
    contactPersonFirstName: "Hellin",
    contactPersonLastName: "Muroma",
    phoneNumber: "0537494342",
    language: "Finnish, English",
    description: "A versatile two-room office perfect for both work and meetings",
    address: "Paciuksenkaari 8",
    postalCode: "00270",
    location: { x: 60.19057, y: 24.942555 },
    n: 60.19057,
    e: 24.942555,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 60,
    rent: 720,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistöt Oy",
    email: "landlord064@sopia.io",
    contactPersonFirstName: "Hertta",
    contactPersonLastName: "Nuorvala",
    phoneNumber: "0552190202",
    language: "Finnish, Swedish",
    description: "Creative Work Environment\nA flexible office room that fosters creativity, with stylish furniture and a layout designed for both individual and collaborative tasks.",
    address: "Paciuksenkatu 19",
    postalCode: "00270",
    location: { x: 60.17053, y: 24.941165 },
    n: 60.17053,
    e: 24.941516,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 35,
    rent: 420,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Furnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistöt Oy",
    email: "landlord064@sopia.io",
    contactPersonFirstName: "Jousia",
    contactPersonLastName: "Jernberg",
    phoneNumber: "0424616491",
    language: "Finnish, English",
    description: "A flexible two-room office with plenty of room for meetings and personal work",
    address: "Paciuksenkatu 25",
    postalCode: "00270",
    location: { x: 60.17852, y: 24.940355 },
    n: 60.17852,
    e: 24.940535,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 51,
    rent: 612,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistöt Oy",
    email: "landlord065@sopia.io",
    contactPersonFirstName: "Jimi",
    contactPersonLastName: "Hildén",
    phoneNumber: "0503994629",
    language: "Finnish, English",
    description: "A modern two-room office with a balance of personal space and collaboration",
    address: "Paciuksenkatu 29",
    postalCode: "00270",
    location: { x: 60.18650, y: 24.939545 },
    n: 60.18650,
    e: 24.939554,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 55,
    rent: 660,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistöt Oy",
    email: "landlord065@sopia.io",
    contactPersonFirstName: "Jalo",
    contactPersonLastName: "Helander",
    phoneNumber: "0572164882",
    language: "Finnish, English",
    description: "Cozy Office Corner\nA compact yet functional office room, offering a cozy environment to concentrate and meet with clients in a professional setting.",
    address: "Paciuksenkatu 7",
    postalCode: "00270",
    location: { x: 60.24351, y: 24.944645 },
    n: 60.24351,
    e: 24.944564,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 32,
    rent: 640,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistöt Oy",
    email: "landlord066@sopia.io",
    contactPersonFirstName: "Joni",
    contactPersonLastName: "Hohenthal",
    phoneNumber: "0529425770",
    language: "Finnish, English",
    description: "This expansive four-room office offers a seamless balance of privacy and teamwork, ideal for fostering both focus and innovation.",
    address: "Paciuksenkuja 10",
    postalCode: "00270",
    location: { x: 60.16006, y: 24.943165 },
    n: 60.16006,
    e: 24.943516,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [4],
    whenAvailable: new Date(1740787200000),
    size: 78,
    rent: 1560,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistöt Oy",
    email: "landlord066@sopia.io",
    contactPersonFirstName: "Heljä",
    contactPersonLastName: "Mela",
    phoneNumber: "0494803337",
    language: "Finnish, English",
    description: "Bright and Spacious Room\nA well-lit office with large windows, providing a comfortable space for work or creative thinking, designed for maximum comfort.",
    address: "Paciuksenkuja 1",
    postalCode: "00270",
    location: { x: 60.19750, y: 24.943185 },
    n: 60.19750,
    e: 24.943518,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 22,
    rent: 440,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistöt Oy",
    email: "landlord067@sopia.io",
    contactPersonFirstName: "Helinä",
    contactPersonLastName: "Malmivaara",
    phoneNumber: "0491660413",
    language: "Finnish, English",
    description: "A spacious two-room office designed for comfort and efficient work",
    address: "Paciuksenkuja 3",
    postalCode: "00270",
    location: { x: 60.19852, y: 24.943435 },
    n: 60.19852,
    e: 24.943543,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 59,
    rent: 1180,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistöt Oy",
    email: "landlord067@sopia.io",
    contactPersonFirstName: "Iiris",
    contactPersonLastName: "Sotavalta",
    phoneNumber: "0541769543",
    language: "Finnish, English",
    description: "A cozy, well-lit two-room office offering privacy and productivity",
    address: "Paciuksenkuja 5",
    postalCode: "00270",
    location: { x: 60.19959, y: 24.943435 },
    n: 60.19959,
    e: 24.943543,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 47,
    rent: 940,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistöt Oy",
    email: "landlord068@sopia.io",
    contactPersonFirstName: "Jori",
    contactPersonLastName: "Ingman",
    phoneNumber: "0501517695",
    language: "Finnish, English",
    description: "A two-room office with stylish decor, ideal for professionals and teams",
    address: "Paciuksenkuja 7",
    postalCode: "00270",
    location: { x: 60.16016, y: 24.943515 },
    n: 60.16016,
    e: 24.943551,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 60,
    rent: 1200,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistöt Oy",
    email: "landlord068@sopia.io",
    contactPersonFirstName: "Henriikka",
    contactPersonLastName: "Airila",
    phoneNumber: "0569433947",
    language: "Finnish, English",
    description: "A functional two-room office that supports both individual work and group collaboration",
    address: "Pohjoiskaari 36",
    postalCode: "00200",
    location: { x: 60.23159, y: 24.936985 },
    n: 60.23159,
    e: 24.936598,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 54,
    rent: 1080,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistöt Oy",
    email: "landlord069@sopia.io",
    contactPersonFirstName: "Jaakko",
    contactPersonLastName: "Harberg",
    phoneNumber: "0475663329",
    language: "Finnish, English, Swedish",
    description: "Elegant Workspace\nA tastefully decorated office room with contemporary furnishings, providing an ideal setting for individual work or client consultations.\nEfficient & Practical\nA well-organized office room, offering a productive environment with a desk, comfortable seating, and plenty of storage space.",
    address: "Pohjoiskaari 39",
    postalCode: "00200",
    location: { x: 60.23954, y: 24.934365 },
    n: 60.23954,
    e: 24.934536,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 38,
    rent: 760,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistöt Oy",
    email: "landlord069@sopia.io",
    contactPersonFirstName: "Jesse",
    contactPersonLastName: "Hidén",
    phoneNumber: "0421872034",
    language: "Finnish, Swedish",
    description: "Creative Work Environment\nA flexible office room that fosters creativity, with stylish furniture and a layout designed for both individual and collaborative tasks.",
    address: "Pohjoiskaari 4",
    postalCode: "00200",
    location: { x: 60.18057, y: 24.940015 },
    n: 60.18057,
    e: 24.940501,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 37,
    rent: 1480,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistöt Oy",
    email: "landlord070@sopia.io",
    contactPersonFirstName: "Elsi",
    contactPersonLastName: "Kulo",
    phoneNumber: "0529029297",
    language: "Finnish, English",
    description: "Compact & Professional\nA compact office with three rooms, perfect for small teams needing a private, yet collaborative space to work and meet.",
    address: "Pohjoiskaari 5",
    postalCode: "00200",
    location: { x: 60.19250, y: 24.940545 },
    n: 60.19250,
    e: 24.940554,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1740787200000),
    size: 60,
    rent: 2400,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Excellent",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistöt Oy",
    email: "landlord070@sopia.io",
    contactPersonFirstName: "Jousia",
    contactPersonLastName: "Jernberg",
    phoneNumber: "0585284909",
    language: "Finnish, English",
    description: "A flexible two-room office with plenty of room for meetings and personal work",
    address: "Pohjoiskaari 7",
    postalCode: "00200",
    location: { x: 60.19554, y: 24.940775 },
    n: 60.19554,
    e: 24.940577,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 50,
    rent: 2000,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistöt Oy",
    email: "landlord071@sopia.io",
    contactPersonFirstName: "Jarno",
    contactPersonLastName: "Helin",
    phoneNumber: "0563012822",
    language: "Finnish, English",
    description: "A cozy, well-lit two-room office offering privacy and productivity",
    address: "Pohjoiskaari 8",
    postalCode: "00200",
    location: { x: 60.19152, y: 24.939985 },
    n: 60.19152,
    e: 24.939598,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 51,
    rent: 2040,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistöt Oy",
    email: "landlord071@sopia.io",
    contactPersonFirstName: "Hilppa",
    contactPersonLastName: "Paatela",
    phoneNumber: "0576665667",
    language: "Finnish, English",
    description: "Chic & Professional Atmosphere\nThe modern design features neutral tones, elegant wood finishes, and modern lighting, providing a sophisticated setting across three rooms.",
    address: "Abrahaminkatu 6",
    postalCode: "00180",
    location: { x: 60.24051, y: 24.960175 },
    n: 60.24051,
    e: 24.960517,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1740787200000),
    size: 66,
    rent: 2640,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistöt Oy",
    email: "landlord072@sopia.io",
    contactPersonFirstName: "Juha",
    contactPersonLastName: "Jernberg",
    phoneNumber: "0439133714",
    language: "Finnish, Swedish",
    description: "A spacious two-room office designed for comfort and efficient work",
    address: "Abrahaminkatu 8",
    postalCode: "00180",
    location: { x: 60.24451, y: 24.959875 },
    n: 60.24451,
    e: 24.959587,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 44,
    rent: 1760,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistöt Oy",
    email: "landlord072@sopia.io",
    contactPersonFirstName: "Ester",
    contactPersonLastName: "Koskelo",
    phoneNumber: "0584678186",
    language: "Finnish, Swedish",
    description: "Vibrant & Creative Workspace\nBold color accents and unique design elements in every room inspire creativity, while maintaining a professional and polished look.",
    address: "Ainonkatu 2",
    postalCode: "00100",
    location: { x: 60.22053, y: 24.962515 },
    n: 60.22053,
    e: 24.962551,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1740787200000),
    size: 72,
    rent: 2880,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 1,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Satisfying",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistöt Oy",
    email: "landlord073@sopia.io",
    contactPersonFirstName: "Jani",
    contactPersonLastName: "Helenius",
    phoneNumber: "0568684096",
    language: "Finnish, English",
    description: "A spacious four-room office offering a perfect blend of privacy and collaboration, designed to enhance productivity and creativity in a professional setting.",
    address: "Ainonkatu 4",
    postalCode: "00100",
    location: { x: 60.21955, y: 24.962245 },
    n: 60.21955,
    e: 24.962524,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [4],
    whenAvailable: new Date(1740787200000),
    size: 76,
    rent: 912,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 1,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Sun toimitila Oy",
    email: "landlord073@sopia.io",
    contactPersonFirstName: "Helle",
    contactPersonLastName: "Mannermaa",
    phoneNumber: "0588654221",
    language: "Finnish, English",
    description: "A modern two-room office with a balance of personal space and collaboration",
    address: "Albertinkatu 1",
    postalCode: "00150",
    location: { x: 60.18850, y: 24.967075 },
    n: 60.18850,
    e: 24.967507,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 45,
    rent: 540,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Sun toimitila Oy",
    email: "landlord074@sopia.io",
    contactPersonFirstName: "Hilma",
    contactPersonLastName: "Paalu",
    phoneNumber: "0496529943",
    language: "Finnish, English",
    description: "A cozy, well-lit two-room office offering privacy and productivity",
    address: "Albertinkatu 12",
    postalCode: "00150",
    location: { x: 60.19951, y: 24.965375 },
    n: 60.19951,
    e: 24.965537,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 45,
    rent: 540,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Excellent",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Sun toimitila Oy",
    email: "landlord074@sopia.io",
    contactPersonFirstName: "Heljä",
    contactPersonLastName: "Mela",
    phoneNumber: "0458273472",
    language: "Finnish, Swedish",
    description: "A functional two-room office that supports both individual work and group collaboration",
    address: "Albertinkatu 14",
    postalCode: "00120",
    location: { x: 60.20356, y: 24.965125 },
    n: 60.20356,
    e: 24.965512,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 57,
    rent: 684,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Sun toimitila Oy",
    email: "landlord075@sopia.io",
    contactPersonFirstName: "Iida",
    contactPersonLastName: "Osmonsalo",
    phoneNumber: "0515324012",
    language: "Finnish, English",
    description: "A spacious two-room office designed for comfort and efficient work",
    address: "Bulevardi 31",
    postalCode: "00180",
    location: { x: 60.22456, y: 24.961975 },
    n: 60.22456,
    e: 24.961597,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 54,
    rent: 648,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Sun toimitila Oy",
    email: "landlord075@sopia.io",
    contactPersonFirstName: "Esteri",
    contactPersonLastName: "Apajalahti",
    phoneNumber: "0435446378",
    language: "Finnish, English",
    description: "We offer a collaborative and innovative workspace designed to foster creativity and growth.",
    address: "Bulevardi 34a",
    postalCode: "00120",
    location: { x: 60.22353, y: 24.963475 },
    n: 60.22353,
    e: 24.963547,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1740787200000),
    size: 98,
    rent: 1960,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Sun toimitila Oy",
    email: "landlord076@sopia.io",
    contactPersonFirstName: "Helena",
    contactPersonLastName: "Louhivuori",
    phoneNumber: "0460573176",
    language: "Finnish, English",
    description: "Modern Office Space\nA stylish and private office room, perfect for focused work or one-on-one meetings, equipped with all the essentials for productivity.",
    address: "Bulevardi 40",
    postalCode: "00120",
    location: { x: 60.21851, y: 24.962525 },
    n: 60.21851,
    e: 24.962552,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 40,
    rent: 800,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 1,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Satisfying",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Sun toimitila Oy",
    email: "landlord076@sopia.io",
    contactPersonFirstName: "Elsi",
    contactPersonLastName: "Kulo",
    phoneNumber: "0509715531",
    language: "Finnish, English",
    description: "A two-room office with stylish decor, ideal for professionals and teams",
    address: "Bulevardi 4",
    postalCode: "00120",
    location: { x: 60.25755, y: 24.968375 },
    n: 60.25755,
    e: 24.968537,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 50,
    rent: 600,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Sun toimitila Oy",
    email: "landlord077@sopia.io",
    contactPersonFirstName: "Eveliina",
    contactPersonLastName: "Linko",
    phoneNumber: "0461394512",
    language: "Finnish, English",
    description: "Cozy Office Corner\nA compact yet functional office room, offering a cozy environment to concentrate and meet with clients in a professional setting.",
    address: "Caloniuksenkatu 1",
    postalCode: "00100",
    location: { x: 60.24059, y: 24.955515 },
    n: 60.24059,
    e: 24.955551,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 21,
    rent: 420,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Furnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Sun toimitila Oy",
    email: "landlord077@sopia.io",
    contactPersonFirstName: "Enni",
    contactPersonLastName: "Niini",
    phoneNumber: "0410024433",
    language: "Finnish, English",
    description: "A cozy, well-lit two-room office offering privacy and productivity",
    address: "Caloniuksenkatu 3",
    postalCode: "00100",
    location: { x: 60.24357, y: 24.955685 },
    n: 60.24357,
    e: 24.955568,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 58,
    rent: 1160,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Sun toimitila Oy",
    email: "landlord078@sopia.io",
    contactPersonFirstName: "Justus",
    contactPersonLastName: "Johnsson",
    phoneNumber: "0402524659",
    language: "Finnish, English",
    description: "Professional and Quiet\nA quiet, private office ideal for uninterrupted work, with sleek furniture and a minimalist design for a clear mind.",
    address: "Caloniuksenkatu 5",
    postalCode: "00100",
    location: { x: 60.24654, y: 24.955935 },
    n: 60.24654,
    e: 24.955593,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 21,
    rent: 420,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Sun toimitila Oy",
    email: "landlord078@sopia.io",
    contactPersonFirstName: "Jami",
    contactPersonLastName: "Helenius",
    phoneNumber: "0560273255",
    language: "Finnish, English",
    description: "Elegant Workspace\nA tastefully decorated office room with contemporary furnishings, providing an ideal setting for individual work or client consultations.\nEfficient & Practical\nA well-organized office room, offering a productive environment with a desk, comfortable seating, and plenty of storage space.",
    address: "Caloniuksenkatu 7",
    postalCode: "00100",
    location: { x: 60.24955, y: 24.956135 },
    n: 60.24955,
    e: 24.956513,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 45,
    rent: 900,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Sun toimitila Oy",
    email: "landlord079@sopia.io",
    contactPersonFirstName: "Hannele",
    contactPersonLastName: "Merikoski",
    phoneNumber: "0511976246",
    language: "Finnish, English",
    description: "A modern two-room office with a balance of personal space and collaboration",
    address: "Caloniuksenkatu 9",
    postalCode: "00100",
    location: { x: 60.25255, y: 24.956515 },
    n: 60.25255,
    e: 24.956551,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 57,
    rent: 1140,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Sun toimitila Oy",
    email: "landlord079@sopia.io",
    contactPersonFirstName: "Hilma",
    contactPersonLastName: "Paalu",
    phoneNumber: "0406326785",
    language: "Finnish, English, Swedish",
    description: "A flexible two-room office with plenty of room for meetings and personal work",
    address: "Dunckerinkatu 2",
    postalCode: "00260",
    location: { x: 60.19451, y: 24.960395 },
    n: 60.19451,
    e: 24.960539,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1743465600000),
    size: 46,
    rent: 552,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Good",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Sun toimitila Oy",
    email: "landlord080@sopia.io",
    contactPersonFirstName: "Hannele",
    contactPersonLastName: "Merikoski",
    phoneNumber: "0548673192",
    language: "Finnish, Swedish",
    description: "A functional two-room office that supports both individual work and group collaboration",
    address: "Döbelninkatu 1",
    postalCode: "00260",
    location: { x: 60.19355, y: 24.958105 },
    n: 60.19355,
    e: 24.958510,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1743465600000),
    size: 44,
    rent: 528,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Sun toimitila Oy",
    email: "landlord080@sopia.io",
    contactPersonFirstName: "Joosef",
    contactPersonLastName: "Hästesko",
    phoneNumber: "0425296591",
    language: "Finnish, English",
    description: "Modern 3-Room Office Suite\nA sleek office with three distinct rooms, including a private office, meeting space, and a collaborative work area.",
    address: "Döbelninkatu 3a",
    postalCode: "00260",
    location: { x: 60.19259, y: 24.957865 },
    n: 60.19259,
    e: 24.957586,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1743465600000),
    size: 62,
    rent: 744,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Furnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Sun toimitila Oy",
    email: "landlord081@sopia.io",
    contactPersonFirstName: "Jarkko",
    contactPersonLastName: "Helenius",
    phoneNumber: "0550743489",
    language: "Finnish, English",
    description: "A cozy, well-lit two-room office offering privacy and productivity",
    address: "Eino Leinon katu 3",
    postalCode: "00250",
    location: { x: 60.25754, y: 24.955825 },
    n: 60.25754,
    e: 24.955582,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1743465600000),
    size: 44,
    rent: 528,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Satisfying",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Sun toimitila Oy",
    email: "landlord081@sopia.io",
    contactPersonFirstName: "Helmi",
    contactPersonLastName: "Nuorpuu",
    phoneNumber: "0582091006",
    language: "Finnish, English",
    description: "A roomy four-room office combining privacy and collaborative spaces, designed to boost productivity and creativity in a professional environment.",
    address: "Eino Leinon katu 7",
    postalCode: "00250",
    location: { x: 60.25756, y: 24.955095 },
    n: 60.25756,
    e: 24.955509,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [4],
    whenAvailable: new Date(1743465600000),
    size: 111,
    rent: 1332,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Sun toimitila Oy",
    email: "landlord082@sopia.io",
    contactPersonFirstName: "Hellä",
    contactPersonLastName: "Nevanlinna",
    phoneNumber: "0449848584",
    language: "Finnish, English",
    description: "Tailored for Productivity\nA 3-room office designed with productivity in mind, featuring a quiet workspace, meeting room, and a collaborative area.",
    address: "Eiranranta 3",
    postalCode: "00150",
    location: { x: 60.23752, y: 24.963065 },
    n: 60.23752,
    e: 24.963506,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1743465600000),
    size: 74,
    rent: 888,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 10,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Sun toimitila Oy",
    email: "landlord082@sopia.io",
    contactPersonFirstName: "Jarno",
    contactPersonLastName: "Helin",
    phoneNumber: "0578442048",
    language: "Finnish, Swedish",
    description: "A spacious two-room office designed for comfort and efficient work",
    address: "Eiranranta 7",
    postalCode: "00150",
    location: { x: 60.23056, y: 24.962035 },
    n: 60.23056,
    e: 24.962503,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1743465600000),
    size: 46,
    rent: 552,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Sun toimitila Oy",
    email: "landlord083@sopia.io",
    contactPersonFirstName: "Jonne",
    contactPersonLastName: "Holmberg",
    phoneNumber: "0571463517",
    language: "Finnish, Swedish",
    description: "A two-room office with stylish decor, ideal for professionals and teams",
    address: "Elisabeth Koch vägen - Ruskeasuon siirtolapuutarha 61",
    postalCode: "00280",
    location: { x: 60.16886, y: 24.946055 },
    n: 60.16886,
    e: 24.946505,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1743465600000),
    size: 50,
    rent: 600,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 10,
    furnished: "Furnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Sun toimitila Oy",
    email: "landlord083@sopia.io",
    contactPersonFirstName: "Heidi",
    contactPersonLastName: "Niinistö",
    phoneNumber: "0517251196",
    language: "Finnish, English",
    description: "Bright & Inviting Space\nNatural light floods through large windows, illuminating the contemporary furnishings in each of the three rooms, creating an open, airy feel.",
    address: "Elisabeth Koch vägen - Ruskeasuon siirtolapuutarha 63",
    postalCode: "00280",
    location: { x: 60.16920, y: 24.946395 },
    n: 60.16920,
    e: 24.946539,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1743465600000),
    size: 90,
    rent: 1080,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 10,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Excellent",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Sun toimitila Oy",
    email: "landlord084@sopia.io",
    contactPersonFirstName: "Erja",
    contactPersonLastName: "Hiekka",
    phoneNumber: "0412692570",
    language: "Finnish, English",
    description: "Creative Work Environment\nA flexible office room that fosters creativity, with stylish furniture and a layout designed for both individual and collaborative tasks.",
    address: "Fabianinkatu 7",
    postalCode: "00130",
    location: { x: 60.23655, y: 24.972375 },
    n: 60.23655,
    e: 24.972537,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1743465600000),
    size: 26,
    rent: 312,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Sun toimitila Oy",
    email: "landlord084@sopia.io",
    contactPersonFirstName: "Iiris",
    contactPersonLastName: "Sotavalta",
    phoneNumber: "0443978293",
    language: "Finnish, English",
    description: "Modern Office Space\nA stylish and private office room, perfect for focused work or one-on-one meetings, equipped with all the essentials for productivity.",
    address: "Fabianinkatu 9",
    postalCode: "00130",
    location: { x: 60.24050, y: 24.972375 },
    n: 60.24050,
    e: 24.972537,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1743465600000),
    size: 20,
    rent: 240,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Sun toimitila Oy",
    email: "landlord085@sopia.io",
    contactPersonFirstName: "Esteri",
    contactPersonLastName: "Apajalahti",
    phoneNumber: "0487881634",
    language: "Finnish, Swedish",
    description: "A modern two-room office with a balance of personal space and collaboration",
    address: "Fabianinkatu 20",
    postalCode: "00100",
    location: { x: 60.19757, y: 24.971525 },
    n: 60.19757,
    e: 24.971552,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1743465600000),
    size: 59,
    rent: 708,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Sun toimitila Oy",
    email: "landlord085@sopia.io",
    contactPersonFirstName: "Juho",
    contactPersonLastName: "Johansson",
    phoneNumber: "0562372521",
    language: "Finnish, English",
    description: "Efficient & Practical\nA well-organized office room, offering a productive environment with a desk, comfortable seating, and plenty of storage space.",
    address: "Fabianinkatu 21",
    postalCode: "00130",
    location: { x: 60.16055, y: 24.972385 },
    n: 60.16055,
    e: 24.972538,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1743465600000),
    size: 39,
    rent: 468,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 10,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Excellent",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Sun toimitila Oy",
    email: "landlord086@sopia.io",
    contactPersonFirstName: "Heidi",
    contactPersonLastName: "Niinistö",
    phoneNumber: "0572796600",
    language: "Finnish, English",
    description: "Vibrant & Creative Workspace\nBold color accents and unique design elements in every room inspire creativity, while maintaining a professional and polished look.",
    address: "Fabianinkatu 23",
    postalCode: "00130",
    location: { x: 60.16355, y: 24.972235 },
    n: 60.16355,
    e: 24.972523,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1743465600000),
    size: 84,
    rent: 1680,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Sun toimitila Oy",
    email: "landlord086@sopia.io",
    contactPersonFirstName: "Jalmari",
    contactPersonLastName: "Helander",
    phoneNumber: "0529450772",
    language: "Finnish, English",
    description: "Cozy Office Corner\nA compact yet functional office room, offering a cozy environment to concentrate and meet with clients in a professional setting.",
    address: "Fabianinkatu 24",
    postalCode: "00100",
    location: { x: 60.20853, y: 24.971505 },
    n: 60.20853,
    e: 24.971550,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1743465600000),
    size: 24,
    rent: 480,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Sun toimitila Oy",
    email: "landlord087@sopia.io",
    contactPersonFirstName: "Juhani",
    contactPersonLastName: "Järnström",
    phoneNumber: "0597453685",
    language: "Finnish, English",
    description: "Bright and Spacious Room\nA well-lit office with large windows, providing a comfortable space for work or creative thinking, designed for maximum comfort.",
    address: "Fabianinkatu 26",
    postalCode: "00100",
    location: { x: 60.21151, y: 24.971315 },
    n: 60.21151,
    e: 24.971531,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1743465600000),
    size: 20,
    rent: 400,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 10,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Sun toimitila Oy",
    email: "landlord087@sopia.io",
    contactPersonFirstName: "Henriikka",
    contactPersonLastName: "Airila",
    phoneNumber: "0503091118",
    language: "Finnish, English",
    description: "Comfortable & Functional\nFive spacious rooms designed for comfort and productivity, with dedicated areas for focused work, team meetings, and client visits.",
    address: "Fabianinkatu 28",
    postalCode: "00100",
    location: { x: 60.21452, y: 24.971485 },
    n: 60.21452,
    e: 24.971548,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [5],
    whenAvailable: new Date(1743465600000),
    size: 115,
    rent: 2300,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Sun toimitila Oy",
    email: "landlord088@sopia.io",
    contactPersonFirstName: "Julius",
    contactPersonLastName: "Johansson",
    phoneNumber: "0563879662",
    language: "Finnish, English",
    description: "A spacious two-room office designed for comfort and efficient work",
    address: "Fabianinkatu 30",
    postalCode: "00100",
    location: { x: 60.21654, y: 24.971185 },
    n: 60.21654,
    e: 24.971518,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1743465600000),
    size: 46,
    rent: 552,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 10,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Sun toimitila Oy",
    email: "landlord088@sopia.io",
    contactPersonFirstName: "Johannes",
    contactPersonLastName: "Hoffrén",
    phoneNumber: "0408870705",
    language: "Finnish, English",
    description: "Elegant Workspace\nA tastefully decorated office room with contemporary furnishings, providing an ideal setting for individual work or client consultations.\nEfficient & Practical\nA well-organized office room, offering a productive environment with a desk, comfortable seating, and plenty of storage space.",
    address: "Gyldénintie 1",
    postalCode: "00200",
    location: { x: 60.17453, y: 24.932345 },
    n: 60.17453,
    e: 24.932534,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1743465600000),
    size: 32,
    rent: 384,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 5,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Excellent",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Sun toimitila Oy",
    email: "landlord089@sopia.io",
    contactPersonFirstName: "Jami",
    contactPersonLastName: "Helenius",
    phoneNumber: "0575912588",
    language: "Finnish, English",
    description: "Efficient & Practical\nA well-organized office room, offering a productive environment with a desk, comfortable seating, and plenty of storage space.",
    address: "Gyldénintie 13",
    postalCode: "00200",
    location: { x: 60.20455, y: 24.932535 },
    n: 60.20455,
    e: 24.932553,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1743465600000),
    size: 38,
    rent: 456,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Sun toimitila Oy",
    email: "landlord089@sopia.io",
    contactPersonFirstName: "Hilkka",
    contactPersonLastName: "Järventaus",
    phoneNumber: "0421294065",
    language: "Finnish, English",
    description: "Modern Office Space\nA stylish and private office room, perfect for focused work or one-on-one meetings, equipped with all the essentials for productivity.",
    address: "Gyldénintie 15",
    postalCode: "00200",
    location: { x: 60.21155, y: 24.932595 },
    n: 60.21155,
    e: 24.932559,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1743465600000),
    size: 25,
    rent: 300,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 5,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Sun toimitila Oy",
    email: "landlord090@sopia.io",
    contactPersonFirstName: "Jimi",
    contactPersonLastName: "Hildén",
    phoneNumber: "0463113047",
    language: "Finnish, English, Swedish",
    description: "Compact & Professional\nA compact office with three rooms, perfect for small teams needing a private, yet collaborative space to work and meet.",
    address: "Gyldénintie 2a",
    postalCode: "00200",
    location: { x: 60.17851, y: 24.931585 },
    n: 60.17851,
    e: 24.931558,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1743465600000),
    size: 71,
    rent: 852,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 5,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Excellent",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Sun toimitila Oy",
    email: "landlord090@sopia.io",
    contactPersonFirstName: "Jalo",
    contactPersonLastName: "Helander",
    phoneNumber: "0573786045",
    language: "Finnish, Swedish",
    description: "A flexible two-room office with plenty of room for meetings and personal work",
    address: "Gyldénintie 4",
    postalCode: "00200",
    location: { x: 60.18651, y: 24.931615 },
    n: 60.18651,
    e: 24.931561,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1743465600000),
    size: 52,
    rent: 624,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Satisfying",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Sun toimitila Oy",
    email: "landlord091@sopia.io",
    contactPersonFirstName: "Enni",
    contactPersonLastName: "Niini",
    phoneNumber: "0514804207",
    language: "Finnish, English",
    description: "Cozy Office Corner\nA compact yet functional office room, offering a cozy environment to concentrate and meet with clients in a professional setting.",
    address: "Gyldénintie 6",
    postalCode: "00200",
    location: { x: 60.19357, y: 24.931755 },
    n: 60.19357,
    e: 24.931575,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1743465600000),
    size: 24,
    rent: 288,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord091@sopia.io",
    contactPersonFirstName: "Jonni",
    contactPersonLastName: "Holmström",
    phoneNumber: "0584791379",
    language: "Finnish, English",
    description: "A cozy, well-lit two-room office offering privacy and productivity",
    address: "Erottajankatu 1-3",
    postalCode: "00130",
    location: { x: 60.23858, y: 24.969115 },
    n: 60.23858,
    e: 24.969511,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1743465600000),
    size: 59,
    rent: 708,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Excellent",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord092@sopia.io",
    contactPersonFirstName: "Jaakoppi",
    contactPersonLastName: "Heikel",
    phoneNumber: "0506136858",
    language: "Finnish, English",
    description: "A two-room office with stylish decor, ideal for professionals and teams",
    address: "Haahkakuja 3",
    postalCode: "00200",
    location: { x: 60.25251, y: 24.930975 },
    n: 60.25251,
    e: 24.930597,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1743465600000),
    size: 44,
    rent: 528,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Satisfying",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord092@sopia.io",
    contactPersonFirstName: "Jonne",
    contactPersonLastName: "Holmberg",
    phoneNumber: "0590007683",
    language: "Finnish, English",
    description: "A flexible two-room office with plenty of room for meetings and personal work",
    address: "Haahkakuja 7",
    postalCode: "00200",
    location: { x: 60.16455, y: 24.931155 },
    n: 60.16455,
    e: 24.931515,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1743465600000),
    size: 41,
    rent: 492,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord093@sopia.io",
    contactPersonFirstName: "Elma",
    contactPersonLastName: "Kairamo",
    phoneNumber: "0530412961",
    language: "Finnish, Swedish",
    description: "Creative Work Environment\nA flexible office room that fosters creativity, with stylish furniture and a layout designed for both individual and collaborative tasks.",
    address: "Haahkapolku 1",
    postalCode: "00200",
    location: { x: 60.24955, y: 24.932415 },
    n: 60.24955,
    e: 24.932541,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1743465600000),
    size: 20,
    rent: 240,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 5,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Excellent",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord093@sopia.io",
    contactPersonFirstName: "Hilla",
    contactPersonLastName: "Suviranta",
    phoneNumber: "0463937731",
    language: "Finnish, Swedish",
    description: "Professional and Quiet\nA quiet, private office ideal for uninterrupted work, with sleek furniture and a minimalist design for a clear mind.",
    address: "Haahkapolku 3",
    postalCode: "00200",
    location: { x: 60.24352, y: 24.932145 },
    n: 60.24352,
    e: 24.932514,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1743465600000),
    size: 33,
    rent: 825,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 5,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord094@sopia.io",
    contactPersonFirstName: "Jaakob",
    contactPersonLastName: "Heerman",
    phoneNumber: "0406567494",
    language: "Finnish, English",
    description: "Chic & Professional Atmosphere\nThe modern design features neutral tones, elegant wood finishes, and modern lighting, providing a sophisticated setting across three rooms.",
    address: "Haahkatie 1",
    postalCode: "00200",
    location: { x: 60.25954, y: 24.933945 },
    n: 60.25954,
    e: 24.933594,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1743465600000),
    size: 79,
    rent: 1975,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 0,
    furnished: "Furnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord094@sopia.io",
    contactPersonFirstName: "Janne",
    contactPersonLastName: "Helenius",
    phoneNumber: "0547332841",
    language: "Finnish, English",
    description: "Elegant Workspace\nA tastefully decorated office room with contemporary furnishings, providing an ideal setting for individual work or client consultations.\nEfficient & Practical\nA well-organized office room, offering a productive environment with a desk, comfortable seating, and plenty of storage space.",
    address: "Haahkatie 12",
    postalCode: "00200",
    location: { x: 60.24955, y: 24.932415 },
    n: 60.24955,
    e: 24.932541,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1743465600000),
    size: 44,
    rent: 1100,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord095@sopia.io",
    contactPersonFirstName: "Jalo",
    contactPersonLastName: "Helander",
    phoneNumber: "0523596430",
    language: "Finnish, English",
    description: "We offer a collaborative and innovative workspace designed to foster creativity and growth.",
    address: "Haahkatie 14",
    postalCode: "00200",
    location: { x: 60.24859, y: 24.931945 },
    n: 60.24859,
    e: 24.931594,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1743465600000),
    size: 89,
    rent: 2225,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Satisfying",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord095@sopia.io",
    contactPersonFirstName: "Juho",
    contactPersonLastName: "Johansson",
    phoneNumber: "0509784364",
    language: "Finnish, Swedish",
    description: "A spacious two-room office designed for comfort and efficient work",
    address: "Helsinginkatu 56",
    postalCode: "00260",
    location: { x: 60.24157, y: 24.961895 },
    n: 60.24157,
    e: 24.961589,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1743465600000),
    size: 60,
    rent: 1500,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord096@sopia.io",
    contactPersonFirstName: "Hilma",
    contactPersonLastName: "Paalu",
    phoneNumber: "0404872910",
    language: "Finnish, English",
    description: "Efficient & Practical\nA well-organized office room, offering a productive environment with a desk, comfortable seating, and plenty of storage space.",
    address: "Heikinniementie 11",
    postalCode: "00250",
    location: { x: 60.24053, y: 24.937695 },
    n: 60.24053,
    e: 24.937569,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1743465600000),
    size: 24,
    rent: 600,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord096@sopia.io",
    contactPersonFirstName: "Helle",
    contactPersonLastName: "Mannermaa",
    phoneNumber: "0519337235",
    language: "Finnish, English",
    description: "A modern two-room office with a balance of personal space and collaboration",
    address: "Heikinniementie 3",
    postalCode: "00250",
    location: { x: 60.22358, y: 24.939075 },
    n: 60.22358,
    e: 24.939507,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1743465600000),
    size: 46,
    rent: 552,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord097@sopia.io",
    contactPersonFirstName: "Johannes",
    contactPersonLastName: "Hoffrén",
    phoneNumber: "0575823950",
    language: "Finnish, English",
    description: "A functional two-room office that supports both individual work and group collaboration",
    address: "Heikinniementie 4a",
    postalCode: "00250",
    location: { x: 60.22258, y: 24.938265 },
    n: 60.22258,
    e: 24.938526,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1743465600000),
    size: 54,
    rent: 648,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord097@sopia.io",
    contactPersonFirstName: "Jaakko",
    contactPersonLastName: "Harberg",
    phoneNumber: "0575199303",
    language: "Finnish, English",
    description: "A sleek and contemporary two-room office with ample natural light",
    address: "Heikinniementie 6",
    postalCode: "00250",
    location: { x: 60.23452, y: 24.937115 },
    n: 60.23452,
    e: 24.937511,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1743465600000),
    size: 52,
    rent: 624,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord098@sopia.io",
    contactPersonFirstName: "Hilppa",
    contactPersonLastName: "Paatela",
    phoneNumber: "0508233501",
    language: "Finnish, English",
    description: "Vibrant & Creative Workspace\nBold color accents and unique design elements in every room inspire creativity, while maintaining a professional and polished look.",
    address: "Heikinniementie 9",
    postalCode: "00250",
    location: { x: 60.23554, y: 24.938185 },
    n: 60.23554,
    e: 24.938518,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1743465600000),
    size: 99,
    rent: 1188,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord098@sopia.io",
    contactPersonFirstName: "Jukka",
    contactPersonLastName: "Johansson",
    phoneNumber: "0424696838",
    language: "Finnish, English",
    description: "Creative Work Environment\nA flexible office room that fosters creativity, with stylish furniture and a layout designed for both individual and collaborative tasks.",
    address: "Heikkilänaukio 2",
    postalCode: "00210",
    location: { x: 60.21857, y: 24.933845 },
    n: 60.21857,
    e: 24.933584,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1743465600000),
    size: 24,
    rent: 288,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord099@sopia.io",
    contactPersonFirstName: "Henriikka",
    contactPersonLastName: "Airila",
    phoneNumber: "0582328370",
    language: "Finnish, English",
    description: "A cozy, well-lit two-room office offering privacy and productivity",
    address: "Heikkilänpolku 1",
    postalCode: "00210",
    location: { x: 60.23358, y: 24.933305 },
    n: 60.23358,
    e: 24.933530,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1743465600000),
    size: 53,
    rent: 636,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord099@sopia.io",
    contactPersonFirstName: "Hellä",
    contactPersonLastName: "Nevanlinna",
    phoneNumber: "0411003769",
    language: "Finnish, English",
    description: "Modern Office Space\nA stylish and private office room, perfect for focused work or one-on-one meetings, equipped with all the essentials for productivity.",
    address: "Heikkilänpolku 4",
    postalCode: "00210",
    location: { x: 60.23256, y: 24.932725 },
    n: 60.23256,
    e: 24.932572,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1743465600000),
    size: 28,
    rent: 336,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord100@sopia.io",
    contactPersonFirstName: "Hely",
    contactPersonLastName: "Nuorivaara",
    phoneNumber: "0421502168",
    language: "Finnish, English",
    description: "A two-room office with stylish decor, ideal for professionals and teams",
    address: "Heikkiläntie 1",
    postalCode: "00210",
    location: { x: 60.23252, y: 24.934225 },
    n: 60.23252,
    e: 24.934522,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1743465600000),
    size: 47,
    rent: 564,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord100@sopia.io",
    contactPersonFirstName: "Helinä",
    contactPersonLastName: "Malmivaara",
    phoneNumber: "0489979975",
    language: "Finnish, English, Swedish",
    description: "Cozy Office Corner\nA compact yet functional office room, offering a cozy environment to concentrate and meet with clients in a professional setting.",
    address: "Heikkiläntie 2",
    postalCode: "00210",
    location: { x: 60.22856, y: 24.933025 },
    n: 60.22856,
    e: 24.933502,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1743465600000),
    size: 28,
    rent: 336,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord101@sopia.io",
    contactPersonFirstName: "Jaakko",
    contactPersonLastName: "Harberg",
    phoneNumber: "0513540744",
    language: "Finnish, Swedish",
    description: "Well-Equipped Office\nThree fully-equipped rooms with modern amenities, creating an ideal setting for work, meetings, and brainstorming sessions.",
    address: "Heikkiläntie 4",
    postalCode: "00210",
    location: { x: 60.23358, y: 24.933305 },
    n: 60.23358,
    e: 24.933530,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1743465600000),
    size: 65,
    rent: 780,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord101@sopia.io",
    contactPersonFirstName: "Hellevi",
    contactPersonLastName: "Miesmaa",
    phoneNumber: "0536559796",
    language: "Finnish, English",
    description: "Tailored for Productivity\nA 3-room office designed with productivity in mind, featuring a quiet workspace, meeting room, and a collaborative area.",
    address: "Heikkiläntie 7",
    postalCode: "00210",
    location: { x: 60.24755, y: 24.935975 },
    n: 60.24755,
    e: 24.935597,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1743465600000),
    size: 73,
    rent: 876,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord101@sopia.io",
    contactPersonFirstName: "Iiris",
    contactPersonLastName: "Sotavalta",
    phoneNumber: "0554692361",
    language: "Finnish, English",
    description: "Bright and Spacious Room\nA well-lit office with large windows, providing a comfortable space for work or creative thinking, designed for maximum comfort.",
    address: "Heino Kasken katu 2",
    postalCode: "00180",
    location: { x: 60.17157, y: 24.949785 },
    n: 60.17157,
    e: 24.949578,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1743465600000),
    size: 22,
    rent: 550,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord102@sopia.io",
    contactPersonFirstName: "Jaakkima",
    contactPersonLastName: "Hallsten",
    phoneNumber: "0596475461",
    language: "Finnish, English",
    description: "Creative Work Environment\nA flexible office room that fosters creativity, with stylish furniture and a layout designed for both individual and collaborative tasks.",
    address: "Heino Kasken katu 5",
    postalCode: "00180",
    location: { x: 60.16658, y: 24.949045 },
    n: 60.16658,
    e: 24.949504,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1743465600000),
    size: 30,
    rent: 750,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord102@sopia.io",
    contactPersonFirstName: "Jooa",
    contactPersonLastName: "Hultman",
    phoneNumber: "0491395649",
    language: "Finnish, English",
    description: "Bright & Inviting Space\nNatural light floods through large windows, illuminating the contemporary furnishings in each of the five rooms, creating an open, airy feel.",
    address: "Helenankatu 1",
    postalCode: "00170",
    location: { x: 60.18157, y: 24.975325 },
    n: 60.18157,
    e: 24.975532,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [5],
    whenAvailable: new Date(1743465600000),
    size: 102,
    rent: 2550,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord102@sopia.io",
    contactPersonFirstName: "Jesse",
    contactPersonLastName: "Hidén",
    phoneNumber: "0496831535",
    language: "Finnish, Swedish",
    description: "A spacious two-room office designed for comfort and efficient work",
    address: "Hietalahdenkatu 10",
    postalCode: "00180",
    location: { x: 60.22751, y: 24.959575 },
    n: 60.22751,
    e: 24.959557,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1743465600000),
    size: 55,
    rent: 1375,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord102@sopia.io",
    contactPersonFirstName: "Jesper",
    contactPersonLastName: "Herckman",
    phoneNumber: "0573288515",
    language: "Finnish, Swedish",
    description: "Modern Office Space\nA stylish and private office room, perfect for focused work or one-on-one meetings, equipped with all the essentials for productivity.",
    address: "Hietalahdenkatu 12",
    postalCode: "00180",
    location: { x: 60.23056, y: 24.959325 },
    n: 60.23056,
    e: 24.959532,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1743465600000),
    size: 31,
    rent: 372,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 1,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord103@sopia.io",
    contactPersonFirstName: "Juhani",
    contactPersonLastName: "Järnström",
    phoneNumber: "0532563649",
    language: "Finnish, Swedish",
    description: "Bright and Spacious Room\nA well-lit office with large windows, providing a comfortable space for work or creative thinking, designed for maximum comfort.",
    address: "Hietaniemenkatu 20",
    postalCode: "00100",
    location: { x: 60.23358, y: 24.949565 },
    n: 60.23358,
    e: 24.949556,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1743465600000),
    size: 31,
    rent: 372,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 1,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord103@sopia.io",
    contactPersonFirstName: "Jimi",
    contactPersonLastName: "Hildén",
    phoneNumber: "0480189560",
    language: "Finnish, Swedish",
    description: "Elegant Workspace\nA tastefully decorated office room with contemporary furnishings, providing an ideal setting for individual work or client consultations.\nEfficient & Practical\nA well-organized office room, offering a productive environment with a desk, comfortable seating, and plenty of storage space.",
    address: "Hietaniemenkatu 2",
    postalCode: "00100",
    location: { x: 60.19758, y: 24.958825 },
    n: 60.19758,
    e: 24.958582,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1743465600000),
    size: 30,
    rent: 360,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 1,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord103@sopia.io",
    contactPersonFirstName: "Hanna",
    contactPersonLastName: "Liro",
    phoneNumber: "0426566108",
    language: "Finnish, Swedish",
    description: "Compact & Professional\nA compact office with three rooms, perfect for small teams needing a private, yet collaborative space to work and meet.",
    address: "Hietaniemenkatu 27",
    postalCode: "00100",
    location: { x: 60.23157, y: 24.952045 },
    n: 60.23157,
    e: 24.952504,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1743465600000),
    size: 77,
    rent: 924,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord103@sopia.io",
    contactPersonFirstName: "Ester",
    contactPersonLastName: "Koskelo",
    phoneNumber: "0470006216",
    language: "Finnish, Swedish",
    description: "A flexible two-room office with plenty of room for meetings and personal work",
    address: "Hietaniemenkatu 4",
    postalCode: "00100",
    location: { x: 60.19651, y: 24.958585 },
    n: 60.19651,
    e: 24.958558,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1743465600000),
    size: 59,
    rent: 708,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord104@sopia.io",
    contactPersonFirstName: "Hely",
    contactPersonLastName: "Nuorivaara",
    phoneNumber: "0463863164",
    language: "Finnish, Swedish",
    description: "Professional and Quiet\nA quiet, private office ideal for uninterrupted work, with sleek furniture and a minimalist design for a clear mind.",
    address: "Hietaniemenkatu 5b",
    postalCode: "00100",
    location: { x: 60.20450, y: 24.957795 },
    n: 60.20450,
    e: 24.957579,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1743465600000),
    size: 41,
    rent: 492,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord104@sopia.io",
    contactPersonFirstName: "Jaakob",
    contactPersonLastName: "Heerman",
    phoneNumber: "0559755036",
    language: "Finnish, Swedish",
    description: "A modern two-room office with a balance of personal space and collaboration",
    address: "Hietaniemenkatu 8",
    postalCode: "00100",
    location: { x: 60.19854, y: 24.957965 },
    n: 60.19854,
    e: 24.957596,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1743465600000),
    size: 40,
    rent: 480,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord104@sopia.io",
    contactPersonFirstName: "Jesse",
    contactPersonLastName: "Hidén",
    phoneNumber: "0520042882",
    language: "Finnish, Swedish",
    description: "Modern 3-Room Office Suite\nA sleek office with three distinct rooms, including a private office, meeting space, and a collaborative work area.",
    address: "Hiekkarannantie 13",
    postalCode: "00100",
    location: { x: 60.23458, y: 24.947615 },
    n: 60.23458,
    e: 24.947561,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1743465600000),
    size: 62,
    rent: 744,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord104@sopia.io",
    contactPersonFirstName: "Esteri",
    contactPersonLastName: "Apajalahti",
    phoneNumber: "0480606161",
    language: "Finnish, English",
    description: "A two-room office with stylish decor, ideal for professionals and teams",
    address: "Hiekkarannantie 5",
    postalCode: "00100",
    location: { x: 60.16258, y: 24.949685 },
    n: 60.16258,
    e: 24.949568,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1743465600000),
    size: 43,
    rent: 516,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord105@sopia.io",
    contactPersonFirstName: "Elsa",
    contactPersonLastName: "Kurki-Suonio",
    phoneNumber: "0447091951",
    language: "Finnish, English",
    description: "Bright & Inviting Space\nNatural light floods through large windows, illuminating the contemporary furnishings in each of the three rooms, creating an open, airy feel.",
    address: "Hertanmäenkatu 4",
    postalCode: "00240",
    location: { x: 60.16577, y: 24.956905 },
    n: 60.16577,
    e: 24.956590,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1743465600000),
    size: 82,
    rent: 984,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord105@sopia.io",
    contactPersonFirstName: "Hellä",
    contactPersonLastName: "Nevanlinna",
    phoneNumber: "0469594846",
    language: "Finnish, English",
    description: "Sleek & Modern Design\nWith clean lines and minimalist decor, this 3-room office offers a stylish yet functional environment for all your business needs.",
    address: "Kellosaarenkatu 7",
    postalCode: "00180",
    location: { x: 60.21850, y: 24.950305 },
    n: 60.21850,
    e: 24.950530,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1743465600000),
    size: 74,
    rent: 888,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord105@sopia.io",
    contactPersonFirstName: "Heini",
    contactPersonLastName: "Sarva",
    phoneNumber: "0548296630",
    language: "Finnish, English",
    description: "Bright & Inviting Space\nNatural light floods through large windows, illuminating the contemporary furnishings in each of the three rooms, creating an open, airy feel.",
    address: "Kellosaarenkatu 9",
    postalCode: "00180",
    location: { x: 60.22053, y: 24.949815 },
    n: 60.22053,
    e: 24.949581,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1743465600000),
    size: 97,
    rent: 1164,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 5,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord105@sopia.io",
    contactPersonFirstName: "Ester",
    contactPersonLastName: "Koskelo",
    phoneNumber: "0489825781",
    language: "Finnish, English",
    description: "A cozy, well-lit two-room office offering privacy and productivity",
    address: "Kellosaarenranta 2",
    postalCode: "00180",
    location: { x: 60.20953, y: 24.951425 },
    n: 60.20953,
    e: 24.951542,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1743465600000),
    size: 42,
    rent: 504,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord106@sopia.io",
    contactPersonFirstName: "Elsi",
    contactPersonLastName: "Kulo",
    phoneNumber: "0484267267",
    language: "Finnish, English",
    description: "Efficient & Practical\nA well-organized office room, offering a productive environment with a desk, comfortable seating, and plenty of storage space.",
    address: "Kellosaarenranta 5",
    postalCode: "00180",
    location: { x: 60.21156, y: 24.949705 },
    n: 60.21156,
    e: 24.949570,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1743465600000),
    size: 32,
    rent: 384,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord106@sopia.io",
    contactPersonFirstName: "Hilppa",
    contactPersonLastName: "Paatela",
    phoneNumber: "0541670035",
    language: "Finnish, English",
    description: "A spacious two-room office designed for comfort and efficient work",
    address: "Kellosaarenranta 7",
    postalCode: "00180",
    location: { x: 60.21059, y: 24.949085 },
    n: 60.21059,
    e: 24.949508,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1743465600000),
    size: 47,
    rent: 564,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 5,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord106@sopia.io",
    contactPersonFirstName: "Iines",
    contactPersonLastName: "Reenkola",
    phoneNumber: "0584733493",
    language: "Finnish, English, Swedish",
    description: "A sleek and contemporary two-room office with ample natural light",
    address: "Kalevankatu 54",
    postalCode: "00180",
    location: { x: 60.22251, y: 24.959025 },
    n: 60.22251,
    e: 24.959502,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 46,
    rent: 552,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord106@sopia.io",
    contactPersonFirstName: "Juha",
    contactPersonLastName: "Jernberg",
    phoneNumber: "0562625014",
    language: "Finnish, Swedish",
    description: "A flexible two-room office with plenty of room for meetings and personal work",
    address: "Kalevankatu 56a",
    postalCode: "00180",
    location: { x: 60.21856, y: 24.958475 },
    n: 60.21856,
    e: 24.958547,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 45,
    rent: 1800,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord107@sopia.io",
    contactPersonFirstName: "Joel",
    contactPersonLastName: "Hoffrén",
    phoneNumber: "0433697611",
    language: "Finnish, English",
    description: "Modern Office Space\nA stylish and private office room, perfect for focused work or one-on-one meetings, equipped with all the essentials for productivity.",
    address: "Kalevankatu 57",
    postalCode: "00180",
    location: { x: 60.22851, y: 24.958975 },
    n: 60.22851,
    e: 24.958597,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 26,
    rent: 312,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord107@sopia.io",
    contactPersonFirstName: "Jooa",
    contactPersonLastName: "Hultman",
    phoneNumber: "0425261860",
    language: "Finnish, English",
    description: "Creative Work Environment\nA flexible office room that fosters creativity, with stylish furniture and a layout designed for both individual and collaborative tasks.",
    address: "Lahnalahdentie 1",
    postalCode: "00200",
    location: { x: 60.22357, y: 24.927615 },
    n: 60.22357,
    e: 24.927561,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 30,
    rent: 360,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 1,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord107@sopia.io",
    contactPersonFirstName: "Hilda",
    contactPersonLastName: "Niitemaa",
    phoneNumber: "0537494342",
    language: "Finnish, English",
    description: "Vibrant & Creative Workspace\nBold color accents and unique design elements in every room inspire creativity, while maintaining a professional and polished look.",
    address: "Lahnalahdentie 4",
    postalCode: "00200",
    location: { x: 60.23450, y: 24.925855 },
    n: 60.23450,
    e: 24.925585,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1738368000000),
    size: 66,
    rent: 792,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord107@sopia.io",
    contactPersonFirstName: "Emilia",
    contactPersonLastName: "Hirvensalo",
    phoneNumber: "0552190202",
    language: "Finnish, English",
    description: "Efficient & Practical\nA well-organized office room, offering a productive environment with a desk, comfortable seating, and plenty of storage space.",
    address: "Lahnaruohontie 1",
    postalCode: "00200",
    location: { x: 60.18058, y: 24.929515 },
    n: 60.18058,
    e: 24.929551,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 36,
    rent: 432,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Furnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord108@sopia.io",
    contactPersonFirstName: "Joakim",
    contactPersonLastName: "Hildén",
    phoneNumber: "0424616491",
    language: "Finnish, Swedish",
    description: "Versatile Office Space\nA 3-room office offering flexibility to accommodate both individual work and group collaboration, all within a professional environment.",
    address: "Lahnaruohontie 2",
    postalCode: "00200",
    location: { x: 60.18559, y: 24.928955 },
    n: 60.18559,
    e: 24.928595,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1738368000000),
    size: 93,
    rent: 1116,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 5,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord108@sopia.io",
    contactPersonFirstName: "Hanne",
    contactPersonLastName: "Loimaranta",
    phoneNumber: "0503994629",
    language: "Finnish, Swedish",
    description: "A two-room office with stylish decor, ideal for professionals and teams",
    address: "Lahnaruohontie 4",
    postalCode: "00200",
    location: { x: 60.18957, y: 24.928975 },
    n: 60.18957,
    e: 24.928597,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 42,
    rent: 504,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord108@sopia.io",
    contactPersonFirstName: "Hanna",
    contactPersonLastName: "Liro",
    phoneNumber: "0572164882",
    language: "Finnish, English",
    description: "A functional two-room office that supports both individual work and group collaboration",
    address: "Lahnaruohontie 6",
    postalCode: "00200",
    location: { x: 60.19454, y: 24.929075 },
    n: 60.19454,
    e: 24.929507,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 41,
    rent: 492,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord108@sopia.io",
    contactPersonFirstName: "Enna",
    contactPersonLastName: "Listo",
    phoneNumber: "0529425770",
    language: "Finnish, English",
    description: "Elegant Workspace\nA tastefully decorated office room with contemporary furnishings, providing an ideal setting for individual work or client consultations.\nEfficient & Practical\nA well-organized office room, offering a productive environment with a desk, comfortable seating, and plenty of storage space.",
    address: "Lahnaruohontie 8",
    postalCode: "00200",
    location: { x: 60.20053, y: 24.929165 },
    n: 60.20053,
    e: 24.929516,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 39,
    rent: 468,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 1,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord109@sopia.io",
    contactPersonFirstName: "Enni",
    contactPersonLastName: "Niini",
    phoneNumber: "0494803337",
    language: "Finnish, English",
    description: "Well-Equipped Office\nThree fully-equipped rooms with modern amenities, creating an ideal setting for work, meetings, and brainstorming sessions.",
    address: "Lastenkodin kuja 3",
    postalCode: "00180",
    location: { x: 60.16456, y: 24.958935 },
    n: 60.16456,
    e: 24.958593,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1738368000000),
    size: 68,
    rent: 816,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord109@sopia.io",
    contactPersonFirstName: "Iida",
    contactPersonLastName: "Osmonsalo",
    phoneNumber: "0491660413",
    language: "Finnish, Swedish",
    description: "Bright and Spacious Room\nA well-lit office with large windows, providing a comfortable space for work or creative thinking, designed for maximum comfort.",
    address: "Lastenkodinkatu 11",
    postalCode: "00180",
    location: { x: 60.16157, y: 24.957735 },
    n: 60.16157,
    e: 24.957573,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 42,
    rent: 1050,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 1,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord109@sopia.io",
    contactPersonFirstName: "Jiri",
    contactPersonLastName: "Hildén",
    phoneNumber: "0541769543",
    language: "Finnish, English",
    description: "Efficient & Practical\nA well-organized office room, offering a productive environment with a desk, comfortable seating, and plenty of storage space.",
    address: "Maamonlahdentie 3",
    postalCode: "00200",
    location: { x: 60.25551, y: 24.933095 },
    n: 60.25551,
    e: 24.933509,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 40,
    rent: 800,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 1,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["BOTTOM"],
    elevator: false,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord109@sopia.io",
    contactPersonFirstName: "Hilla",
    contactPersonLastName: "Suviranta",
    phoneNumber: "0501517695",
    language: "Finnish, English",
    description: "A cozy, well-lit two-room office offering privacy and productivity",
    address: "Mannerheimintie 19a",
    postalCode: "00250",
    location: { x: 60.16053, y: 24.957875 },
    n: 60.16053,
    e: 24.957587,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 56,
    rent: 1120,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord110@sopia.io",
    contactPersonFirstName: "Elmi",
    contactPersonLastName: "Kulomäki",
    phoneNumber: "0569433947",
    language: "Finnish, English",
    description: "A flexible two-room office with plenty of room for meetings and personal work",
    address: "Mannerheimintie 20",
    postalCode: "00100",
    location: { x: 60.19256, y: 24.965735 },
    n: 60.19256,
    e: 24.965573,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 41,
    rent: 820,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord110@sopia.io",
    contactPersonFirstName: "Enna",
    contactPersonLastName: "Listo",
    phoneNumber: "0475663329",
    language: "Finnish, English",
    description: "A spacious two-room office designed for comfort and efficient work",
    address: "Hietaniemenkatu 2",
    postalCode: "00100",
    location: { x: 60.19758, y: 24.958825 },
    n: 60.19758,
    e: 24.958582,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 48,
    rent: 960,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord110@sopia.io",
    contactPersonFirstName: "Erja",
    contactPersonLastName: "Hiekka",
    phoneNumber: "0421872034",
    language: "Finnish, English",
    description: "A sleek and contemporary two-room office with ample natural light",
    address: "Hietaniemenkatu 27",
    postalCode: "00100",
    location: { x: 60.23157, y: 24.952045 },
    n: 60.23157,
    e: 24.952504,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 40,
    rent: 800,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord110@sopia.io",
    contactPersonFirstName: "Henna",
    contactPersonLastName: "Nuorteva",
    phoneNumber: "0529029297",
    language: "Finnish, English",
    description: "Vibrant & Creative Workspace\nBold color accents and unique design elements in every room inspire creativity, while maintaining a professional and polished look.",
    address: "Nousiaistentie 2",
    postalCode: "00280",
    location: { x: 60.16284, y: 24.947465 },
    n: 60.16284,
    e: 24.947546,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1738368000000),
    size: 96,
    rent: 1152,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord111@sopia.io",
    contactPersonFirstName: "Joni",
    contactPersonLastName: "Hohenthal",
    phoneNumber: "0585284909",
    language: "Finnish, English",
    description: "We offer a collaborative and innovative workspace designed to foster creativity and growth.",
    address: "Nousiaistentie 4",
    postalCode: "00280",
    location: { x: 60.16285, y: 24.947905 },
    n: 60.16285,
    e: 24.947590,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [5],
    whenAvailable: new Date(1738368000000),
    size: 122,
    rent: 1464,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord111@sopia.io",
    contactPersonFirstName: "Elvi",
    contactPersonLastName: "Lehto",
    phoneNumber: "0563012822",
    language: "Finnish, English",
    description: "This expansive four-room office offers a seamless balance of privacy and teamwork, ideal for fostering both focus and innovation.",
    address: "Nousiaistentie 6",
    postalCode: "00280",
    location: { x: 60.16285, y: 24.948335 },
    n: 60.16285,
    e: 24.948533,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [4],
    whenAvailable: new Date(1738368000000),
    size: 85,
    rent: 1020,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord111@sopia.io",
    contactPersonFirstName: "Joose",
    contactPersonLastName: "Hällström\/Hellström",
    phoneNumber: "0576665667",
    language: "Finnish, English",
    description: "Elegant Workspace\nA tastefully decorated office room with contemporary furnishings, providing an ideal setting for individual work or client consultations.\nEfficient & Practical\nA well-organized office room, offering a productive environment with a desk, comfortable seating, and plenty of storage space.",
    address: "Nousiaistentie 8",
    postalCode: "00280",
    location: { x: 60.16285, y: 24.948805 },
    n: 60.16285,
    e: 24.948580,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 35,
    rent: 420,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 1,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord111@sopia.io",
    contactPersonFirstName: "Heta",
    contactPersonLastName: "Ilves",
    phoneNumber: "0439133714",
    language: "Finnish, English, Swedish",
    description: "Professional and Quiet\nA quiet, private office ideal for uninterrupted work, with sleek furniture and a minimalist design for a clear mind.",
    address: "Oikokatu 3",
    postalCode: "00170",
    location: { x: 60.25055, y: 24.974675 },
    n: 60.25055,
    e: 24.974567,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 42,
    rent: 504,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 1,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord112@sopia.io",
    contactPersonFirstName: "Hilla",
    contactPersonLastName: "Suviranta",
    phoneNumber: "0584678186",
    language: "Finnish, Swedish",
    description: "A cozy, well-lit two-room office offering privacy and productivity",
    address: "Oikokatu 5",
    postalCode: "00170",
    location: { x: 60.25058, y: 24.975115 },
    n: 60.25058,
    e: 24.975511,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 58,
    rent: 696,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord112@sopia.io",
    contactPersonFirstName: "Joonatan",
    contactPersonLastName: "Hällström, af Hällström",
    phoneNumber: "0568684096",
    language: "Finnish, English",
    description: "Efficient & Practical\nA well-organized office room, offering a productive environment with a desk, comfortable seating, and plenty of storage space.",
    address: "Oikokatu 6-8",
    postalCode: "00170",
    location: { x: 60.25650, y: 24.974845 },
    n: 60.25650,
    e: 24.974584,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 22,
    rent: 440,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord112@sopia.io",
    contactPersonFirstName: "Iina",
    contactPersonLastName: "Sotavalta",
    phoneNumber: "0588654221",
    language: "Finnish, English",
    description: "A two-room office with stylish decor, ideal for professionals and teams",
    address: "Oksasenkatu 7",
    postalCode: "00100",
    location: { x: 60.16452, y: 24.957695 },
    n: 60.16452,
    e: 24.957569,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 42,
    rent: 840,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord112@sopia.io",
    contactPersonFirstName: "Jalmari",
    contactPersonLastName: "Helander",
    phoneNumber: "0496529943",
    language: "Finnish, English",
    description: "A well-designed four-room office that blends private workspaces with areas for collaboration, optimizing productivity and creativity.",
    address: "Oksasenkatu 9",
    postalCode: "00100",
    location: { x: 60.16753, y: 24.957585 },
    n: 60.16753,
    e: 24.957558,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [4],
    whenAvailable: new Date(1738368000000),
    size: 78,
    rent: 936,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord113@sopia.io",
    contactPersonFirstName: "Enni",
    contactPersonLastName: "Niini",
    phoneNumber: "0458273472",
    language: "Finnish, English",
    description: "Modern Office Space\nA stylish and private office room, perfect for focused work or one-on-one meetings, equipped with all the essentials for productivity.",
    address: "Olavinkatu 2",
    postalCode: "00100",
    location: { x: 60.20651, y: 24.962735 },
    n: 60.20651,
    e: 24.962573,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 36,
    rent: 432,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord113@sopia.io",
    contactPersonFirstName: "Eveliina",
    contactPersonLastName: "Linko",
    phoneNumber: "0515324012",
    language: "Finnish, Swedish",
    description: "We offer a collaborative and innovative workspace designed to foster creativity and growth.",
    address: "Oksakoskenpolku 6",
    postalCode: "00250",
    location: { x: 60.20855, y: 24.944195 },
    n: 60.20855,
    e: 24.944519,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1738368000000),
    size: 89,
    rent: 1068,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord113@sopia.io",
    contactPersonFirstName: "Jesper",
    contactPersonLastName: "Herckman",
    phoneNumber: "0435446378",
    language: "Finnish, Swedish",
    description: "A spacious two-room office designed for comfort and efficient work",
    address: "Oksasenkatu 2a",
    postalCode: "00100",
    location: { x: 60.24259, y: 24.957765 },
    n: 60.24259,
    e: 24.957576,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 42,
    rent: 504,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord113@sopia.io",
    contactPersonFirstName: "Hertta",
    contactPersonLastName: "Nuorvala",
    phoneNumber: "0460573176",
    language: "Finnish, English",
    description: "Cozy Office Corner\nA compact yet functional office room, offering a cozy environment to concentrate and meet with clients in a professional setting.",
    address: "Oksasenkatu 2b",
    postalCode: "00100",
    location: { x: 60.24557, y: 24.957645 },
    n: 60.24557,
    e: 24.957564,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 33,
    rent: 396,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord114@sopia.io",
    contactPersonFirstName: "Jouni",
    contactPersonLastName: "Jansson",
    phoneNumber: "0509715531",
    language: "Finnish, English",
    description: "This expansive four-room office offers a seamless balance of privacy and teamwork, ideal for fostering both focus and innovation.",
    address: "Oksasenkatu 4a",
    postalCode: "00100",
    location: { x: 60.25056, y: 24.957595 },
    n: 60.25056,
    e: 24.957559,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [4],
    whenAvailable: new Date(1738368000000),
    size: 107,
    rent: 1284,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord114@sopia.io",
    contactPersonFirstName: "Julius",
    contactPersonLastName: "Johansson",
    phoneNumber: "0461394512",
    language: "Finnish, English",
    description: "Bright and Spacious Room\nA well-lit office with large windows, providing a comfortable space for work or creative thinking, designed for maximum comfort.",
    address: "Oksasenkatu 5",
    postalCode: "00100",
    location: { x: 60.16156, y: 24.957785 },
    n: 60.16156,
    e: 24.957578,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 20,
    rent: 240,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord114@sopia.io",
    contactPersonFirstName: "Hilma",
    contactPersonLastName: "Paalu",
    phoneNumber: "0410024433",
    language: "Finnish, Swedish",
    description: "A cozy, well-lit two-room office offering privacy and productivity",
    address: "Paciuksenkaari 3",
    postalCode: "00270",
    location: { x: 60.16010, y: 24.943735 },
    n: 60.16010,
    e: 24.943573,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 46,
    rent: 552,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord114@sopia.io",
    contactPersonFirstName: "Hertta",
    contactPersonLastName: "Nuorvala",
    phoneNumber: "0402524659",
    language: "Finnish, English",
    description: "Creative Work Environment\nA flexible office room that fosters creativity, with stylish furniture and a layout designed for both individual and collaborative tasks.",
    address: "Paciuksenkaari 4",
    postalCode: "00270",
    location: { x: 60.19459, y: 24.943485 },
    n: 60.19459,
    e: 24.943548,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 29,
    rent: 348,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord115@sopia.io",
    contactPersonFirstName: "Helinä",
    contactPersonLastName: "Malmivaara",
    phoneNumber: "0560273255",
    language: "Finnish, English",
    description: "Modern Office Space\nA stylish and private office room, perfect for focused work or one-on-one meetings, equipped with all the essentials for productivity.",
    address: "Paciuksenkaari 6",
    postalCode: "00270",
    location: { x: 60.19153, y: 24.942955 },
    n: 60.19153,
    e: 24.942595,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 21,
    rent: 252,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord115@sopia.io",
    contactPersonFirstName: "Erja",
    contactPersonLastName: "Hiekka",
    phoneNumber: "0511976246",
    language: "Finnish, English",
    description: "A spacious two-room office designed for comfort and efficient work",
    address: "Paciuksenkaari 8",
    postalCode: "00270",
    location: { x: 60.19057, y: 24.942555 },
    n: 60.19057,
    e: 24.942555,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 49,
    rent: 588,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord115@sopia.io",
    contactPersonFirstName: "Elma",
    contactPersonLastName: "Kairamo",
    phoneNumber: "0406326785",
    language: "Finnish, English",
    description: "A functional two-room office that supports both individual work and group collaboration",
    address: "Paciuksenkatu 19",
    postalCode: "00270",
    location: { x: 60.17053, y: 24.941165 },
    n: 60.17053,
    e: 24.941516,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 56,
    rent: 672,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord115@sopia.io",
    contactPersonFirstName: "Hilda",
    contactPersonLastName: "Niitemaa",
    phoneNumber: "0548673192",
    language: "Finnish, English",
    description: "Elegant Workspace\nA tastefully decorated office room with contemporary furnishings, providing an ideal setting for individual work or client consultations.\nEfficient & Practical\nA well-organized office room, offering a productive environment with a desk, comfortable seating, and plenty of storage space.",
    address: "Paciuksenkatu 25",
    postalCode: "00270",
    location: { x: 60.17852, y: 24.940355 },
    n: 60.17852,
    e: 24.940535,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 24,
    rent: 288,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord116@sopia.io",
    contactPersonFirstName: "Hilma",
    contactPersonLastName: "Paalu",
    phoneNumber: "0425296591",
    language: "Finnish, English",
    description: "Professional and Quiet\nA quiet, private office ideal for uninterrupted work, with sleek furniture and a minimalist design for a clear mind.",
    address: "Paciuksenkatu 29",
    postalCode: "00270",
    location: { x: 60.18650, y: 24.939545 },
    n: 60.18650,
    e: 24.939554,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 36,
    rent: 432,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord116@sopia.io",
    contactPersonFirstName: "Jari",
    contactPersonLastName: "Helenius",
    phoneNumber: "0550743489",
    language: "Finnish, English",
    description: "A flexible two-room office with plenty of room for meetings and personal work",
    address: "Paciuksenkatu 7",
    postalCode: "00270",
    location: { x: 60.24351, y: 24.944645 },
    n: 60.24351,
    e: 24.944564,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 57,
    rent: 684,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord116@sopia.io",
    contactPersonFirstName: "Juhani",
    contactPersonLastName: "Järnström",
    phoneNumber: "0582091006",
    language: "Finnish, English",
    description: "Elegant Workspace\nA tastefully decorated office room with contemporary furnishings, providing an ideal setting for individual work or client consultations.\nEfficient & Practical\nA well-organized office room, offering a productive environment with a desk, comfortable seating, and plenty of storage space.",
    address: "Paciuksenkuja 10",
    postalCode: "00270",
    location: { x: 60.16006, y: 24.943165 },
    n: 60.16006,
    e: 24.943516,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 40,
    rent: 480,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord116@sopia.io",
    contactPersonFirstName: "Hely",
    contactPersonLastName: "Nuorivaara",
    phoneNumber: "0449848584",
    language: "Finnish, English",
    description: "Compact & Professional\nA compact office with three rooms, perfect for small teams needing a private, yet collaborative space to work and meet.",
    address: "Paciuksenkuja 1",
    postalCode: "00270",
    location: { x: 60.19750, y: 24.943185 },
    n: 60.19750,
    e: 24.943518,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1738368000000),
    size: 94,
    rent: 1128,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Furnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord117@sopia.io",
    contactPersonFirstName: "Juha",
    contactPersonLastName: "Jernberg",
    phoneNumber: "0578442048",
    language: "Finnish, English, Swedish",
    description: "Cozy Office Corner\nA compact yet functional office room, offering a cozy environment to concentrate and meet with clients in a professional setting.",
    address: "Paciuksenkuja 3",
    postalCode: "00270",
    location: { x: 60.19852, y: 24.943435 },
    n: 60.19852,
    e: 24.943543,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 44,
    rent: 528,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord117@sopia.io",
    contactPersonFirstName: "Hilppa",
    contactPersonLastName: "Paatela",
    phoneNumber: "0571463517",
    language: "Finnish, Swedish",
    description: "Creative Work Environment\nA flexible office room that fosters creativity, with stylish furniture and a layout designed for both individual and collaborative tasks.",
    address: "Paciuksenkuja 5",
    postalCode: "00270",
    location: { x: 60.19959, y: 24.943435 },
    n: 60.19959,
    e: 24.943543,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 38,
    rent: 456,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord117@sopia.io",
    contactPersonFirstName: "Emma",
    contactPersonLastName: "Kalima",
    phoneNumber: "0517251196",
    language: "Finnish, English",
    description: "Modern Office Space\nA stylish and private office room, perfect for focused work or one-on-one meetings, equipped with all the essentials for productivity.",
    address: "Paciuksenkuja 7",
    postalCode: "00270",
    location: { x: 60.16016, y: 24.943515 },
    n: 60.16016,
    e: 24.943551,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 23,
    rent: 276,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord117@sopia.io",
    contactPersonFirstName: "Juha",
    contactPersonLastName: "Jernberg",
    phoneNumber: "0412692570",
    language: "Finnish, English",
    description: "A spacious two-room office designed for comfort and efficient work",
    address: "Pohjoiskaari 36",
    postalCode: "00200",
    location: { x: 60.23159, y: 24.936985 },
    n: 60.23159,
    e: 24.936598,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 59,
    rent: 708,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord118@sopia.io",
    contactPersonFirstName: "Eveliina",
    contactPersonLastName: "Linko",
    phoneNumber: "0443978293",
    language: "Finnish, English",
    description: "Efficient & Practical\nA well-organized office room, offering a productive environment with a desk, comfortable seating, and plenty of storage space.",
    address: "Pohjoiskaari 39",
    postalCode: "00200",
    location: { x: 60.23954, y: 24.934365 },
    n: 60.23954,
    e: 24.934536,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 42,
    rent: 1680,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord118@sopia.io",
    contactPersonFirstName: "Elna",
    contactPersonLastName: "Kataja",
    phoneNumber: "0487881634",
    language: "Finnish, English",
    description: "A cozy, well-lit two-room office offering privacy and productivity",
    address: "Pohjoiskaari 4",
    postalCode: "00200",
    location: { x: 60.18057, y: 24.940015 },
    n: 60.18057,
    e: 24.940501,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 60,
    rent: 720,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord118@sopia.io",
    contactPersonFirstName: "Ester",
    contactPersonLastName: "Koskelo",
    phoneNumber: "0562372521",
    language: "Finnish, Swedish",
    description: "Your next office awaits! Enjoy a sleek, comfortable environment where ideas come to life and businesses grow.",
    address: "Pohjoiskaari 5",
    postalCode: "00200",
    location: { x: 60.19250, y: 24.940545 },
    n: 60.19250,
    e: 24.940554,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1738368000000),
    size: 80,
    rent: 960,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord118@sopia.io",
    contactPersonFirstName: "Helinä",
    contactPersonLastName: "Malmivaara",
    phoneNumber: "0572796600",
    language: "Finnish, Swedish",
    description: "A two-room office with stylish decor, ideal for professionals and teams",
    address: "Pohjoiskaari 7",
    postalCode: "00200",
    location: { x: 60.19554, y: 24.940775 },
    n: 60.19554,
    e: 24.940577,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 53,
    rent: 636,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord119@sopia.io",
    contactPersonFirstName: "Jarkko",
    contactPersonLastName: "Helenius",
    phoneNumber: "0529450772",
    language: "Finnish, Swedish",
    description: "A flexible two-room office with plenty of room for meetings and personal work",
    address: "Pohjoiskaari 8",
    postalCode: "00200",
    location: { x: 60.19152, y: 24.939985 },
    n: 60.19152,
    e: 24.939598,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 52,
    rent: 624,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord119@sopia.io",
    contactPersonFirstName: "Iida",
    contactPersonLastName: "Osmonsalo",
    phoneNumber: "0597453685",
    language: "Finnish, Swedish",
    description: "A cozy, well-lit two-room office offering privacy and productivity",
    address: "Abrahaminkatu 6",
    postalCode: "00180",
    location: { x: 60.24051, y: 24.960175 },
    n: 60.24051,
    e: 24.960517,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 52,
    rent: 624,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord119@sopia.io",
    contactPersonFirstName: "Heta",
    contactPersonLastName: "Ilves",
    phoneNumber: "0503091118",
    language: "Finnish, Swedish",
    description: "Tailored for Productivity\nA 3-room office designed with productivity in mind, featuring a quiet workspace, meeting room, and a collaborative area.",
    address: "Abrahaminkatu 8",
    postalCode: "00180",
    location: { x: 60.24451, y: 24.959875 },
    n: 60.24451,
    e: 24.959587,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1738368000000),
    size: 89,
    rent: 1068,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord119@sopia.io",
    contactPersonFirstName: "Jussi",
    contactPersonLastName: "Johansson",
    phoneNumber: "0563879662",
    language: "Finnish, Swedish",
    description: "Well-Equipped Office\nThree fully-equipped rooms with modern amenities, creating an ideal setting for work, meetings, and brainstorming sessions.",
    address: "Ainonkatu 2",
    postalCode: "00100",
    location: { x: 60.22053, y: 24.962515 },
    n: 60.22053,
    e: 24.962551,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1738368000000),
    size: 92,
    rent: 1104,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord120@sopia.io",
    contactPersonFirstName: "Hilppa",
    contactPersonLastName: "Paatela",
    phoneNumber: "0408870705",
    language: "Finnish, Swedish",
    description: "Bright and Spacious Room\nA well-lit office with large windows, providing a comfortable space for work or creative thinking, designed for maximum comfort.",
    address: "Ainonkatu 4",
    postalCode: "00100",
    location: { x: 60.21955, y: 24.962245 },
    n: 60.21955,
    e: 24.962524,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 26,
    rent: 312,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord120@sopia.io",
    contactPersonFirstName: "Henriikka",
    contactPersonLastName: "Airila",
    phoneNumber: "0575912588",
    language: "Finnish, Swedish",
    description: "Cozy Office Corner\nA compact yet functional office room, offering a cozy environment to concentrate and meet with clients in a professional setting.",
    address: "Albertinkatu 1",
    postalCode: "00150",
    location: { x: 60.18850, y: 24.967075 },
    n: 60.18850,
    e: 24.967507,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 21,
    rent: 252,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord120@sopia.io",
    contactPersonFirstName: "Jalo",
    contactPersonLastName: "Helander",
    phoneNumber: "0421294065",
    language: "Finnish, Swedish",
    description: "A functional two-room office that supports both individual work and group collaboration",
    address: "Albertinkatu 12",
    postalCode: "00150",
    location: { x: 60.19951, y: 24.965375 },
    n: 60.19951,
    e: 24.965537,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 57,
    rent: 684,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord120@sopia.io",
    contactPersonFirstName: "Henni",
    contactPersonLastName: "Laitakari",
    phoneNumber: "0463113047",
    language: "Finnish, English",
    description: "A sleek and contemporary two-room office with ample natural light",
    address: "Albertinkatu 14",
    postalCode: "00120",
    location: { x: 60.20356, y: 24.965125 },
    n: 60.20356,
    e: 24.965512,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 43,
    rent: 516,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord121@sopia.io",
    contactPersonFirstName: "Jukka",
    contactPersonLastName: "Johansson",
    phoneNumber: "0573786045",
    language: "Finnish, English",
    description: "Vibrant & Creative Workspace\nBold color accents and unique design elements in every room inspire creativity, while maintaining a professional and polished look.",
    address: "Bulevardi 31",
    postalCode: "00180",
    location: { x: 60.22456, y: 24.961975 },
    n: 60.22456,
    e: 24.961597,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1738368000000),
    size: 78,
    rent: 936,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord121@sopia.io",
    contactPersonFirstName: "Helka",
    contactPersonLastName: "Merikanto",
    phoneNumber: "0514804207",
    language: "Finnish, English",
    description: "A cozy, well-lit two-room office offering privacy and productivity",
    address: "Bulevardi 34a",
    postalCode: "00120",
    location: { x: 60.22353, y: 24.963475 },
    n: 60.22353,
    e: 24.963547,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 56,
    rent: 672,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord121@sopia.io",
    contactPersonFirstName: "Heini",
    contactPersonLastName: "Sarva",
    phoneNumber: "0584791379",
    language: "Finnish, English",
    description: "Efficient & Practical\nA well-organized office room, offering a productive environment with a desk, comfortable seating, and plenty of storage space.",
    address: "Bulevardi 40",
    postalCode: "00120",
    location: { x: 60.21851, y: 24.962525 },
    n: 60.21851,
    e: 24.962552,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 29,
    rent: 348,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord121@sopia.io",
    contactPersonFirstName: "Helena",
    contactPersonLastName: "Louhivuori",
    phoneNumber: "0506136858",
    language: "Finnish, English",
    description: "A spacious two-room office designed for comfort and efficient work",
    address: "Bulevardi 4",
    postalCode: "00120",
    location: { x: 60.17555, y: 24.968375 },
    n: 60.25755,
    e: 24.968537,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 56,
    rent: 672,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord122@sopia.io",
    contactPersonFirstName: "Jarmo",
    contactPersonLastName: "Helenius",
    phoneNumber: "0590007683",
    language: "Finnish, English",
    description: "Bright & Inviting Space\nNatural light floods through large windows, illuminating the contemporary furnishings in each of the three rooms, creating an open, airy feel.",
    address: "Caloniuksenkatu 1",
    postalCode: "00100",
    location: { x: 60.24059, y: 24.955515 },
    n: 60.24059,
    e: 24.955551,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1738368000000),
    size: 90,
    rent: 1080,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord122@sopia.io",
    contactPersonFirstName: "Joel",
    contactPersonLastName: "Hoffrén",
    phoneNumber: "0530412961",
    language: "Finnish, English",
    description: "A two-room office with stylish decor, ideal for professionals and teams",
    address: "Caloniuksenkatu 3",
    postalCode: "00100",
    location: { x: 60.24357, y: 24.955685 },
    n: 60.24357,
    e: 24.955568,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 49,
    rent: 588,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord122@sopia.io",
    contactPersonFirstName: "Heini",
    contactPersonLastName: "Sarva",
    phoneNumber: "0463937731",
    language: "Finnish, English, Swedish",
    description: "Modern Office Space\nA stylish and private office room, perfect for focused work or one-on-one meetings, equipped with all the essentials for productivity.",
    address: "Caloniuksenkatu 5",
    postalCode: "00100",
    location: { x: 60.24654, y: 24.955935 },
    n: 60.24654,
    e: 24.955593,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 28,
    rent: 336,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord122@sopia.io",
    contactPersonFirstName: "Jesper",
    contactPersonLastName: "Herckman",
    phoneNumber: "0406567494",
    language: "Finnish, Swedish",
    description: "Efficient & Practical\nA well-organized office room, offering a productive environment with a desk, comfortable seating, and plenty of storage space.",
    address: "Caloniuksenkatu 7",
    postalCode: "00100",
    location: { x: 60.24955, y: 24.956135 },
    n: 60.24955,
    e: 24.956513,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 41,
    rent: 492,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord123@sopia.io",
    contactPersonFirstName: "Hertta",
    contactPersonLastName: "Nuorvala",
    phoneNumber: "0547332841",
    language: "Finnish, English",
    description: "A flexible two-room office with plenty of room for meetings and personal work",
    address: "Caloniuksenkatu 9",
    postalCode: "00100",
    location: { x: 60.25255, y: 24.956515 },
    n: 60.25255,
    e: 24.956551,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 59,
    rent: 708,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord123@sopia.io",
    contactPersonFirstName: "Eveliina",
    contactPersonLastName: "Linko",
    phoneNumber: "0523596430",
    language: "Finnish, English",
    description: "A sleek and contemporary two-room office with ample natural light",
    address: "Dunckerinkatu 2",
    postalCode: "00260",
    location: { x: 60.19451, y: 24.960395 },
    n: 60.19451,
    e: 24.960539,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 44,
    rent: 528,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord123@sopia.io",
    contactPersonFirstName: "Hertta",
    contactPersonLastName: "Nuorvala",
    phoneNumber: "0509784364",
    language: "Finnish, English",
    description: "Elegant Workspace\nA tastefully decorated office room with contemporary furnishings, providing an ideal setting for individual work or client consultations.\nEfficient & Practical\nA well-organized office room, offering a productive environment with a desk, comfortable seating, and plenty of storage space.",
    address: "Döbelninkatu 1",
    postalCode: "00260",
    location: { x: 60.19355, y: 24.958105 },
    n: 60.19355,
    e: 24.958510,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 24,
    rent: 600,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Kiinteistösijoittajat Oy",
    email: "landlord123@sopia.io",
    contactPersonFirstName: "Heli",
    contactPersonLastName: "Maasalo",
    phoneNumber: "0404872910",
    language: "Finnish, English",
    description: "Professional and Quiet\nA quiet, private office ideal for uninterrupted work, with sleek furniture and a minimalist design for a clear mind.",
    address: "Döbelninkatu 3a",
    postalCode: "00260",
    location: { x: 60.19259, y: 24.957865 },
    n: 60.19259,
    e: 24.957586,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 23,
    rent: 575,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Helsingin kiinteistönomistajat Oy",
    email: "landlord124@sopia.io",
    contactPersonFirstName: "Janne",
    contactPersonLastName: "Helenius",
    phoneNumber: "0519337235",
    language: "Finnish, Swedish",
    description: "Cozy Office Corner\nA compact yet functional office room, offering a cozy environment to concentrate and meet with clients in a professional setting.",
    address: "Eino Leinon katu 3",
    postalCode: "00250",
    location: { x: 60.25754, y: 24.955825 },
    n: 60.25754,
    e: 24.955582,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 36,
    rent: 900,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Helsingin kiinteistönomistajat Oy",
    email: "landlord124@sopia.io",
    contactPersonFirstName: "Jousia",
    contactPersonLastName: "Jernberg",
    phoneNumber: "0575823950",
    language: "Finnish, Swedish",
    description: "A functional two-room office that supports both individual work and group collaboration",
    address: "Eino Leinon katu 7",
    postalCode: "00250",
    location: { x: 60.25756, y: 24.955095 },
    n: 60.25756,
    e: 24.955509,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 57,
    rent: 1425,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Helsingin kiinteistönomistajat Oy",
    email: "landlord124@sopia.io",
    contactPersonFirstName: "Jasper",
    contactPersonLastName: "Hellberg",
    phoneNumber: "0575199303",
    language: "Finnish, English",
    description: "Creative Work Environment\nA flexible office room that fosters creativity, with stylish furniture and a layout designed for both individual and collaborative tasks.",
    address: "Eiranranta 3",
    postalCode: "00150",
    location: { x: 60.23752, y: 24.963065 },
    n: 60.23752,
    e: 24.963506,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 26,
    rent: 650,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Helsingin kiinteistönomistajat Oy",
    email: "landlord124@sopia.io",
    contactPersonFirstName: "Helli",
    contactPersonLastName: "Kivalo",
    phoneNumber: "0508233501",
    language: "Finnish, English",
    description: "Modern Office Space\nA stylish and private office room, perfect for focused work or one-on-one meetings, equipped with all the essentials for productivity.",
    address: "Eiranranta 7",
    postalCode: "00150",
    location: { x: 60.23056, y: 24.962035 },
    n: 60.23056,
    e: 24.962503,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 37,
    rent: 925,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Helsingin kiinteistönomistajat Oy",
    email: "landlord125@sopia.io",
    contactPersonFirstName: "Juha",
    contactPersonLastName: "Jernberg",
    phoneNumber: "0424696838",
    language: "Finnish, English",
    description: "A cozy, well-lit two-room office offering privacy and productivity",
    address: "Elisabeth Koch vägen - Ruskeasuon siirtolapuutarha 61",
    postalCode: "00280",
    location: { x: 60.16886, y: 24.946055 },
    n: 60.16886,
    e: 24.946505,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 57,
    rent: 1140,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Helsingin kiinteistönomistajat Oy",
    email: "landlord125@sopia.io",
    contactPersonFirstName: "Hillevi",
    contactPersonLastName: "Salmenoja",
    phoneNumber: "0582328370",
    language: "Finnish, Swedish",
    description: "Cozy Office Corner\nA compact yet functional office room, offering a cozy environment to concentrate and meet with clients in a professional setting.",
    address: "Elisabeth Koch vägen - Ruskeasuon siirtolapuutarha 63",
    postalCode: "00280",
    location: { x: 60.16920, y: 24.946395 },
    n: 60.16920,
    e: 24.946539,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 32,
    rent: 640,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Furnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Helsingin kiinteistönomistajat Oy",
    email: "landlord125@sopia.io",
    contactPersonFirstName: "Heidi",
    contactPersonLastName: "Niinistö",
    phoneNumber: "0411003769",
    language: "Finnish, English",
    description: "A two-room office with stylish decor, ideal for professionals and teams",
    address: "Fabianinkatu 7",
    postalCode: "00130",
    location: { x: 60.23655, y: 24.972375 },
    n: 60.23655,
    e: 24.972537,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 48,
    rent: 1200,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Helsingin kiinteistönomistajat Oy",
    email: "landlord125@sopia.io",
    contactPersonFirstName: "Elmi",
    contactPersonLastName: "Kulomäki",
    phoneNumber: "0421502168",
    language: "Finnish, English",
    description: "A roomy four-room office combining privacy and collaborative spaces, designed to boost productivity and creativity in a professional environment.",
    address: "Fabianinkatu 9",
    postalCode: "00130",
    location: { x: 60.24050, y: 24.972375 },
    n: 60.24050,
    e: 24.972537,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [4],
    whenAvailable: new Date(1738368000000),
    size: 82,
    rent: 2050,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Helsingin kiinteistönomistajat Oy",
    email: "landlord126@sopia.io",
    contactPersonFirstName: "Hellä",
    contactPersonLastName: "Nevanlinna",
    phoneNumber: "0489979975",
    language: "Finnish, English",
    description: "Bright and Spacious Room\nA well-lit office with large windows, providing a comfortable space for work or creative thinking, designed for maximum comfort.",
    address: "Fabianinkatu 20",
    postalCode: "00100",
    location: { x: 60.19757, y: 24.971525 },
    n: 60.19757,
    e: 24.971552,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 32,
    rent: 800,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Helsingin kiinteistönomistajat Oy",
    email: "landlord126@sopia.io",
    contactPersonFirstName: "Heini",
    contactPersonLastName: "Sarva",
    phoneNumber: "0513540744",
    language: "Finnish, English",
    description: "Efficient & Practical\nA well-organized office room, offering a productive environment with a desk, comfortable seating, and plenty of storage space.",
    address: "Fabianinkatu 21",
    postalCode: "00130",
    location: { x: 60.16055, y: 24.972385 },
    n: 60.16055,
    e: 24.972538,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 26,
    rent: 650,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Helsingin kiinteistönomistajat Oy",
    email: "landlord126@sopia.io",
    contactPersonFirstName: "Juhani",
    contactPersonLastName: "Järnström",
    phoneNumber: "0536559796",
    language: "Finnish, English",
    description: "Modern 3-Room Office Suite\nA sleek office with three distinct rooms, including a private office, meeting space, and a collaborative work area.",
    address: "Fabianinkatu 23",
    postalCode: "00130",
    location: { x: 60.16355, y: 24.972235 },
    n: 60.16355,
    e: 24.972523,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1738368000000),
    size: 86,
    rent: 2150,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Helsingin kiinteistönomistajat Oy",
    email: "landlord126@sopia.io",
    contactPersonFirstName: "Jukka",
    contactPersonLastName: "Johansson",
    phoneNumber: "0554692361",
    language: "Finnish, English",
    description: "Elegant Workspace\nA tastefully decorated office room with contemporary furnishings, providing an ideal setting for individual work or client consultations.\nEfficient & Practical\nA well-organized office room, offering a productive environment with a desk, comfortable seating, and plenty of storage space.",
    address: "Fabianinkatu 24",
    postalCode: "00100",
    location: { x: 60.20853, y: 24.971505 },
    n: 60.20853,
    e: 24.971550,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 38,
    rent: 950,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Good",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Helsingin kiinteistönomistajat Oy",
    email: "landlord127@sopia.io",
    contactPersonFirstName: "Hanna",
    contactPersonLastName: "Liro",
    phoneNumber: "0596475461",
    language: "Finnish, English",
    description: "A spacious two-room office designed for comfort and efficient work",
    address: "Fabianinkatu 26",
    postalCode: "00100",
    location: { x: 60.21151, y: 24.971315 },
    n: 60.21151,
    e: 24.971531,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 45,
    rent: 1125,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Helsingin kiinteistönomistajat Oy",
    email: "landlord127@sopia.io",
    contactPersonFirstName: "Jaakoppi",
    contactPersonLastName: "Heikel",
    phoneNumber: "0491395649",
    language: "Finnish, English",
    description: "Creative Work Environment\nA flexible office room that fosters creativity, with stylish furniture and a layout designed for both individual and collaborative tasks.",
    address: "Fabianinkatu 28",
    postalCode: "00100",
    location: { x: 60.21452, y: 24.971485 },
    n: 60.21452,
    e: 24.971548,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 29,
    rent: 580,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Helsingin kiinteistönomistajat Oy",
    email: "landlord127@sopia.io",
    contactPersonFirstName: "Helvi",
    contactPersonLastName: "Pohjanpää",
    phoneNumber: "0496831535",
    language: "Finnish, English",
    description: "A functional two-room office that supports both individual work and group collaboration",
    address: "Fabianinkatu 30",
    postalCode: "00100",
    location: { x: 60.21654, y: 24.971185 },
    n: 60.21654,
    e: 24.971518,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 55,
    rent: 1100,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Helsingin kiinteistönomistajat Oy",
    email: "landlord127@sopia.io",
    contactPersonFirstName: "Enna",
    contactPersonLastName: "Listo",
    phoneNumber: "0573288515",
    language: "Finnish, English, Swedish",
    description: "Compact & Professional\nA compact office with three rooms, perfect for small teams needing a private, yet collaborative space to work and meet.",
    address: "Gyldénintie 1",
    postalCode: "00200",
    location: { x: 60.17453, y: 24.932345 },
    n: 60.17453,
    e: 24.932534,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1738368000000),
    size: 99,
    rent: 1980,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Helsingin kiinteistönomistajat Oy",
    email: "landlord128@sopia.io",
    contactPersonFirstName: "Jooa",
    contactPersonLastName: "Hultman",
    phoneNumber: "0532563649",
    language: "Finnish, Swedish",
    description: "A flexible two-room office with plenty of room for meetings and personal work",
    address: "Gyldénintie 13",
    postalCode: "00200",
    location: { x: 60.20455, y: 24.932535 },
    n: 60.20455,
    e: 24.932553,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 47,
    rent: 940,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord128@sopia.io",
    contactPersonFirstName: "Helmi",
    contactPersonLastName: "Nuorpuu",
    phoneNumber: "0480189560",
    language: "Finnish, English",
    description: "A two-room office with stylish decor, ideal for professionals and teams",
    address: "Gyldénintie 15",
    postalCode: "00200",
    location: { x: 60.21155, y: 24.932595 },
    n: 60.21155,
    e: 24.932559,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 47,
    rent: 940,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord128@sopia.io",
    contactPersonFirstName: "Hannele",
    contactPersonLastName: "Merikoski",
    phoneNumber: "0426566108",
    language: "Finnish, English",
    description: "A spacious two-room office designed for comfort and efficient work",
    address: "Gyldénintie 2a",
    postalCode: "00200",
    location: { x: 60.17851, y: 24.931585 },
    n: 60.17851,
    e: 24.931558,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 48,
    rent: 960,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord128@sopia.io",
    contactPersonFirstName: "Juhani",
    contactPersonLastName: "Järnström",
    phoneNumber: "0470006216",
    language: "Finnish, English",
    description: "A functional two-room office that supports both individual work and group collaboration",
    address: "Gyldénintie 4",
    postalCode: "00200",
    location: { x: 60.18651, y: 24.931615 },
    n: 60.18651,
    e: 24.931561,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 52,
    rent: 624,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Furnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord129@sopia.io",
    contactPersonFirstName: "Juhana",
    contactPersonLastName: "Jernström",
    phoneNumber: "0463863164",
    language: "Finnish, English",
    description: "A cozy, well-lit two-room office offering privacy and productivity",
    address: "Gyldénintie 6",
    postalCode: "00200",
    location: { x: 60.19357, y: 24.931755 },
    n: 60.19357,
    e: 24.931575,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 58,
    rent: 696,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord129@sopia.io",
    contactPersonFirstName: "Heljä",
    contactPersonLastName: "Mela",
    phoneNumber: "0559755036",
    language: "Finnish, Swedish",
    description: "Professional and Quiet\nA quiet, private office ideal for uninterrupted work, with sleek furniture and a minimalist design for a clear mind.",
    address: "Erottajankatu 1-3",
    postalCode: "00130",
    location: { x: 60.23858, y: 24.969115 },
    n: 60.23858,
    e: 24.969511,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 33,
    rent: 396,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord129@sopia.io",
    contactPersonFirstName: "Jukka",
    contactPersonLastName: "Johansson",
    phoneNumber: "0520042882",
    language: "Finnish, Swedish",
    description: "Vibrant & Creative Workspace\nBold color accents and unique design elements in every room inspire creativity, while maintaining a professional and polished look.",
    address: "Haahkakuja 3",
    postalCode: "00200",
    location: { x: 60.25251, y: 24.930975 },
    n: 60.25251,
    e: 24.930597,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1738368000000),
    size: 83,
    rent: 996,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Furnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord129@sopia.io",
    contactPersonFirstName: "Jalo",
    contactPersonLastName: "Helander",
    phoneNumber: "0480606161",
    language: "Finnish, English",
    description: "Tailored for Productivity\nA 3-room office designed with productivity in mind, featuring a quiet workspace, meeting room, and a collaborative area.",
    address: "Haahkakuja 7",
    postalCode: "00200",
    location: { x: 60.16455, y: 24.931155 },
    n: 60.16455,
    e: 24.931515,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1738368000000),
    size: 84,
    rent: 1008,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord130@sopia.io",
    contactPersonFirstName: "Jouni",
    contactPersonLastName: "Jansson",
    phoneNumber: "0447091951",
    language: "Finnish, English",
    description: "Modern Office Space\nA stylish and private office room, perfect for focused work or one-on-one meetings, equipped with all the essentials for productivity.",
    address: "Haahkapolku 1",
    postalCode: "00200",
    location: { x: 60.24955, y: 24.932415 },
    n: 60.24955,
    e: 24.932541,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 38,
    rent: 456,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord130@sopia.io",
    contactPersonFirstName: "Juhani",
    contactPersonLastName: "Järnström",
    phoneNumber: "0469594846",
    language: "Finnish, English",
    description: "Professional and Quiet\nA quiet, private office ideal for uninterrupted work, with sleek furniture and a minimalist design for a clear mind.",
    address: "Haahkapolku 3",
    postalCode: "00200",
    location: { x: 60.24352, y: 24.932145 },
    n: 60.24352,
    e: 24.932514,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 35,
    rent: 420,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord130@sopia.io",
    contactPersonFirstName: "Emma",
    contactPersonLastName: "Kalima",
    phoneNumber: "0548296630",
    language: "Finnish, Swedish",
    description: "A spacious four-room office offering a perfect blend of privacy and collaboration, designed to enhance productivity and creativity in a professional setting.",
    address: "Haahkatie 1",
    postalCode: "00200",
    location: { x: 60.25954, y: 24.933945 },
    n: 60.25954,
    e: 24.933594,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [4],
    whenAvailable: new Date(1738368000000),
    size: 78,
    rent: 936,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Good",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord130@sopia.io",
    contactPersonFirstName: "Joona",
    contactPersonLastName: "Hällberg\/Hälleberg",
    phoneNumber: "0489825781",
    language: "Finnish, English",
    description: "Well-Equipped Office\nThree fully-equipped rooms with modern amenities, creating an ideal setting for work, meetings, and brainstorming sessions.",
    address: "Haahkatie 12",
    postalCode: "00200",
    location: { x: 60.24955, y: 24.932415 },
    n: 60.24955,
    e: 24.932541,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1738368000000),
    size: 97,
    rent: 1164,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord131@sopia.io",
    contactPersonFirstName: "Hannele",
    contactPersonLastName: "Merikoski",
    phoneNumber: "0484267267",
    language: "Finnish, English",
    description: "Cozy Office Corner\nA compact yet functional office room, offering a cozy environment to concentrate and meet with clients in a professional setting.",
    address: "Haahkatie 14",
    postalCode: "00200",
    location: { x: 60.24859, y: 24.931945 },
    n: 60.24859,
    e: 24.931594,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 45,
    rent: 900,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord131@sopia.io",
    contactPersonFirstName: "Jooseppi",
    contactPersonLastName: "Högman",
    phoneNumber: "0541670035",
    language: "Finnish, English",
    description: "A two-room office with stylish decor, ideal for professionals and teams",
    address: "Helsinginkatu 56",
    postalCode: "00260",
    location: { x: 60.24157, y: 24.961895 },
    n: 60.24157,
    e: 24.961589,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 49,
    rent: 980,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Good",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord131@sopia.io",
    contactPersonFirstName: "Jaakob",
    contactPersonLastName: "Heerman",
    phoneNumber: "0584733493",
    language: "Finnish, English",
    description: "Bright & Inviting Space\nNatural light floods through large windows, illuminating the contemporary furnishings in each of the three rooms, creating an open, airy feel.",
    address: "Heikinniementie 11",
    postalCode: "00250",
    location: { x: 60.24053, y: 24.937695 },
    n: 60.24053,
    e: 24.937569,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1738368000000),
    size: 70,
    rent: 1400,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord131@sopia.io",
    contactPersonFirstName: "Henni",
    contactPersonLastName: "Laitakari",
    phoneNumber: "0562625014",
    language: "Finnish, English",
    description: "Modern 3-Room Office Suite\nA sleek office with three distinct rooms, including a private office, meeting space, and a collaborative work area.",
    address: "Heikinniementie 3",
    postalCode: "00250",
    location: { x: 60.22358, y: 24.939075 },
    n: 60.22358,
    e: 24.939507,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1738368000000),
    size: 94,
    rent: 1880,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord132@sopia.io",
    contactPersonFirstName: "Hellä",
    contactPersonLastName: "Nevanlinna",
    phoneNumber: "0433697611",
    language: "Finnish, English",
    description: "A private two-room office that promotes focus and creativity",
    address: "Heikinniementie 4a",
    postalCode: "00250",
    location: { x: 60.22258, y: 24.938265 },
    n: 60.22258,
    e: 24.938526,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 60,
    rent: 1200,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord132@sopia.io",
    contactPersonFirstName: "Jesper",
    contactPersonLastName: "Herckman",
    phoneNumber: "0425261860",
    language: "Finnish, English",
    description: "Elegant Workspace\nA tastefully decorated office room with contemporary furnishings, providing an ideal setting for individual work or client consultations.\nEfficient & Practical\nA well-organized office room, offering a productive environment with a desk, comfortable seating, and plenty of storage space.",
    address: "Heikinniementie 6",
    postalCode: "00250",
    location: { x: 60.23452, y: 24.937115 },
    n: 60.23452,
    e: 24.937511,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 27,
    rent: 540,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord132@sopia.io",
    contactPersonFirstName: "Elma",
    contactPersonLastName: "Kairamo",
    phoneNumber: "0537494342",
    language: "Finnish, English",
    description: "A flexible two-room office with plenty of room for meetings and personal work",
    address: "Heikinniementie 9",
    postalCode: "00250",
    location: { x: 60.23554, y: 24.938185 },
    n: 60.23554,
    e: 24.938518,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 53,
    rent: 636,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord132@sopia.io",
    contactPersonFirstName: "Joona",
    contactPersonLastName: "Hällberg\/Hälleberg",
    phoneNumber: "0552190202",
    language: "Finnish, English",
    description: "Modern Office Space\nA stylish and private office room, perfect for focused work or one-on-one meetings, equipped with all the essentials for productivity.",
    address: "Heikkilänaukio 2",
    postalCode: "00210",
    location: { x: 60.21857, y: 24.933845 },
    n: 60.21857,
    e: 24.933584,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 37,
    rent: 740,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Furnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord133@sopia.io",
    contactPersonFirstName: "Jarno",
    contactPersonLastName: "Helin",
    phoneNumber: "0424616491",
    language: "Finnish, English, Swedish",
    description: "Efficient & Practical\nA well-organized office room, offering a productive environment with a desk, comfortable seating, and plenty of storage space.",
    address: "Heikkilänpolku 1",
    postalCode: "00210",
    location: { x: 60.23358, y: 24.933305 },
    n: 60.23358,
    e: 24.933530,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 20,
    rent: 500,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord133@sopia.io",
    contactPersonFirstName: "Helle",
    contactPersonLastName: "Mannermaa",
    phoneNumber: "0503994629",
    language: "Finnish, Swedish",
    description: "A sleek and contemporary two-room office with ample natural light",
    address: "Heikkilänpolku 4",
    postalCode: "00210",
    location: { x: 60.23256, y: 24.932725 },
    n: 60.23256,
    e: 24.932572,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 60,
    rent: 1200,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord133@sopia.io",
    contactPersonFirstName: "Helle",
    contactPersonLastName: "Mannermaa",
    phoneNumber: "0572164882",
    language: "Finnish, English",
    description: "Bright and Spacious Room\nA well-lit office with large windows, providing a comfortable space for work or creative thinking, designed for maximum comfort.",
    address: "Heikkiläntie 1",
    postalCode: "00210",
    location: { x: 60.23252, y: 24.934225 },
    n: 60.23252,
    e: 24.934522,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 29,
    rent: 580,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Furnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord133@sopia.io",
    contactPersonFirstName: "Elviira",
    contactPersonLastName: "Lahdensuo",
    phoneNumber: "0529425770",
    language: "Finnish, English",
    description: "Professional and Quiet\nA quiet, private office ideal for uninterrupted work, with sleek furniture and a minimalist design for a clear mind.",
    address: "Heikkiläntie 2",
    postalCode: "00210",
    location: { x: 60.22856, y: 24.933025 },
    n: 60.22856,
    e: 24.933502,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 33,
    rent: 660,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord134@sopia.io",
    contactPersonFirstName: "Joose",
    contactPersonLastName: "Hällström\/Hellström",
    phoneNumber: "0494803337",
    language: "Finnish, English",
    description: "A spacious two-room office designed for comfort and efficient work",
    address: "Heikkiläntie 4",
    postalCode: "00210",
    location: { x: 60.23358, y: 24.933305 },
    n: 60.23358,
    e: 24.933530,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 54,
    rent: 648,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord134@sopia.io",
    contactPersonFirstName: "Helle",
    contactPersonLastName: "Mannermaa",
    phoneNumber: "0491660413",
    language: "Finnish, English",
    description: "A functional two-room office that supports both individual work and group collaboration",
    address: "Heikkiläntie 7",
    postalCode: "00210",
    location: { x: 60.24755, y: 24.935975 },
    n: 60.24755,
    e: 24.935597,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 50,
    rent: 600,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord134@sopia.io",
    contactPersonFirstName: "Elsa",
    contactPersonLastName: "Kurki-Suonio",
    phoneNumber: "0541769543",
    language: "Finnish, Swedish",
    description: "Creative Work Environment\nA flexible office room that fosters creativity, with stylish furniture and a layout designed for both individual and collaborative tasks.",
    address: "Heino Kasken katu 2",
    postalCode: "00180",
    location: { x: 60.17157, y: 24.949785 },
    n: 60.17157,
    e: 24.949578,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 24,
    rent: 288,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord134@sopia.io",
    contactPersonFirstName: "Justus",
    contactPersonLastName: "Johnsson",
    phoneNumber: "0501517695",
    language: "Finnish, Swedish",
    description: "Vibrant & Creative Workspace\nBold color accents and unique design elements in every room inspire creativity, while maintaining a professional and polished look.",
    address: "Heino Kasken katu 5",
    postalCode: "00180",
    location: { x: 60.16658, y: 24.949045 },
    n: 60.16658,
    e: 24.949504,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1738368000000),
    size: 66,
    rent: 792,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord135@sopia.io",
    contactPersonFirstName: "Jarmo",
    contactPersonLastName: "Helenius",
    phoneNumber: "0569433947",
    language: "Finnish, Swedish",
    description: "Compact & Professional\nA compact office with three rooms, perfect for small teams needing a private, yet collaborative space to work and meet.",
    address: "Helenankatu 1",
    postalCode: "00170",
    location: { x: 60.18157, y: 24.975325 },
    n: 60.18157,
    e: 24.975532,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1738368000000),
    size: 91,
    rent: 1092,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord135@sopia.io",
    contactPersonFirstName: "Joose",
    contactPersonLastName: "Hällström\/Hellström",
    phoneNumber: "0475663329",
    language: "Finnish, Swedish",
    description: "A well-designed four-room office that blends private workspaces with areas for collaboration, optimizing productivity and creativity.",
    address: "Hietalahdenkatu 10",
    postalCode: "00180",
    location: { x: 60.22751, y: 24.959575 },
    n: 60.22751,
    e: 24.959557,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [4],
    whenAvailable: new Date(1738368000000),
    size: 113,
    rent: 1356,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord135@sopia.io",
    contactPersonFirstName: "Jarkko",
    contactPersonLastName: "Helenius",
    phoneNumber: "0421872034",
    language: "Finnish, Swedish",
    description: "Modern Office Space\nA stylish and private office room, perfect for focused work or one-on-one meetings, equipped with all the essentials for productivity.",
    address: "Hietalahdenkatu 12",
    postalCode: "00180",
    location: { x: 60.23056, y: 24.959325 },
    n: 60.23056,
    e: 24.959532,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 26,
    rent: 312,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord135@sopia.io",
    contactPersonFirstName: "Helinä",
    contactPersonLastName: "Malmivaara",
    phoneNumber: "0529029297",
    language: "Finnish, Swedish",
    description: "A cozy, well-lit two-room office offering privacy and productivity",
    address: "Hietaniemenkatu 20",
    postalCode: "00100",
    location: { x: 60.23358, y: 24.949565 },
    n: 60.23358,
    e: 24.949556,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 41,
    rent: 492,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord136@sopia.io",
    contactPersonFirstName: "Heli",
    contactPersonLastName: "Maasalo",
    phoneNumber: "0585284909",
    language: "Finnish, Swedish",
    description: "A two-room office with stylish decor, ideal for professionals and teams",
    address: "Hietaniemenkatu 2",
    postalCode: "00100",
    location: { x: 60.19758, y: 24.958825 },
    n: 60.19758,
    e: 24.958582,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 41,
    rent: 492,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord136@sopia.io",
    contactPersonFirstName: "Joona",
    contactPersonLastName: "Hällberg\/Hälleberg",
    phoneNumber: "0563012822",
    language: "Finnish, Swedish",
    description: "A spacious two-room office designed for comfort and efficient work",
    address: "Hietaniemenkatu 27",
    postalCode: "00100",
    location: { x: 60.23157, y: 24.952045 },
    n: 60.23157,
    e: 24.952504,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 56,
    rent: 672,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord136@sopia.io",
    contactPersonFirstName: "Hilla",
    contactPersonLastName: "Suviranta",
    phoneNumber: "0576665667",
    language: "Finnish, Swedish",
    description: "Cozy Office Corner\nA compact yet functional office room, offering a cozy environment to concentrate and meet with clients in a professional setting.",
    address: "Hietaniemenkatu 4",
    postalCode: "00100",
    location: { x: 60.19651, y: 24.958585 },
    n: 60.19651,
    e: 24.958558,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 33,
    rent: 396,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord136@sopia.io",
    contactPersonFirstName: "Helena",
    contactPersonLastName: "Louhivuori",
    phoneNumber: "0439133714",
    language: "Finnish, English",
    description: "A roomy four-room office combining privacy and collaborative spaces, designed to boost productivity and creativity in a professional environment.",
    address: "Hietaniemenkatu 5b",
    postalCode: "00100",
    location: { x: 60.20450, y: 24.957795 },
    n: 60.20450,
    e: 24.957579,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [4],
    whenAvailable: new Date(1738368000000),
    size: 109,
    rent: 1308,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord137@sopia.io",
    contactPersonFirstName: "Elma",
    contactPersonLastName: "Kairamo",
    phoneNumber: "0584678186",
    language: "Finnish, English",
    description: "Elegant Workspace\nA tastefully decorated office room with contemporary furnishings, providing an ideal setting for individual work or client consultations.\nEfficient & Practical\nA well-organized office room, offering a productive environment with a desk, comfortable seating, and plenty of storage space.",
    address: "Hietaniemenkatu 8",
    postalCode: "00100",
    location: { x: 60.19854, y: 24.957965 },
    n: 60.19854,
    e: 24.957596,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 31,
    rent: 372,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord137@sopia.io",
    contactPersonFirstName: "Jussi",
    contactPersonLastName: "Johansson",
    phoneNumber: "0568684096",
    language: "Finnish, English",
    description: "Creative Work Environment\nA flexible office room that fosters creativity, with stylish furniture and a layout designed for both individual and collaborative tasks.",
    address: "Hiekkarannantie 13",
    postalCode: "00100",
    location: { x: 60.23458, y: 24.947615 },
    n: 60.23458,
    e: 24.947561,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 36,
    rent: 900,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord137@sopia.io",
    contactPersonFirstName: "Jaakoppi",
    contactPersonLastName: "Heikel",
    phoneNumber: "0588654221",
    language: "Finnish, English",
    description: "A two-room office with stylish decor, ideal for professionals and teams",
    address: "Hiekkarannantie 5",
    postalCode: "00100",
    location: { x: 60.16258, y: 24.949685 },
    n: 60.16258,
    e: 24.949568,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 43,
    rent: 1075,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord137@sopia.io",
    contactPersonFirstName: "Emilia",
    contactPersonLastName: "Hirvensalo",
    phoneNumber: "0496529943",
    language: "Finnish, English",
    description: "Professional and Quiet\nA quiet, private office ideal for uninterrupted work, with sleek furniture and a minimalist design for a clear mind.",
    address: "Hertanmäenkatu 4",
    postalCode: "00240",
    location: { x: 60.16577, y: 24.956905 },
    n: 60.16577,
    e: 24.956590,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 36,
    rent: 900,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord138@sopia.io",
    contactPersonFirstName: "Henriikka",
    contactPersonLastName: "Airila",
    phoneNumber: "0458273472",
    language: "Finnish, English",
    description: "Well-Equipped Office\nThree fully-equipped rooms with modern amenities, creating an ideal setting for work, meetings, and brainstorming sessions.",
    address: "Kellosaarenkatu 7",
    postalCode: "00180",
    location: { x: 60.21850, y: 24.950305 },
    n: 60.21850,
    e: 24.950530,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1738368000000),
    size: 90,
    rent: 2250,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord138@sopia.io",
    contactPersonFirstName: "Julius",
    contactPersonLastName: "Johansson",
    phoneNumber: "0515324012",
    language: "Finnish, English",
    description: "Cozy Office Corner\nA compact yet functional office room, offering a cozy environment to concentrate and meet with clients in a professional setting.",
    address: "Kellosaarenkatu 9",
    postalCode: "00180",
    location: { x: 60.22053, y: 24.949815 },
    n: 60.22053,
    e: 24.949581,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 41,
    rent: 1025,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 0,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord138@sopia.io",
    contactPersonFirstName: "Iines",
    contactPersonLastName: "Reenkola",
    phoneNumber: "0435446378",
    language: "Finnish, English, Swedish",
    description: "A sleek and contemporary two-room office with ample natural light",
    address: "Kellosaarenranta 2",
    postalCode: "00180",
    location: { x: 60.20953, y: 24.951425 },
    n: 60.20953,
    e: 24.951542,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 43,
    rent: 1075,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Good",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord138@sopia.io",
    contactPersonFirstName: "Joona",
    contactPersonLastName: "Hällberg\/Hälleberg",
    phoneNumber: "0460573176",
    language: "Finnish, Swedish",
    description: "A spacious two-room office designed for comfort and efficient work",
    address: "Kellosaarenranta 5",
    postalCode: "00180",
    location: { x: 60.21156, y: 24.949705 },
    n: 60.21156,
    e: 24.949570,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 50,
    rent: 1250,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord139@sopia.io",
    contactPersonFirstName: "Jonne",
    contactPersonLastName: "Holmberg",
    phoneNumber: "0509715531",
    language: "Finnish, English",
    description: "Bright & Inviting Space\nNatural light floods through large windows, illuminating the contemporary furnishings in each of the three rooms, creating an open, airy feel.",
    address: "Kellosaarenranta 7",
    postalCode: "00180",
    location: { x: 60.21059, y: 24.949085 },
    n: 60.21059,
    e: 24.949508,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1738368000000),
    size: 77,
    rent: 1925,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "View",
    deposit: 0,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord139@sopia.io",
    contactPersonFirstName: "Jouko",
    contactPersonLastName: "Jankeloff",
    phoneNumber: "0461394512",
    language: "Finnish, English",
    description: "Modern Office Space\nA stylish and private office room, perfect for focused work or one-on-one meetings, equipped with all the essentials for productivity.",
    address: "Kalevankatu 54",
    postalCode: "00180",
    location: { x: 60.22251, y: 24.959025 },
    n: 60.22251,
    e: 24.959502,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 38,
    rent: 950,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord139@sopia.io",
    contactPersonFirstName: "Hilma",
    contactPersonLastName: "Paalu",
    phoneNumber: "0410024433",
    language: "Finnish, English",
    description: "A cozy, well-lit two-room office offering privacy and productivity",
    address: "Kalevankatu 56a",
    postalCode: "00180",
    location: { x: 60.21856, y: 24.958475 },
    n: 60.21856,
    e: 24.958547,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 54,
    rent: 648,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord139@sopia.io",
    contactPersonFirstName: "Essi",
    contactPersonLastName: "Leppälä",
    phoneNumber: "0402524659",
    language: "Finnish, English",
    description: "Tailored for Productivity\nA 3-room office designed with productivity in mind, featuring a quiet workspace, meeting room, and a collaborative area.",
    address: "Kalevankatu 57",
    postalCode: "00180",
    location: { x: 60.22851, y: 24.958975 },
    n: 60.22851,
    e: 24.958597,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1738368000000),
    size: 60,
    rent: 720,
    rentPeriodMin: "3 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord140@sopia.io",
    contactPersonFirstName: "Else",
    contactPersonLastName: "Kalha",
    phoneNumber: "0560273255",
    language: "Finnish, Swedish",
    description: "A two-room office with stylish decor, ideal for professionals and teams",
    address: "Lahnalahdentie 1",
    postalCode: "00200",
    location: { x: 60.22357, y: 24.927615 },
    n: 60.22357,
    e: 24.927561,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 44,
    rent: 528,
    rentPeriodMin: "3 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord140@sopia.io",
    contactPersonFirstName: "Jorma",
    contactPersonLastName: "Jakobsson",
    phoneNumber: "0511976246",
    language: "Finnish, Swedish",
    description: "A functional two-room office that supports both individual work and group collaboration",
    address: "Lahnalahdentie 4",
    postalCode: "00200",
    location: { x: 60.23450, y: 24.925855 },
    n: 60.23450,
    e: 24.925585,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 44,
    rent: 528,
    rentPeriodMin: "3 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "View",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord140@sopia.io",
    contactPersonFirstName: "Elsa",
    contactPersonLastName: "Kurki-Suonio",
    phoneNumber: "0406326785",
    language: "Finnish, English",
    description: "A flexible two-room office with plenty of room for meetings and personal work",
    address: "Lahnaruohontie 1",
    postalCode: "00200",
    location: { x: 60.18058, y: 24.929515 },
    n: 60.18058,
    e: 24.929551,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 49,
    rent: 588,
    rentPeriodMin: "3 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord140@sopia.io",
    contactPersonFirstName: "Hellä",
    contactPersonLastName: "Nevanlinna",
    phoneNumber: "0548673192",
    language: "Finnish, English",
    description: "A spacious two-room office designed for comfort and efficient work",
    address: "Lahnaruohontie 2",
    postalCode: "00200",
    location: { x: 60.18559, y: 24.928955 },
    n: 60.18559,
    e: 24.928595,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 47,
    rent: 564,
    rentPeriodMin: "3 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord141@sopia.io",
    contactPersonFirstName: "Jesse",
    contactPersonLastName: "Hidén",
    phoneNumber: "0425296591",
    language: "Finnish, English",
    description: "Vibrant & Creative Workspace\nBold color accents and unique design elements in every room inspire creativity, while maintaining a professional and polished look.",
    address: "Lahnaruohontie 4",
    postalCode: "00200",
    location: { x: 60.18957, y: 24.928975 },
    n: 60.18957,
    e: 24.928597,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1738368000000),
    size: 75,
    rent: 900,
    rentPeriodMin: "3 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "Yes",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord141@sopia.io",
    contactPersonFirstName: "Jaakko",
    contactPersonLastName: "Harberg",
    phoneNumber: "0550743489",
    language: "Finnish, Swedish",
    description: "Efficient & Practical\nA well-organized office room, offering a productive environment with a desk, comfortable seating, and plenty of storage space.",
    address: "Lahnaruohontie 6",
    postalCode: "00200",
    location: { x: 60.19454, y: 24.929075 },
    n: 60.19454,
    e: 24.929507,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 40,
    rent: 480,
    rentPeriodMin: "3 months",
    rentPeriodMax: "18 months",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Furnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord141@sopia.io",
    contactPersonFirstName: "Jami",
    contactPersonLastName: "Helenius",
    phoneNumber: "0582091006",
    language: "Finnish, English",
    description: "Bright and Spacious Room\nA well-lit office with large windows, providing a comfortable space for work or creative thinking, designed for maximum comfort.",
    address: "Lahnaruohontie 8",
    postalCode: "00200",
    location: { x: 60.20053, y: 24.929165 },
    n: 60.20053,
    e: 24.929516,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 28,
    rent: 336,
    rentPeriodMin: "3 months",
    rentPeriodMax: "18 months",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord141@sopia.io",
    contactPersonFirstName: "Juhana",
    contactPersonLastName: "Jernström",
    phoneNumber: "0449848584",
    language: "Finnish, English",
    description: "Elegant Workspace\nA tastefully decorated office room with contemporary furnishings, providing an ideal setting for individual work or client consultations.\nEfficient & Practical\nA well-organized office room, offering a productive environment with a desk, comfortable seating, and plenty of storage space.",
    address: "Lastenkodin kuja 3",
    postalCode: "00180",
    location: { x: 60.16456, y: 24.958935 },
    n: 60.16456,
    e: 24.958593,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 30,
    rent: 360,
    rentPeriodMin: "3 months",
    rentPeriodMax: "18 months",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord142@sopia.io",
    contactPersonFirstName: "Elviira",
    contactPersonLastName: "Lahdensuo",
    phoneNumber: "0578442048",
    language: "Finnish, English",
    description: "Creative Work Environment\nA flexible office room that fosters creativity, with stylish furniture and a layout designed for both individual and collaborative tasks.",
    address: "Lastenkodinkatu 11",
    postalCode: "00180",
    location: { x: 60.16157, y: 24.957735 },
    n: 60.16157,
    e: 24.957573,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 35,
    rent: 420,
    rentPeriodMin: "3 months",
    rentPeriodMax: "18 months",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord142@sopia.io",
    contactPersonFirstName: "Hilla",
    contactPersonLastName: "Suviranta",
    phoneNumber: "0571463517",
    language: "Finnish, English",
    description: "Professional and Quiet\nA quiet, private office ideal for uninterrupted work, with sleek furniture and a minimalist design for a clear mind.",
    address: "Maamonlahdentie 3",
    postalCode: "00200",
    location: { x: 60.25551, y: 24.933095 },
    n: 60.25551,
    e: 24.933509,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 39,
    rent: 468,
    rentPeriodMin: "3 months",
    rentPeriodMax: "18 months",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord142@sopia.io",
    contactPersonFirstName: "Jousia",
    contactPersonLastName: "Jernberg",
    phoneNumber: "0517251196",
    language: "Finnish, English",
    description: "A two-room office with stylish decor, ideal for professionals and teams",
    address: "Mannerheimintie 19a",
    postalCode: "00250",
    location: { x: 60.16053, y: 24.957875 },
    n: 60.16053,
    e: 24.957587,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 43,
    rent: 516,
    rentPeriodMin: "3 months",
    rentPeriodMax: "18 months",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord142@sopia.io",
    contactPersonFirstName: "Hilda",
    contactPersonLastName: "Niitemaa",
    phoneNumber: "0412692570",
    language: "Finnish, English",
    description: "A cozy, well-lit two-room office offering privacy and productivity",
    address: "Mannerheimintie 20",
    postalCode: "00100",
    location: { x: 60.19256, y: 24.965735 },
    n: 60.19256,
    e: 24.965573,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 57,
    rent: 684,
    rentPeriodMin: "3 months",
    rentPeriodMax: "18 months",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Furnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord143@sopia.io",
    contactPersonFirstName: "Elna",
    contactPersonLastName: "Kataja",
    phoneNumber: "0443978293",
    language: "Finnish, English",
    description: "A functional two-room office that supports both individual work and group collaboration",
    address: "Nousiaistentie 2",
    postalCode: "00280",
    location: { x: 60.16284, y: 24.947465 },
    n: 60.16284,
    e: 24.947546,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 51,
    rent: 612,
    rentPeriodMin: "3 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord143@sopia.io",
    contactPersonFirstName: "Enna",
    contactPersonLastName: "Listo",
    phoneNumber: "0487881634",
    language: "Finnish, English",
    description: "Efficient & Practical\nA well-organized office room, offering a productive environment with a desk, comfortable seating, and plenty of storage space.",
    address: "Nousiaistentie 4",
    postalCode: "00280",
    location: { x: 60.16285, y: 24.947905 },
    n: 60.16285,
    e: 24.947590,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 33,
    rent: 396,
    rentPeriodMin: "3 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord143@sopia.io",
    contactPersonFirstName: "Jere",
    contactPersonLastName: "Hellman",
    phoneNumber: "0562372521",
    language: "Finnish, English",
    description: "Cozy Office Corner\nA compact yet functional office room, offering a cozy environment to concentrate and meet with clients in a professional setting.",
    address: "Nousiaistentie 6",
    postalCode: "00280",
    location: { x: 60.16285, y: 24.948335 },
    n: 60.16285,
    e: 24.948533,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 41,
    rent: 492,
    rentPeriodMin: "3 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord143@sopia.io",
    contactPersonFirstName: "Heta",
    contactPersonLastName: "Ilves",
    phoneNumber: "0572796600",
    language: "Finnish, English, Swedish",
    description: "Elegant Workspace\nA tastefully decorated office room with contemporary furnishings, providing an ideal setting for individual work or client consultations.\nEfficient & Practical\nA well-organized office room, offering a productive environment with a desk, comfortable seating, and plenty of storage space.",
    address: "Nousiaistentie 8",
    postalCode: "00280",
    location: { x: 60.16285, y: 24.948805 },
    n: 60.16285,
    e: 24.948580,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 30,
    rent: 360,
    rentPeriodMin: "3 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord144@sopia.io",
    contactPersonFirstName: "Hertta",
    contactPersonLastName: "Nuorvala",
    phoneNumber: "0529450772",
    language: "Finnish, Swedish",
    description: "A sleek and contemporary two-room office with ample natural light",
    address: "Oikokatu 3",
    postalCode: "00170",
    location: { x: 60.25055, y: 24.974675 },
    n: 60.25055,
    e: 24.974567,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 47,
    rent: 564,
    rentPeriodMin: "3 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: false,
    propertyCondition: "Good",
    view: "No view",
    deposit: 0,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord144@sopia.io",
    contactPersonFirstName: "Johannes",
    contactPersonLastName: "Hoffrén",
    phoneNumber: "0597453685",
    language: "Finnish, English",
    description: "A flexible two-room office with plenty of room for meetings and personal work",
    address: "Oikokatu 5",
    postalCode: "00170",
    location: { x: 60.25058, y: 24.975115 },
    n: 60.25058,
    e: 24.975511,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 59,
    rent: 708,
    rentPeriodMin: "3 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: false,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord144@sopia.io",
    contactPersonFirstName: "Eveliina",
    contactPersonLastName: "Linko",
    phoneNumber: "0503091118",
    language: "Finnish, English",
    description: "A functional two-room office that supports both individual work and group collaboration",
    address: "Oikokatu 6-8",
    postalCode: "00170",
    location: { x: 60.25650, y: 24.974845 },
    n: 60.25650,
    e: 24.974584,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 48,
    rent: 576,
    rentPeriodMin: "3 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord144@sopia.io",
    contactPersonFirstName: "Jalmari",
    contactPersonLastName: "Helander",
    phoneNumber: "0563879662",
    language: "Finnish, English",
    description: "A spacious two-room office designed for comfort and efficient work",
    address: "Oksasenkatu 7",
    postalCode: "00100",
    location: { x: 60.16452, y: 24.957695 },
    n: 60.16452,
    e: 24.957569,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 55,
    rent: 660,
    rentPeriodMin: "3 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord145@sopia.io",
    contactPersonFirstName: "Helli",
    contactPersonLastName: "Kivalo",
    phoneNumber: "0408870705",
    language: "Finnish, English",
    description: "Bright and Spacious Room\nA well-lit office with large windows, providing a comfortable space for work or creative thinking, designed for maximum comfort.",
    address: "Oksasenkatu 9",
    postalCode: "00100",
    location: { x: 60.16753, y: 24.957585 },
    n: 60.16753,
    e: 24.957558,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 42,
    rent: 504,
    rentPeriodMin: "3 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: false,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord145@sopia.io",
    contactPersonFirstName: "Juho",
    contactPersonLastName: "Johansson",
    phoneNumber: "0575912588",
    language: "Finnish, Swedish",
    description: "Creative Work Environment\nA flexible office room that fosters creativity, with stylish furniture and a layout designed for both individual and collaborative tasks.",
    address: "Olavinkatu 2",
    postalCode: "00100",
    location: { x: 60.20651, y: 24.962735 },
    n: 60.20651,
    e: 24.962573,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 41,
    rent: 492,
    rentPeriodMin: "3 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: false,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord145@sopia.io",
    contactPersonFirstName: "Joona",
    contactPersonLastName: "Hällberg\/Hälleberg",
    phoneNumber: "0421294065",
    language: "Finnish, Swedish",
    description: "Modern Office Space\nA stylish and private office room, perfect for focused work or one-on-one meetings, equipped with all the essentials for productivity.",
    address: "Oksakoskenpolku 6",
    postalCode: "00250",
    location: { x: 60.20855, y: 24.944195 },
    n: 60.20855,
    e: 24.944519,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1738368000000),
    size: 22,
    rent: 264,
    rentPeriodMin: "3 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord145@sopia.io",
    contactPersonFirstName: "Iina",
    contactPersonLastName: "Sotavalta",
    phoneNumber: "0463113047",
    language: "Finnish, English",
    description: "A two-room office with stylish decor, ideal for professionals and teams",
    address: "Oksasenkatu 2a",
    postalCode: "00100",
    location: { x: 60.24259, y: 24.957765 },
    n: 60.24259,
    e: 24.957576,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1738368000000),
    size: 44,
    rent: 528,
    rentPeriodMin: "3 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: false,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord146@sopia.io",
    contactPersonFirstName: "Erja",
    contactPersonLastName: "Hiekka",
    phoneNumber: "0573786045",
    language: "Finnish, English",
    description: "Well-Equipped Office\nThree fully-equipped rooms with modern amenities, creating an ideal setting for work, meetings, and brainstorming sessions.",
    address: "Oksasenkatu 2b",
    postalCode: "00100",
    location: { x: 60.24557, y: 24.957645 },
    n: 60.24557,
    e: 24.957564,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1738368000000),
    size: 93,
    rent: 1116,
    rentPeriodMin: "3 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord146@sopia.io",
    contactPersonFirstName: "Hellevi",
    contactPersonLastName: "Miesmaa",
    phoneNumber: "0514804207",
    language: "Finnish, English",
    description: "A sleek and contemporary two-room office with ample natural light",
    address: "Oksasenkatu 4a",
    postalCode: "00100",
    location: { x: 60.25056, y: 24.957595 },
    n: 60.25056,
    e: 24.957559,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 47,
    rent: 940,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord146@sopia.io",
    contactPersonFirstName: "Elmi",
    contactPersonLastName: "Kulomäki",
    phoneNumber: "0584791379",
    language: "Finnish, Swedish",
    description: "Professional and Quiet\nA quiet, private office ideal for uninterrupted work, with sleek furniture and a minimalist design for a clear mind.",
    address: "Oksasenkatu 5",
    postalCode: "00100",
    location: { x: 60.16156, y: 24.957785 },
    n: 60.16156,
    e: 24.957578,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 30,
    rent: 600,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: false,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord146@sopia.io",
    contactPersonFirstName: "Jaakkima",
    contactPersonLastName: "Hallsten",
    phoneNumber: "0506136858",
    language: "Finnish, English",
    description: "This expansive four-room office offers a seamless balance of privacy and teamwork, ideal for fostering both focus and innovation.",
    address: "Paciuksenkaari 3",
    postalCode: "00270",
    location: { x: 60.16010, y: 24.943735 },
    n: 60.16010,
    e: 24.943573,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [4],
    whenAvailable: new Date(1740787200000),
    size: 77,
    rent: 1540,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: false,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord147@sopia.io",
    contactPersonFirstName: "Juhani",
    contactPersonLastName: "Järnström",
    phoneNumber: "0590007683",
    language: "Finnish, English",
    description: "A flexible two-room office with plenty of room for meetings and personal work",
    address: "Paciuksenkaari 4",
    postalCode: "00270",
    location: { x: 60.19459, y: 24.943485 },
    n: 60.19459,
    e: 24.943548,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 59,
    rent: 1180,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord147@sopia.io",
    contactPersonFirstName: "Hille",
    contactPersonLastName: "Suolahti",
    phoneNumber: "0530412961",
    language: "Finnish, English",
    description: "A functional two-room office that supports both individual work and group collaboration",
    address: "Paciuksenkaari 6",
    postalCode: "00270",
    location: { x: 60.19153, y: 24.942955 },
    n: 60.19153,
    e: 24.942595,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 49,
    rent: 980,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: false,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord147@sopia.io",
    contactPersonFirstName: "Helmi",
    contactPersonLastName: "Nuorpuu",
    phoneNumber: "0463937731",
    language: "Finnish, English",
    description: "Creative Work Environment\nA flexible office room that fosters creativity, with stylish furniture and a layout designed for both individual and collaborative tasks.",
    address: "Paciuksenkaari 8",
    postalCode: "00270",
    location: { x: 60.19057, y: 24.942555 },
    n: 60.19057,
    e: 24.942555,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 25,
    rent: 300,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: false,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: true,
  },
  {
    company: "Vuokraa toimisto Oy",
    email: "landlord147@sopia.io",
    contactPersonFirstName: "Jami",
    contactPersonLastName: "Helenius",
    phoneNumber: "0406567494",
    language: "Finnish, English",
    description: "Compact & Professional\nA compact office with three rooms, perfect for small teams needing a private, yet collaborative space to work and meet.",
    address: "Paciuksenkatu 19",
    postalCode: "00270",
    location: { x: 60.17053, y: 24.941165 },
    n: 60.17053,
    e: 24.941516,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1740787200000),
    size: 88,
    rent: 1056,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: false,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: true,
  },
  {
    company: "Fantastic office Oy",
    email: "landlord148@sopia.io",
    contactPersonFirstName: "Iida",
    contactPersonLastName: "Osmonsalo",
    phoneNumber: "0547332841",
    language: "Finnish, English",
    description: "Well-Equipped Office\nThree fully-equipped rooms with modern amenities, creating an ideal setting for work, meetings, and brainstorming sessions.",
    address: "Paciuksenkatu 25",
    postalCode: "00270",
    location: { x: 60.17852, y: 24.940355 },
    n: 60.17852,
    e: 24.940535,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1740787200000),
    size: 81,
    rent: 972,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: true,
  },
  {
    company: "Fantastic office Oy",
    email: "landlord148@sopia.io",
    contactPersonFirstName: "Emmi",
    contactPersonLastName: "Leikola",
    phoneNumber: "0523596430",
    language: "Finnish, English",
    description: "A spacious two-room office designed for comfort and efficient work",
    address: "Paciuksenkatu 29",
    postalCode: "00270",
    location: { x: 60.18650, y: 24.939545 },
    n: 60.18650,
    e: 24.939554,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 43,
    rent: 516,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: true,
  },
  {
    company: "Fantastic office Oy",
    email: "landlord148@sopia.io",
    contactPersonFirstName: "Jukka",
    contactPersonLastName: "Johansson",
    phoneNumber: "0509784364",
    language: "Finnish, English",
    description: "Cozy Office Corner\nA compact yet functional office room, offering a cozy environment to concentrate and meet with clients in a professional setting.",
    address: "Paciuksenkatu 7",
    postalCode: "00270",
    location: { x: 60.24351, y: 24.944645 },
    n: 60.24351,
    e: 24.944564,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 38,
    rent: 456,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 2,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: false,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: true,
  },
  {
    company: "Fantastic office Oy",
    email: "landlord148@sopia.io",
    contactPersonFirstName: "Else",
    contactPersonLastName: "Kalha",
    phoneNumber: "0404872910",
    language: "Finnish, English",
    description: "A cozy, well-lit two-room office offering privacy and productivity",
    address: "Paciuksenkuja 10",
    postalCode: "00270",
    location: { x: 60.16006, y: 24.943165 },
    n: 60.16006,
    e: 24.943516,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 55,
    rent: 660,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: true,
  },
  {
    company: "Fantastic office Oy",
    email: "landlord149@sopia.io",
    contactPersonFirstName: "Iiris",
    contactPersonLastName: "Sotavalta",
    phoneNumber: "0519337235",
    language: "Finnish, English, Swedish",
    description: "A two-room office with stylish decor, ideal for professionals and teams",
    address: "Paciuksenkuja 1",
    postalCode: "00270",
    location: { x: 60.19750, y: 24.943185 },
    n: 60.19750,
    e: 24.943518,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 57,
    rent: 684,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Furnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "View",
    deposit: 0,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: true,
  },
  {
    company: "Fantastic office Oy",
    email: "landlord149@sopia.io",
    contactPersonFirstName: "Helle",
    contactPersonLastName: "Mannermaa",
    phoneNumber: "0575823950",
    language: "Finnish, Swedish",
    description: "Tailored for Productivity\nA 3-room office designed with productivity in mind, featuring a quiet workspace, meeting room, and a collaborative area.",
    address: "Paciuksenkuja 3",
    postalCode: "00270",
    location: { x: 60.19852, y: 24.943435 },
    n: 60.19852,
    e: 24.943543,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1740787200000),
    size: 62,
    rent: 1240,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: false,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: true,
  },
  {
    company: "Fantastic office Oy",
    email: "landlord149@sopia.io",
    contactPersonFirstName: "Jere",
    contactPersonLastName: "Hellman",
    phoneNumber: "0575199303",
    language: "Finnish, English",
    description: "A sleek and contemporary two-room office with ample natural light",
    address: "Paciuksenkuja 5",
    postalCode: "00270",
    location: { x: 60.19959, y: 24.943435 },
    n: 60.19959,
    e: 24.943543,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 57,
    rent: 684,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: true,
  },
  {
    company: "Fantastic office Oy",
    email: "landlord149@sopia.io",
    contactPersonFirstName: "Jani",
    contactPersonLastName: "Helenius",
    phoneNumber: "0508233501",
    language: "Finnish, English",
    description: "Elegant Workspace\nA tastefully decorated office room with contemporary furnishings, providing an ideal setting for individual work or client consultations.\nEfficient & Practical\nA well-organized office room, offering a productive environment with a desk, comfortable seating, and plenty of storage space.",
    address: "Paciuksenkuja 7",
    postalCode: "00270",
    location: { x: 60.16016, y: 24.943515 },
    n: 60.16016,
    e: 24.943551,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 38,
    rent: 760,
    rentPeriodMin: "6 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: false,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: true,
  },
  {
    company: "Fantastic office Oy",
    email: "landlord150@sopia.io",
    contactPersonFirstName: "Emilia",
    contactPersonLastName: "Hirvensalo",
    phoneNumber: "0424696838",
    language: "Finnish, English",
    description: "A private two-room office that promotes focus and creativity",
    address: "Pohjoiskaari 36",
    postalCode: "00200",
    location: { x: 60.23159, y: 24.936985 },
    n: 60.23159,
    e: 24.936598,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 52,
    rent: 624,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: true,
  },
  {
    company: "Fantastic office Oy",
    email: "landlord150@sopia.io",
    contactPersonFirstName: "Jesse",
    contactPersonLastName: "Hidén",
    phoneNumber: "0582328370",
    language: "Finnish, English",
    description: "Modern Office Space\nA stylish and private office room, perfect for focused work or one-on-one meetings, equipped with all the essentials for productivity.",
    address: "Pohjoiskaari 39",
    postalCode: "00200",
    location: { x: 60.23954, y: 24.934365 },
    n: 60.23954,
    e: 24.934536,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 35,
    rent: 420,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: false,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: true,
  },
  {
    company: "Fantastic office Oy",
    email: "landlord150@sopia.io",
    contactPersonFirstName: "Else",
    contactPersonLastName: "Kalha",
    phoneNumber: "0411003769",
    language: "Finnish, Swedish",
    description: "A flexible two-room office with plenty of room for meetings and personal work",
    address: "Pohjoiskaari 4",
    postalCode: "00200",
    location: { x: 60.18057, y: 24.940015 },
    n: 60.18057,
    e: 24.940501,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 49,
    rent: 588,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: true,
  },
  {
    company: "Fantastic office Oy",
    email: "landlord150@sopia.io",
    contactPersonFirstName: "Enni",
    contactPersonLastName: "Niini",
    phoneNumber: "0421502168",
    language: "Finnish, Swedish",
    description: "A spacious two-room office designed for comfort and efficient work",
    address: "Pohjoiskaari 5",
    postalCode: "00200",
    location: { x: 60.19250, y: 24.940545 },
    n: 60.19250,
    e: 24.940554,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 57,
    rent: 684,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: true,
  },
  {
    company: "Fantastic office Oy",
    email: "landlord151@sopia.io",
    contactPersonFirstName: "Joel",
    contactPersonLastName: "Hoffrén",
    phoneNumber: "0489979975",
    language: "Finnish, Swedish",
    description: "A cozy, well-lit two-room office offering privacy and productivity",
    address: "Pohjoiskaari 7",
    postalCode: "00200",
    location: { x: 60.19554, y: 24.940775 },
    n: 60.19554,
    e: 24.940577,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 43,
    rent: 516,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: true,
  },
  {
    company: "Fantastic office Oy",
    email: "landlord151@sopia.io",
    contactPersonFirstName: "Enna",
    contactPersonLastName: "Listo",
    phoneNumber: "0513540744",
    language: "Finnish, Swedish",
    description: "A functional two-room office that supports both individual work and group collaboration",
    address: "Pohjoiskaari 8",
    postalCode: "00200",
    location: { x: 60.19152, y: 24.939985 },
    n: 60.19152,
    e: 24.939598,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 45,
    rent: 540,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: true,
  },
  {
    company: "Fantastic office Oy",
    email: "landlord151@sopia.io",
    contactPersonFirstName: "Ester",
    contactPersonLastName: "Koskelo",
    phoneNumber: "0536559796",
    language: "Finnish, Swedish",
    description: "Creative Work Environment\nA flexible office room that fosters creativity, with stylish furniture and a layout designed for both individual and collaborative tasks.",
    address: "Abrahaminkatu 6",
    postalCode: "00180",
    location: { x: 60.24051, y: 24.960175 },
    n: 60.24051,
    e: 24.960517,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 23,
    rent: 276,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 0,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: true,
  },
  {
    company: "Fantastic office Oy",
    email: "landlord151@sopia.io",
    contactPersonFirstName: "Juha",
    contactPersonLastName: "Jernberg",
    phoneNumber: "0554692361",
    language: "Finnish, Swedish",
    description: "A well-designed four-room office that blends private workspaces with areas for collaboration, optimizing productivity and creativity",
    address: "Abrahaminkatu 8",
    postalCode: "00180",
    location: { x: 60.24451, y: 24.959875 },
    n: 60.24451,
    e: 24.959587,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [4],
    whenAvailable: new Date(1740787200000),
    size: 73,
    rent: 876,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: true,
  },
  {
    company: "Fantastic office Oy",
    email: "landlord152@sopia.io",
    contactPersonFirstName: "Heta",
    contactPersonLastName: "Ilves",
    phoneNumber: "0596475461",
    language: "Finnish, Swedish",
    description: "A two-room office with stylish decor, ideal for professionals and teams",
    address: "Ainonkatu 2",
    postalCode: "00100",
    location: { x: 60.22053, y: 24.962515 },
    n: 60.22053,
    e: 24.962551,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 42,
    rent: 504,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord152@sopia.io",
    contactPersonFirstName: "Henriikka",
    contactPersonLastName: "Airila",
    phoneNumber: "0491395649",
    language: "Finnish, Swedish",
    description: "Bright & Inviting Space\nNatural light floods through large windows, illuminating the contemporary furnishings in each of the three rooms, creating an open, airy feel",
    address: "Ainonkatu 4",
    postalCode: "00100",
    location: { x: 60.21955, y: 24.962245 },
    n: 60.21955,
    e: 24.962524,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1740787200000),
    size: 91,
    rent: 1092,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord152@sopia.io",
    contactPersonFirstName: "Eveliina",
    contactPersonLastName: "Linko",
    phoneNumber: "0496831535",
    language: "Finnish, Swedish",
    description: "Bright and Spacious Room\nA well-lit office with large windows, providing a comfortable space for work or creative thinking, designed for maximum comfort",
    address: "Albertinkatu 1",
    postalCode: "00150",
    location: { x: 60.18850, y: 24.967075 },
    n: 60.18850,
    e: 24.967507,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 45,
    rent: 540,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord152@sopia.io",
    contactPersonFirstName: "Joona",
    contactPersonLastName: "Hällberg\/Hälleberg",
    phoneNumber: "0573288515",
    language: "Finnish, English",
    description: "Vibrant & Creative Workspace\nBold color accents and unique design elements in every room inspire creativity, while maintaining a professional and polished look",
    address: "Albertinkatu 12",
    postalCode: "00150",
    location: { x: 60.19951, y: 24.965375 },
    n: 60.19951,
    e: 24.965537,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1740787200000),
    size: 78,
    rent: 936,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord153@sopia.io",
    contactPersonFirstName: "Iiris",
    contactPersonLastName: "Sotavalta",
    phoneNumber: "0532563649",
    language: "Finnish, English",
    description: "A spacious four-room office, perfectly balancing private areas and collaborative spaces, crafted to elevate productivity and creativity",
    address: "Albertinkatu 14",
    postalCode: "00120",
    location: { x: 60.20356, y: 24.965125 },
    n: 60.20356,
    e: 24.965512,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [4],
    whenAvailable: new Date(1740787200000),
    size: 82,
    rent: 984,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord153@sopia.io",
    contactPersonFirstName: "Juhana",
    contactPersonLastName: "Jernström",
    phoneNumber: "0480189560",
    language: "Finnish, English",
    description: "Cozy Office Corner\nA compact yet functional office room, offering a cozy environment to concentrate and meet with clients in a professional setting",
    address: "Bulevardi 31",
    postalCode: "00180",
    location: { x: 60.22456, y: 24.961975 },
    n: 60.22456,
    e: 24.961597,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 28,
    rent: 336,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord153@sopia.io",
    contactPersonFirstName: "Jari",
    contactPersonLastName: "Helenius",
    phoneNumber: "0426566108",
    language: "Finnish, English",
    description: "Elegant Workspace\nA tastefully decorated office room with contemporary furnishings, providing an ideal setting for individual work or client consultations\nEfficient & Practical\nA well-organized office room, offering a productive environment with a desk, comfortable seating, and plenty of storage space.",
    address: "Bulevardi 34a",
    postalCode: "00120",
    location: { x: 60.22353, y: 24.963475 },
    n: 60.22353,
    e: 24.963547,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 20,
    rent: 400,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord153@sopia.io",
    contactPersonFirstName: "Elsi",
    contactPersonLastName: "Kulo",
    phoneNumber: "0470006216",
    language: "Finnish, English",
    description: "Creative Work Environment\nA flexible office room that fosters creativity, with stylish furniture and a layout designed for both individual and collaborative tasks",
    address: "Bulevardi 40",
    postalCode: "00120",
    location: { x: 60.21851, y: 24.962525 },
    n: 60.21851,
    e: 24.962552,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 45,
    rent: 900,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 0,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord154@sopia.io",
    contactPersonFirstName: "Jere",
    contactPersonLastName: "Hellman",
    phoneNumber: "0463863164",
    language: "Finnish, English",
    description: "Professional and Quiet\nA quiet, private office ideal for uninterrupted work, with sleek furniture and a minimalist design for a clear mind",
    address: "Bulevardi 4",
    postalCode: "00120",
    location: { x: 60.25755, y: 24.968375 },
    n: 60.25755,
    e: 24.968537,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 25,
    rent: 500,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord154@sopia.io",
    contactPersonFirstName: "Jasper",
    contactPersonLastName: "Hellberg",
    phoneNumber: "0559755036",
    language: "Finnish, English",
    description: "A sleek and contemporary two-room office with ample natural light",
    address: "Caloniuksenkatu 1",
    postalCode: "00100",
    location: { x: 60.24059, y: 24.955515 },
    n: 60.24059,
    e: 24.955551,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 55,
    rent: 1100,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord154@sopia.io",
    contactPersonFirstName: "Jalmari",
    contactPersonLastName: "Helander",
    phoneNumber: "0520042882",
    language: "Finnish, English, Swedish",
    description: "Creative Work Environment\nA flexible office room that fosters creativity, with stylish furniture and a layout designed for both individual and collaborative tasks",
    address: "Caloniuksenkatu 3",
    postalCode: "00100",
    location: { x: 60.24357, y: 24.955685 },
    n: 60.24357,
    e: 24.955568,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 25,
    rent: 500,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord154@sopia.io",
    contactPersonFirstName: "Hanne",
    contactPersonLastName: "Loimaranta",
    phoneNumber: "0480606161",
    language: "Finnish, Swedish",
    description: "Modern Office Space\nA stylish and private office room, perfect for focused work or one-on-one meetings, equipped with all the essentials for productivity",
    address: "Caloniuksenkatu 5",
    postalCode: "00100",
    location: { x: 60.24654, y: 24.955935 },
    n: 60.24654,
    e: 24.955593,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 41,
    rent: 820,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 0,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord155@sopia.io",
    contactPersonFirstName: "Jami",
    contactPersonLastName: "Helenius",
    phoneNumber: "0447091951",
    language: "Finnish, English",
    description: "A functional two-room office that supports both individual work and group collaboration",
    address: "Caloniuksenkatu 7",
    postalCode: "00100",
    location: { x: 60.24955, y: 24.956135 },
    n: 60.24955,
    e: 24.956513,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 54,
    rent: 1080,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord155@sopia.io",
    contactPersonFirstName: "Hilja",
    contactPersonLastName: "Näre",
    phoneNumber: "0469594846",
    language: "Finnish, English",
    description: "A flexible two-room office with plenty of room for meetings and personal work",
    address: "Caloniuksenkatu 9",
    postalCode: "00100",
    location: { x: 60.25255, y: 24.956515 },
    n: 60.25255,
    e: 24.956551,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 41,
    rent: 820,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord155@sopia.io",
    contactPersonFirstName: "Elvi",
    contactPersonLastName: "Lehto",
    phoneNumber: "0548296630",
    language: "Finnish, English",
    description: "A cozy, well-lit two-room office offering privacy and productivity",
    address: "Dunckerinkatu 2",
    postalCode: "00260",
    location: { x: 60.19451, y: 24.960395 },
    n: 60.19451,
    e: 24.960539,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 55,
    rent: 660,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord155@sopia.io",
    contactPersonFirstName: "Hilda",
    contactPersonLastName: "Niitemaa",
    phoneNumber: "0489825781",
    language: "Finnish, English",
    description: "Cozy Office Corner\nA compact yet functional office room, offering a cozy environment to concentrate and meet with clients in a professional setting",
    address: "Döbelninkatu 1",
    postalCode: "00260",
    location: { x: 60.19355, y: 24.958105 },
    n: 60.19355,
    e: 24.958510,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 23,
    rent: 276,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord156@sopia.io",
    contactPersonFirstName: "Henni",
    contactPersonLastName: "Laitakari",
    phoneNumber: "0484267267",
    language: "Finnish, Swedish",
    description: "A spacious two-room office designed for comfort and efficient work",
    address: "Döbelninkatu 3a",
    postalCode: "00260",
    location: { x: 60.19259, y: 24.957865 },
    n: 60.19259,
    e: 24.957586,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 43,
    rent: 516,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord156@sopia.io",
    contactPersonFirstName: "Hillevi",
    contactPersonLastName: "Salmenoja",
    phoneNumber: "0541670035",
    language: "Finnish, Swedish",
    description: "Modern 3-Room Office Suite\nA sleek office with three distinct rooms, including a private office, meeting space, and a collaborative work area",
    address: "Eino Leinon katu 3",
    postalCode: "00250",
    location: { x: 60.25754, y: 24.955825 },
    n: 60.25754,
    e: 24.955582,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1740787200000),
    size: 86,
    rent: 1032,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord156@sopia.io",
    contactPersonFirstName: "Jarno",
    contactPersonLastName: "Helin",
    phoneNumber: "0584733493",
    language: "Finnish, English",
    description: "Bright and Spacious Room\nA well-lit office with large windows, providing a comfortable space for work or creative thinking, designed for maximum comfort",
    address: "Eino Leinon katu 7",
    postalCode: "00250",
    location: { x: 60.25756, y: 24.955095 },
    n: 60.25756,
    e: 24.955509,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 40,
    rent: 480,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord156@sopia.io",
    contactPersonFirstName: "Else",
    contactPersonLastName: "Kalha",
    phoneNumber: "0562625014",
    language: "Finnish, English",
    description: "A flexible two-room office with plenty of room for meetings and personal work",
    address: "Eiranranta 3",
    postalCode: "00150",
    location: { x: 60.23752, y: 24.963065 },
    n: 60.23752,
    e: 24.963506,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 59,
    rent: 708,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "View",
    deposit: 0,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord157@sopia.io",
    contactPersonFirstName: "Jarkko",
    contactPersonLastName: "Helenius",
    phoneNumber: "0433697611",
    language: "Finnish, English",
    description: "Elegant Workspace\nA tastefully decorated office room with contemporary furnishings, providing an ideal setting for individual work or client consultations\nEfficient & Practical\nA well-organized office room, offering a productive environment with a desk, comfortable seating, and plenty of storage space.",
    address: "Eiranranta 7",
    postalCode: "00150",
    location: { x: 60.23056, y: 24.962035 },
    n: 60.23056,
    e: 24.962503,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 40,
    rent: 480,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord157@sopia.io",
    contactPersonFirstName: "Jori",
    contactPersonLastName: "Ingman",
    phoneNumber: "0425261860",
    language: "Finnish, Swedish",
    description: "A functional two-room office that supports both individual work and group collaboration",
    address: "Elisabeth Koch vägen - Ruskeasuon siirtolapuutarha 61",
    postalCode: "00280",
    location: { x: 60.16886, y: 24.946055 },
    n: 60.16886,
    e: 24.946505,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 40,
    rent: 480,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 0,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord157@sopia.io",
    contactPersonFirstName: "Jukka",
    contactPersonLastName: "Johansson",
    phoneNumber: "0537494342",
    language: "Finnish, English",
    description: "A two-room office with stylish decor, ideal for professionals and teams",
    address: "Elisabeth Koch vägen - Ruskeasuon siirtolapuutarha 63",
    postalCode: "00280",
    location: { x: 60.16920, y: 24.946395 },
    n: 60.16920,
    e: 24.946539,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 50,
    rent: 600,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["SHARED"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord157@sopia.io",
    contactPersonFirstName: "Erja",
    contactPersonLastName: "Hiekka",
    phoneNumber: "0552190202",
    language: "Finnish, English",
    description: "A cozy, well-lit two-room office offering privacy and productivity",
    address: "Fabianinkatu 7",
    postalCode: "00130",
    location: { x: 60.23655, y: 24.972375 },
    n: 60.23655,
    e: 24.972537,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 57,
    rent: 684,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord158@sopia.io",
    contactPersonFirstName: "Jarkko",
    contactPersonLastName: "Helenius",
    phoneNumber: "0424616491",
    language: "Finnish, English",
    description: "A spacious two-room office designed for comfort and efficient work",
    address: "Fabianinkatu 9",
    postalCode: "00130",
    location: { x: 60.24050, y: 24.972375 },
    n: 60.24050,
    e: 24.972537,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 52,
    rent: 624,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 0,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord158@sopia.io",
    contactPersonFirstName: "Joonas",
    contactPersonLastName: "Hällström",
    phoneNumber: "0503994629",
    language: "Finnish, English",
    description: "Creative Work Environment\nA flexible office room that fosters creativity, with stylish furniture and a layout designed for both individual and collaborative tasks",
    address: "Fabianinkatu 20",
    postalCode: "00100",
    location: { x: 60.19757, y: 24.971525 },
    n: 60.19757,
    e: 24.971552,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 38,
    rent: 456,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord158@sopia.io",
    contactPersonFirstName: "Jousia",
    contactPersonLastName: "Jernberg",
    phoneNumber: "0572164882",
    language: "Finnish, English",
    description: "Well-Equipped Office\nThree fully-equipped rooms with modern amenities, creating an ideal setting for work, meetings, and brainstorming sessions",
    address: "Fabianinkatu 21",
    postalCode: "00130",
    location: { x: 60.16055, y: 24.972385 },
    n: 60.16055,
    e: 24.972538,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1740787200000),
    size: 71,
    rent: 852,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord158@sopia.io",
    contactPersonFirstName: "Hanna",
    contactPersonLastName: "Liro",
    phoneNumber: "0529425770",
    language: "Finnish, English",
    description: "Professional and Quiet\nA quiet, private office ideal for uninterrupted work, with sleek furniture and a minimalist design for a clear mind",
    address: "Fabianinkatu 23",
    postalCode: "00130",
    location: { x: 60.16355, y: 24.972235 },
    n: 60.16355,
    e: 24.972523,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 33,
    rent: 396,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord159@sopia.io",
    contactPersonFirstName: "Elvi",
    contactPersonLastName: "Lehto",
    phoneNumber: "0494803337",
    language: "Finnish, English",
    description: "A flexible two-room office with plenty of room for meetings and personal work",
    address: "Fabianinkatu 24",
    postalCode: "00100",
    location: { x: 60.20853, y: 24.971505 },
    n: 60.20853,
    e: 24.971550,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 49,
    rent: 588,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord159@sopia.io",
    contactPersonFirstName: "Iida",
    contactPersonLastName: "Osmonsalo",
    phoneNumber: "0491660413",
    language: "Finnish, English",
    description: "A spacious four-room office offering a perfect blend of privacy and collaboration, designed to enhance productivity and creativity in a professional setting",
    address: "Fabianinkatu 26",
    postalCode: "00100",
    location: { x: 60.21151, y: 24.971315 },
    n: 60.21151,
    e: 24.971531,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [4],
    whenAvailable: new Date(1740787200000),
    size: 110,
    rent: 1320,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord159@sopia.io",
    contactPersonFirstName: "Jarno",
    contactPersonLastName: "Helin",
    phoneNumber: "0541769543",
    language: "Finnish, English",
    description: "A two-room office with stylish decor, ideal for professionals and teams",
    address: "Fabianinkatu 28",
    postalCode: "00100",
    location: { x: 60.21452, y: 24.971485 },
    n: 60.21452,
    e: 24.971548,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 45,
    rent: 900,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord159@sopia.io",
    contactPersonFirstName: "Jussi",
    contactPersonLastName: "Johansson",
    phoneNumber: "0501517695",
    language: "Finnish, English, Swedish",
    description: "Compact & Professional\nA compact office with three rooms, perfect for small teams needing a private, yet collaborative space to work and meet",
    address: "Fabianinkatu 30",
    postalCode: "00100",
    location: { x: 60.21654, y: 24.971185 },
    n: 60.21654,
    e: 24.971518,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1740787200000),
    size: 79,
    rent: 1580,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord160@sopia.io",
    contactPersonFirstName: "Emmi",
    contactPersonLastName: "Leikola",
    phoneNumber: "0569433947",
    language: "Finnish, Swedish",
    description: "Cozy Office Corner\nA compact yet functional office room, offering a cozy environment to concentrate and meet with clients in a professional setting",
    address: "Gyldénintie 1",
    postalCode: "00200",
    location: { x: 60.17453, y: 24.932345 },
    n: 60.17453,
    e: 24.932534,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 22,
    rent: 440,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord160@sopia.io",
    contactPersonFirstName: "Jarmo",
    contactPersonLastName: "Helenius",
    phoneNumber: "0475663329",
    language: "Finnish, English",
    description: "Elegant Workspace\nA tastefully decorated office room with contemporary furnishings, providing an ideal setting for individual work or client consultations\nEfficient & Practical\nA well-organized office room, offering a productive environment with a desk, comfortable seating, and plenty of storage space.",
    address: "Gyldénintie 13",
    postalCode: "00200",
    location: { x: 60.20455, y: 24.932535 },
    n: 60.20455,
    e: 24.932553,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 35,
    rent: 700,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "No",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord160@sopia.io",
    contactPersonFirstName: "Justus",
    contactPersonLastName: "Johnsson",
    phoneNumber: "0421872034",
    language: "Finnish, English",
    description: "Bright & Inviting Space\nNatural light floods through large windows, illuminating the contemporary furnishings in each of the three rooms, creating an open, airy feel",
    address: "Gyldénintie 15",
    postalCode: "00200",
    location: { x: 60.21155, y: 24.932595 },
    n: 60.21155,
    e: 24.932559,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1740787200000),
    size: 89,
    rent: 1780,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Furnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord160@sopia.io",
    contactPersonFirstName: "Hille",
    contactPersonLastName: "Suolahti",
    phoneNumber: "0529029297",
    language: "Finnish, English",
    description: "Well-Equipped Office\nThree fully-equipped rooms with modern amenities, creating an ideal setting for work, meetings, and brainstorming sessions",
    address: "Gyldénintie 2a",
    postalCode: "00200",
    location: { x: 60.17851, y: 24.931585 },
    n: 60.17851,
    e: 24.931558,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1740787200000),
    size: 65,
    rent: 1300,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord161@sopia.io",
    contactPersonFirstName: "Jussi",
    contactPersonLastName: "Johansson",
    phoneNumber: "0585284909",
    language: "Finnish, English",
    description: "Vibrant & Creative Workspace\nBold color accents and unique design elements in every room inspire creativity, while maintaining a professional and polished look",
    address: "Gyldénintie 4",
    postalCode: "00200",
    location: { x: 60.18651, y: 24.931615 },
    n: 60.18651,
    e: 24.931561,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1740787200000),
    size: 86,
    rent: 1720,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord161@sopia.io",
    contactPersonFirstName: "Henriikka",
    contactPersonLastName: "Airila",
    phoneNumber: "0563012822",
    language: "Finnish, Swedish",
    description: "A cozy, well-lit two-room office offering privacy and productivity",
    address: "Gyldénintie 6",
    postalCode: "00200",
    location: { x: 60.19357, y: 24.931755 },
    n: 60.19357,
    e: 24.931575,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 58,
    rent: 696,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord161@sopia.io",
    contactPersonFirstName: "Iines",
    contactPersonLastName: "Reenkola",
    phoneNumber: "0576665667",
    language: "Finnish, Swedish",
    description: "Tailored for Productivity\nA 3-room office designed with productivity in mind, featuring a quiet workspace, meeting room, and a collaborative area",
    address: "Erottajankatu 1-3",
    postalCode: "00130",
    location: { x: 60.23858, y: 24.969115 },
    n: 60.23858,
    e: 24.969511,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1740787200000),
    size: 86,
    rent: 1032,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord161@sopia.io",
    contactPersonFirstName: "Enna",
    contactPersonLastName: "Listo",
    phoneNumber: "0439133714",
    language: "Finnish, English",
    description: "Efficient & Practical\nA well-organized office room, offering a productive environment with a desk, comfortable seating, and plenty of storage space",
    address: "Haahkakuja 3",
    postalCode: "00200",
    location: { x: 60.25251, y: 24.930975 },
    n: 60.25251,
    e: 24.930597,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 33,
    rent: 396,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord162@sopia.io",
    contactPersonFirstName: "Joel",
    contactPersonLastName: "Hoffrén",
    phoneNumber: "0584678186",
    language: "Finnish, English",
    description: "A sleek and contemporary two-room office with ample natural light",
    address: "Haahkakuja 7",
    postalCode: "00200",
    location: { x: 60.16455, y: 24.931155 },
    n: 60.16455,
    e: 24.931515,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 55,
    rent: 660,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord162@sopia.io",
    contactPersonFirstName: "Jami",
    contactPersonLastName: "Helenius",
    phoneNumber: "0568684096",
    language: "Finnish, English",
    description: "A spacious two-room office designed for comfort and efficient work",
    address: "Haahkapolku 1",
    postalCode: "00200",
    location: { x: 60.24955, y: 24.932415 },
    n: 60.24955,
    e: 24.932541,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 56,
    rent: 672,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord162@sopia.io",
    contactPersonFirstName: "Esteri",
    contactPersonLastName: "Apajalahti",
    phoneNumber: "0588654221",
    language: "Finnish, Swedish",
    description: "Creative Work Environment\nA flexible office room that fosters creativity, with stylish furniture and a layout designed for both individual and collaborative tasks",
    address: "Haahkapolku 3",
    postalCode: "00200",
    location: { x: 60.24352, y: 24.932145 },
    n: 60.24352,
    e: 24.932514,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 23,
    rent: 276,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord162@sopia.io",
    contactPersonFirstName: "Helga",
    contactPersonLastName: "Saarnio",
    phoneNumber: "0496529943",
    language: "Finnish, English",
    description: "A two-room office with stylish decor, ideal for professionals and teams",
    address: "Haahkatie 1",
    postalCode: "00200",
    location: { x: 60.25954, y: 24.933945 },
    n: 60.25954,
    e: 24.933594,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 54,
    rent: 648,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord163@sopia.io",
    contactPersonFirstName: "Henna",
    contactPersonLastName: "Nuorteva",
    phoneNumber: "0458273472",
    language: "Finnish, English",
    description: "A cozy, well-lit two-room office offering privacy and productivity",
    address: "Haahkatie 12",
    postalCode: "00200",
    location: { x: 60.24955, y: 24.932415 },
    n: 60.24955,
    e: 24.932541,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 46,
    rent: 552,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord163@sopia.io",
    contactPersonFirstName: "Hilda",
    contactPersonLastName: "Niitemaa",
    phoneNumber: "0515324012",
    language: "Finnish, English",
    description: "Cozy Office Corner\nA compact yet functional office room, offering a cozy environment to concentrate and meet with clients in a professional setting",
    address: "Haahkatie 14",
    postalCode: "00200",
    location: { x: 60.24859, y: 24.931945 },
    n: 60.24859,
    e: 24.931594,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 42,
    rent: 504,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord163@sopia.io",
    contactPersonFirstName: "Jousia",
    contactPersonLastName: "Jernberg",
    phoneNumber: "0435446378",
    language: "Finnish, English",
    description: "Bright and Spacious Room\nA well-lit office with large windows, providing a comfortable space for work or creative thinking, designed for maximum comfort",
    address: "Helsinginkatu 56",
    postalCode: "00260",
    location: { x: 60.24157, y: 24.961895 },
    n: 60.24157,
    e: 24.961589,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 21,
    rent: 252,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord163@sopia.io",
    contactPersonFirstName: "Jaakkima",
    contactPersonLastName: "Hallsten",
    phoneNumber: "0460573176",
    language: "Finnish, English",
    description: "Elegant Workspace\nA tastefully decorated office room with contemporary furnishings, providing an ideal setting for individual work or client consultations\nEfficient & Practical\nA well-organized office room, offering a productive environment with a desk, comfortable seating, and plenty of storage space.",
    address: "Heikinniementie 11",
    postalCode: "00250",
    location: { x: 60.24053, y: 24.937695 },
    n: 60.24053,
    e: 24.937569,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 40,
    rent: 480,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord164@sopia.io",
    contactPersonFirstName: "Henni",
    contactPersonLastName: "Laitakari",
    phoneNumber: "0509715531",
    language: "Finnish, English",
    description: "A functional two-room office that supports both individual work and group collaboration",
    address: "Heikinniementie 3",
    postalCode: "00250",
    location: { x: 60.22358, y: 24.939075 },
    n: 60.22358,
    e: 24.939507,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 49,
    rent: 588,
    rentPeriodMin: "12 months",
    rentPeriodMax: "36 months",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "View",
    deposit: 0,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord164@sopia.io",
    contactPersonFirstName: "Juha",
    contactPersonLastName: "Jernberg",
    phoneNumber: "0461394512",
    language: "Finnish, English",
    description: "A flexible two-room office with plenty of room for meetings and personal work",
    address: "Heikinniementie 4a",
    postalCode: "00250",
    location: { x: 60.22258, y: 24.938265 },
    n: 60.22258,
    e: 24.938526,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 45,
    rent: 540,
    rentPeriodMin: "12 months",
    rentPeriodMax: "36 months",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord164@sopia.io",
    contactPersonFirstName: "Hilja",
    contactPersonLastName: "Näre",
    phoneNumber: "0410024433",
    language: "Finnish, English",
    description: "Efficient & Practical\nA well-organized office room, offering a productive environment with a desk, comfortable seating, and plenty of storage space",
    address: "Heikinniementie 6",
    postalCode: "00250",
    location: { x: 60.23452, y: 24.937115 },
    n: 60.23452,
    e: 24.937511,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 32,
    rent: 800,
    rentPeriodMin: "12 months",
    rentPeriodMax: "36 months",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord164@sopia.io",
    contactPersonFirstName: "Elna",
    contactPersonLastName: "Kataja",
    phoneNumber: "0402524659",
    language: "Finnish, English",
    description: "This modern office space features clean lines, a comfortable work desk, and ample natural light, creating a bright and inviting atmosphere",
    address: "Heikinniementie 9",
    postalCode: "00250",
    location: { x: 60.23554, y: 24.938185 },
    n: 60.23554,
    e: 24.938518,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1740787200000),
    size: 96,
    rent: 2400,
    rentPeriodMin: "12 months",
    rentPeriodMax: "36 months",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord165@sopia.io",
    contactPersonFirstName: "Heidi",
    contactPersonLastName: "Niinistö",
    phoneNumber: "0560273255",
    language: "Finnish, English, Swedish",
    description: "Creative Work Environment\nA flexible office room that fosters creativity, with stylish furniture and a layout designed for both individual and collaborative tasks",
    address: "Heikkilänaukio 2",
    postalCode: "00210",
    location: { x: 60.21857, y: 24.933845 },
    n: 60.21857,
    e: 24.933584,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 26,
    rent: 650,
    rentPeriodMin: "12 months",
    rentPeriodMax: "36 months",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord165@sopia.io",
    contactPersonFirstName: "Erja",
    contactPersonLastName: "Hiekka",
    phoneNumber: "0511976246",
    language: "Finnish, Swedish",
    description: "A spacious two-room office designed for comfort and efficient work",
    address: "Heikkilänpolku 1",
    postalCode: "00210",
    location: { x: 60.23358, y: 24.933305 },
    n: 60.23358,
    e: 24.933530,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 45,
    rent: 540,
    rentPeriodMin: "12 months",
    rentPeriodMax: "36 months",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord165@sopia.io",
    contactPersonFirstName: "Heli",
    contactPersonLastName: "Maasalo",
    phoneNumber: "0406326785",
    language: "Finnish, English",
    description: "A sleek and contemporary two-room office with ample natural light",
    address: "Heikkilänpolku 4",
    postalCode: "00210",
    location: { x: 60.23256, y: 24.932725 },
    n: 60.23256,
    e: 24.932572,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 42,
    rent: 504,
    rentPeriodMin: "12 months",
    rentPeriodMax: "36 months",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord165@sopia.io",
    contactPersonFirstName: "Jooseppi",
    contactPersonLastName: "Högman",
    phoneNumber: "0548673192",
    language: "Finnish, English",
    description: "Compact & Professional\nA compact office with three rooms, perfect for small teams needing a private, yet collaborative space to work and meet",
    address: "Heikkiläntie 1",
    postalCode: "00210",
    location: { x: 60.23252, y: 24.934225 },
    n: 60.23252,
    e: 24.934522,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1740787200000),
    size: 74,
    rent: 2220,
    rentPeriodMin: "12 months",
    rentPeriodMax: "36 months",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord166@sopia.io",
    contactPersonFirstName: "Jeremias",
    contactPersonLastName: "Hellsten",
    phoneNumber: "0425296591",
    language: "Finnish, English",
    description: "Cozy Office Corner\nA compact yet functional office room, offering a cozy environment to concentrate and meet with clients in a professional setting",
    address: "Heikkiläntie 2",
    postalCode: "00210",
    location: { x: 60.22856, y: 24.933025 },
    n: 60.22856,
    e: 24.933502,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 44,
    rent: 1320,
    rentPeriodMin: "12 months",
    rentPeriodMax: "36 months",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord166@sopia.io",
    contactPersonFirstName: "Hilkka",
    contactPersonLastName: "Järventaus",
    phoneNumber: "0550743489",
    language: "Finnish, English",
    description: "Professional and Quiet\nA quiet, private office ideal for uninterrupted work, with sleek furniture and a minimalist design for a clear mind",
    address: "Heikkiläntie 4",
    postalCode: "00210",
    location: { x: 60.23358, y: 24.933305 },
    n: 60.23358,
    e: 24.933530,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 35,
    rent: 700,
    rentPeriodMin: "12 months",
    rentPeriodMax: "36 months",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord166@sopia.io",
    contactPersonFirstName: "Jukka",
    contactPersonLastName: "Johansson",
    phoneNumber: "0582091006",
    language: "Finnish, Swedish",
    description: "Elegant Workspace\nA tastefully decorated office room with contemporary furnishings, providing an ideal setting for individual work or client consultations\nEfficient & Practical\nA well-organized office room, offering a productive environment with a desk, comfortable seating, and plenty of storage space.",
    address: "Heikkiläntie 7",
    postalCode: "00210",
    location: { x: 60.24755, y: 24.935975 },
    n: 60.24755,
    e: 24.935597,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 22,
    rent: 440,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord166@sopia.io",
    contactPersonFirstName: "Henriikka",
    contactPersonLastName: "Airila",
    phoneNumber: "0449848584",
    language: "Finnish, Swedish",
    description: "Efficient & Practical\nA well-organized office room, offering a productive environment with a desk, comfortable seating, and plenty of storage space",
    address: "Heino Kasken katu 2",
    postalCode: "00180",
    location: { x: 60.17157, y: 24.949785 },
    n: 60.17157,
    e: 24.949578,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 32,
    rent: 384,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord167@sopia.io",
    contactPersonFirstName: "Hilja",
    contactPersonLastName: "Näre",
    phoneNumber: "0578442048",
    language: "Finnish, Swedish",
    description: "Bright & Inviting Space\nNatural light floods through large windows, illuminating the contemporary furnishings in each of the three rooms, creating an open, airy feel",
    address: "Heino Kasken katu 5",
    postalCode: "00180",
    location: { x: 60.16658, y: 24.949045 },
    n: 60.16658,
    e: 24.949504,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1740787200000),
    size: 90,
    rent: 1080,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord167@sopia.io",
    contactPersonFirstName: "Heli",
    contactPersonLastName: "Maasalo",
    phoneNumber: "0571463517",
    language: "Finnish, Swedish",
    description: "A roomy four-room office combining privacy and collaborative spaces, designed to boost productivity and creativity in a professional environment",
    address: "Helenankatu 1",
    postalCode: "00170",
    location: { x: 60.18157, y: 24.975325 },
    n: 60.18157,
    e: 24.975532,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [4],
    whenAvailable: new Date(1740787200000),
    size: 99,
    rent: 1188,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Furnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord167@sopia.io",
    contactPersonFirstName: "Henriikka",
    contactPersonLastName: "Airila",
    phoneNumber: "0517251196",
    language: "Finnish, Swedish",
    description: "A cozy, well-lit two-room office offering privacy and productivity",
    address: "Hietalahdenkatu 10",
    postalCode: "00180",
    location: { x: 60.22751, y: 24.959575 },
    n: 60.22751,
    e: 24.959557,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 47,
    rent: 564,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord167@sopia.io",
    contactPersonFirstName: "Helmi",
    contactPersonLastName: "Nuorpuu",
    phoneNumber: "0412692570",
    language: "Finnish, Swedish",
    description: "Well-Equipped Office\nThree fully-equipped rooms with modern amenities, creating an ideal setting for work, meetings, and brainstorming sessions",
    address: "Hietalahdenkatu 12",
    postalCode: "00180",
    location: { x: 60.23056, y: 24.959325 },
    n: 60.23056,
    e: 24.959532,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1740787200000),
    size: 69,
    rent: 828,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord168@sopia.io",
    contactPersonFirstName: "Jasper",
    contactPersonLastName: "Hellberg",
    phoneNumber: "0443978293",
    language: "Finnish, Swedish",
    description: "A two-room office with stylish decor, ideal for professionals and teams",
    address: "Hietaniemenkatu 20",
    postalCode: "00100",
    location: { x: 60.23358, y: 24.949565 },
    n: 60.23358,
    e: 24.949556,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 42,
    rent: 504,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Furnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord168@sopia.io",
    contactPersonFirstName: "Jarno",
    contactPersonLastName: "Helin",
    phoneNumber: "0487881634",
    language: "Finnish, Swedish",
    description: "Vibrant & Creative Workspace\nBold color accents and unique design elements in every room inspire creativity, while maintaining a professional and polished look",
    address: "Hietaniemenkatu 2",
    postalCode: "00100",
    location: { x: 60.19758, y: 24.958825 },
    n: 60.19758,
    e: 24.958582,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1740787200000),
    size: 85,
    rent: 1020,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord168@sopia.io",
    contactPersonFirstName: "Heta",
    contactPersonLastName: "Ilves",
    phoneNumber: "0562372521",
    language: "Finnish, Swedish",
    description: "Cozy Office Corner\nA compact yet functional office room, offering a cozy environment to concentrate and meet with clients in a professional setting",
    address: "Hietaniemenkatu 27",
    postalCode: "00100",
    location: { x: 60.23157, y: 24.952045 },
    n: 60.23157,
    e: 24.952504,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 38,
    rent: 456,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord168@sopia.io",
    contactPersonFirstName: "Jari",
    contactPersonLastName: "Helenius",
    phoneNumber: "0572796600",
    language: "Finnish, English",
    description: "Compact & Professional\nA compact office with three rooms, perfect for small teams needing a private, yet collaborative space to work and meet",
    address: "Hietaniemenkatu 4",
    postalCode: "00100",
    location: { x: 60.19651, y: 24.958585 },
    n: 60.19651,
    e: 24.958558,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1740787200000),
    size: 94,
    rent: 1128,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord169@sopia.io",
    contactPersonFirstName: "Elmi",
    contactPersonLastName: "Kulomäki",
    phoneNumber: "0529450772",
    language: "Finnish, English",
    description: "A functional two-room office that supports both individual work and group collaboration",
    address: "Hietaniemenkatu 5b",
    postalCode: "00100",
    location: { x: 60.20450, y: 24.957795 },
    n: 60.20450,
    e: 24.957579,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 50,
    rent: 600,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord169@sopia.io",
    contactPersonFirstName: "Jeremias",
    contactPersonLastName: "Hellsten",
    phoneNumber: "0597453685",
    language: "Finnish, English",
    description: "Creative Work Environment\nA flexible office room that fosters creativity, with stylish furniture and a layout designed for both individual and collaborative tasks",
    address: "Hietaniemenkatu 8",
    postalCode: "00100",
    location: { x: 60.19854, y: 24.957965 },
    n: 60.19854,
    e: 24.957596,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 20,
    rent: 240,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord169@sopia.io",
    contactPersonFirstName: "Julius",
    contactPersonLastName: "Johansson",
    phoneNumber: "0503091118",
    language: "Finnish, English",
    description: "A flexible two-room office with plenty of room for meetings and personal work",
    address: "Hiekkarannantie 13",
    postalCode: "00100",
    location: { x: 60.23458, y: 24.947615 },
    n: 60.23458,
    e: 24.947561,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 59,
    rent: 708,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord169@sopia.io",
    contactPersonFirstName: "Jonne",
    contactPersonLastName: "Holmberg",
    phoneNumber: "0563879662",
    language: "Finnish, English",
    description: "A spacious two-room office designed for comfort and efficient work",
    address: "Hiekkarannantie 5",
    postalCode: "00100",
    location: { x: 60.16258, y: 24.949685 },
    n: 60.16258,
    e: 24.949568,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 51,
    rent: 612,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord170@sopia.io",
    contactPersonFirstName: "Henni",
    contactPersonLastName: "Laitakari",
    phoneNumber: "0408870705",
    language: "Finnish, English",
    description: "Vibrant & Creative Workspace\nBold color accents and unique design elements in every room inspire creativity, while maintaining a professional and polished look",
    address: "Hertanmäenkatu 4",
    postalCode: "00240",
    location: { x: 60.16577, y: 24.956905 },
    n: 60.16577,
    e: 24.956590,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [5],
    whenAvailable: new Date(1740787200000),
    size: 114,
    rent: 1368,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord170@sopia.io",
    contactPersonFirstName: "Heta",
    contactPersonLastName: "Ilves",
    phoneNumber: "0575912588",
    language: "Finnish, English",
    description: "Elegant Workspace\nA tastefully decorated office room with contemporary furnishings, providing an ideal setting for individual work or client consultations\nEfficient & Practical\nA well-organized office room, offering a productive environment with a desk, comfortable seating, and plenty of storage space.",
    address: "Kellosaarenkatu 7",
    postalCode: "00180",
    location: { x: 60.21850, y: 24.950305 },
    n: 60.21850,
    e: 24.950530,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 39,
    rent: 468,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord170@sopia.io",
    contactPersonFirstName: "Helinä",
    contactPersonLastName: "Malmivaara",
    phoneNumber: "0421294065",
    language: "Finnish, English, Swedish",
    description: "This expansive four-room office offers a seamless balance of privacy and teamwork, ideal for fostering both focus and innovation",
    address: "Kellosaarenkatu 9",
    postalCode: "00180",
    location: { x: 60.22053, y: 24.949815 },
    n: 60.22053,
    e: 24.949581,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [4],
    whenAvailable: new Date(1740787200000),
    size: 71,
    rent: 852,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord170@sopia.io",
    contactPersonFirstName: "Iida",
    contactPersonLastName: "Osmonsalo",
    phoneNumber: "0463113047",
    language: "Finnish, Swedish",
    description: "A cozy, well-lit two-room office offering privacy and productivity",
    address: "Kellosaarenranta 2",
    postalCode: "00180",
    location: { x: 60.20953, y: 24.951425 },
    n: 60.20953,
    e: 24.951542,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 48,
    rent: 576,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord171@sopia.io",
    contactPersonFirstName: "Helinä",
    contactPersonLastName: "Malmivaara",
    phoneNumber: "0573786045",
    language: "Finnish, English",
    description: "A functional two-room office that supports both individual work and group collaboration",
    address: "Kellosaarenranta 5",
    postalCode: "00180",
    location: { x: 60.21156, y: 24.949705 },
    n: 60.21156,
    e: 24.949570,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 43,
    rent: 516,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord171@sopia.io",
    contactPersonFirstName: "Jooa",
    contactPersonLastName: "Hultman",
    phoneNumber: "0514804207",
    language: "Finnish, English",
    description: "Bright and Spacious Room\nA well-lit office with large windows, providing a comfortable space for work or creative thinking, designed for maximum comfort",
    address: "Kellosaarenranta 7",
    postalCode: "00180",
    location: { x: 60.21059, y: 24.949085 },
    n: 60.21059,
    e: 24.949508,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 36,
    rent: 432,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 0,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord171@sopia.io",
    contactPersonFirstName: "Iines",
    contactPersonLastName: "Reenkola",
    phoneNumber: "0584791379",
    language: "Finnish, English",
    description: "A well-designed four-room office that blends private workspaces with areas for collaboration, optimizing productivity and creativity",
    address: "Kalevankatu 54",
    postalCode: "00180",
    location: { x: 60.22251, y: 24.959025 },
    n: 60.22251,
    e: 24.959502,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [4],
    whenAvailable: new Date(1740787200000),
    size: 105,
    rent: 2100,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord171@sopia.io",
    contactPersonFirstName: "Joel",
    contactPersonLastName: "Hoffrén",
    phoneNumber: "0506136858",
    language: "Finnish, English",
    description: "Modern 3-Room Office Suite\nA sleek office with three distinct rooms, including a private office, meeting space, and a collaborative work area",
    address: "Kalevankatu 56a",
    postalCode: "00180",
    location: { x: 60.21856, y: 24.958475 },
    n: 60.21856,
    e: 24.958547,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1740787200000),
    size: 76,
    rent: 1520,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "No wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: false,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord172@sopia.io",
    contactPersonFirstName: "Hillevi",
    contactPersonLastName: "Salmenoja",
    phoneNumber: "0590007683",
    language: "Finnish, Swedish",
    description: "Bright & Inviting Space\nNatural light floods through large windows, illuminating the contemporary furnishings in each of the three rooms, creating an open, airy feel",
    address: "Kalevankatu 57",
    postalCode: "00180",
    location: { x: 60.22851, y: 24.958975 },
    n: 60.22851,
    e: 24.958597,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1740787200000),
    size: 87,
    rent: 1740,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord172@sopia.io",
    contactPersonFirstName: "Emma",
    contactPersonLastName: "Kalima",
    phoneNumber: "0530412961",
    language: "Finnish, Swedish",
    description: "Tailored for Productivity\nA 3-room office designed with productivity in mind, featuring a quiet workspace, meeting room, and a collaborative area",
    address: "Lahnalahdentie 1",
    postalCode: "00200",
    location: { x: 60.22357, y: 24.927615 },
    n: 60.22357,
    e: 24.927561,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1740787200000),
    size: 95,
    rent: 1900,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: false,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord172@sopia.io",
    contactPersonFirstName: "Heljä",
    contactPersonLastName: "Mela",
    phoneNumber: "0463937731",
    language: "Finnish, English",
    description: "A cozy, well-lit two-room office offering privacy and productivity",
    address: "Lahnalahdentie 4",
    postalCode: "00200",
    location: { x: 60.23450, y: 24.925855 },
    n: 60.23450,
    e: 24.925585,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 56,
    rent: 1120,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord172@sopia.io",
    contactPersonFirstName: "Elviira",
    contactPersonLastName: "Lahdensuo",
    phoneNumber: "0406567494",
    language: "Finnish, English",
    description: "A spacious two-room office designed for comfort and efficient work",
    address: "Lahnaruohontie 1",
    postalCode: "00200",
    location: { x: 60.18058, y: 24.929515 },
    n: 60.18058,
    e: 24.929551,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 59,
    rent: 1180,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord173@sopia.io",
    contactPersonFirstName: "Elna",
    contactPersonLastName: "Kataja",
    phoneNumber: "0547332841",
    language: "Finnish, English",
    description: "Creative Work Environment\nA flexible office room that fosters creativity, with stylish furniture and a layout designed for both individual and collaborative tasks",
    address: "Lahnaruohontie 2",
    postalCode: "00200",
    location: { x: 60.18559, y: 24.928955 },
    n: 60.18559,
    e: 24.928595,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 25,
    rent: 500,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["MIDDLE"],
    elevator: false,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord173@sopia.io",
    contactPersonFirstName: "Jouni",
    contactPersonLastName: "Jansson",
    phoneNumber: "0523596430",
    language: "Finnish, Swedish",
    description: "Cozy Office Corner\nA compact yet functional office room, offering a cozy environment to concentrate and meet with clients in a professional setting",
    address: "Lahnaruohontie 4",
    postalCode: "00200",
    location: { x: 60.18957, y: 24.928975 },
    n: 60.18957,
    e: 24.928597,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 43,
    rent: 860,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "No lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord173@sopia.io",
    contactPersonFirstName: "Iiris",
    contactPersonLastName: "Sotavalta",
    phoneNumber: "0509784364",
    language: "Finnish, English",
    description: "Professional and Quiet\nA quiet, private office ideal for uninterrupted work, with sleek furniture and a minimalist design for a clear mind",
    address: "Lahnaruohontie 6",
    postalCode: "00200",
    location: { x: 60.19454, y: 24.929075 },
    n: 60.19454,
    e: 24.929507,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 34,
    rent: 680,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord173@sopia.io",
    contactPersonFirstName: "Helmi",
    contactPersonLastName: "Nuorpuu",
    phoneNumber: "0404872910",
    language: "Finnish, English",
    description: "A flexible two-room office with plenty of room for meetings and personal work",
    address: "Lahnaruohontie 8",
    postalCode: "00200",
    location: { x: 60.20053, y: 24.929165 },
    n: 60.20053,
    e: 24.929516,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 49,
    rent: 980,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord174@sopia.io",
    contactPersonFirstName: "Helena",
    contactPersonLastName: "Louhivuori",
    phoneNumber: "0519337235",
    language: "Finnish, English",
    description: "Vibrant & Creative Workspace\nBold color accents and unique design elements in every room inspire creativity, while maintaining a professional and polished look",
    address: "Lastenkodin kuja 3",
    postalCode: "00180",
    location: { x: 60.16456, y: 24.958935 },
    n: 60.16456,
    e: 24.958593,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1740787200000),
    size: 74,
    rent: 888,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: false,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord174@sopia.io",
    contactPersonFirstName: "Elsa",
    contactPersonLastName: "Kurki-Suonio",
    phoneNumber: "0575823950",
    language: "Finnish, English",
    description: "A two-room office with stylish decor, ideal for professionals and teams",
    address: "Lastenkodinkatu 11",
    postalCode: "00180",
    location: { x: 60.16157, y: 24.957735 },
    n: 60.16157,
    e: 24.957573,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 56,
    rent: 672,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: false,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord174@sopia.io",
    contactPersonFirstName: "Hannele",
    contactPersonLastName: "Merikoski",
    phoneNumber: "0575199303",
    language: "Finnish, English",
    description: "A spacious two-room office designed for comfort and efficient work",
    address: "Maamonlahdentie 3",
    postalCode: "00200",
    location: { x: 60.25551, y: 24.933095 },
    n: 60.25551,
    e: 24.933509,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 44,
    rent: 528,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: false,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord174@sopia.io",
    contactPersonFirstName: "Joosef",
    contactPersonLastName: "Hästesko",
    phoneNumber: "0508233501",
    language: "Finnish, English",
    description: "A spacious five-room office, perfectly balancing private areas and collaborative spaces, crafted to elevate productivity and creativity",
    address: "Mannerheimintie 19a",
    postalCode: "00250",
    location: { x: 60.16053, y: 24.957875 },
    n: 60.16053,
    e: 24.957587,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [5],
    whenAvailable: new Date(1740787200000),
    size: 162,
    rent: 1944,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Excellent",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord175@sopia.io",
    contactPersonFirstName: "Emma",
    contactPersonLastName: "Kalima",
    phoneNumber: "0424696838",
    language: "Finnish, English",
    description: "A cozy, well-lit two-room office offering privacy and productivity",
    address: "Mannerheimintie 20",
    postalCode: "00100",
    location: { x: 60.19256, y: 24.965735 },
    n: 60.19256,
    e: 24.965573,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 54,
    rent: 648,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: false,
    propertyCondition: "Excellent",
    view: "View",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord175@sopia.io",
    contactPersonFirstName: "Elviira",
    contactPersonLastName: "Lahdensuo",
    phoneNumber: "0582328370",
    language: "Finnish, English",
    description: "A roomy four-room office combining privacy and collaborative spaces, designed to boost productivity and creativity in a professional environment",
    address: "Nousiaistentie 2",
    postalCode: "00280",
    location: { x: 60.16284, y: 24.947465 },
    n: 60.16284,
    e: 24.947546,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [4],
    whenAvailable: new Date(1740787200000),
    size: 103,
    rent: 1236,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord175@sopia.io",
    contactPersonFirstName: "Iines",
    contactPersonLastName: "Reenkola",
    phoneNumber: "0411003769",
    language: "Finnish, English",
    description: "Well-Equipped Office\nThree fully-equipped rooms with modern amenities, creating an ideal setting for work, meetings, and brainstorming sessions",
    address: "Nousiaistentie 4",
    postalCode: "00280",
    location: { x: 60.16285, y: 24.947905 },
    n: 60.16285,
    e: 24.947590,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1740787200000),
    size: 86,
    rent: 1032,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord175@sopia.io",
    contactPersonFirstName: "Hille",
    contactPersonLastName: "Suolahti",
    phoneNumber: "0421502168",
    language: "Finnish, English, Swedish",
    description: "Compact & Professional\nA compact office with three rooms, perfect for small teams needing a private, yet collaborative space to work and meet",
    address: "Nousiaistentie 6",
    postalCode: "00280",
    location: { x: 60.16285, y: 24.948335 },
    n: 60.16285,
    e: 24.948533,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [3],
    whenAvailable: new Date(1740787200000),
    size: 97,
    rent: 1164,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: true,
    wc: ["PRIVATE"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["TOP"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord176@sopia.io",
    contactPersonFirstName: "Jalmari",
    contactPersonLastName: "Helander",
    phoneNumber: "0489979975",
    language: "Finnish, Swedish",
    description: "Bright and Spacious Room\nA well-lit office with large windows, providing a comfortable space for work or creative thinking, designed for maximum comfort",
    address: "Nousiaistentie 8",
    postalCode: "00280",
    location: { x: 60.16285, y: 24.948805 },
    n: 60.16285,
    e: 24.948580,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [1],
    whenAvailable: new Date(1740787200000),
    size: 35,
    rent: 420,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: ["STREET"],
    parkingPlaceAmount: 3,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["BOTTOM"],
    elevator: true,
    propertyCondition: "Good",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  },
  {
    company: "Yksityishenkilö",
    email: "landlord176@sopia.io",
    contactPersonFirstName: "Jarmo",
    contactPersonLastName: "Helenius",
    phoneNumber: "0513540744",
    language: "Finnish, English",
    description: "A flexible two-room office with plenty of room for meetings and personal work",
    address: "Oikokatu 3",
    postalCode: "00170",
    location: { x: 60.25055, y: 24.974675 },
    n: 60.25055,
    e: 24.974567,
    city: "Helsinki",
    residenceType: ["OFFICE"],
    rooms: [2],
    whenAvailable: new Date(1740787200000),
    size: 54,
    rent: 648,
    rentPeriodMin: "12 months",
    rentPeriodMax: "No",
    publicTransport: null,
    parking: undefined,
    parkingPlaceAmount: 0,
    furnished: "Unfurnished",
    wifiIncluded: "Wifi",
    meetingRoom: false,
    wc: ["SHARED"],
    kitchen: ["OWN"],
    lobbyService: "Lobby service",
    floor: ["MIDDLE"],
    elevator: false,
    propertyCondition: "Satisfying",
    view: "No view",
    deposit: 1000,
    nearGreenArea: "No",
    nearLunch: "Yes",
    isLandlord: true,
  }
]

const mockData = { tenants: mockDataUsers, announcements: mockDataAnnouncements }

export default mockData;